/* eslint-disable arrow-body-style */
// all the app's backend requests: the C# asmx api (constConfig.url.API_URL)
// and back_app (back_app_url, src/back/app/bs.js)
import { parseString } from 'xml2js';
import { dispatch } from 'store';
import { openGeneralAlertSnackbar } from 'store/slices/snackbar';
import { back_app_url, constConfig, is_bs_app } from 'Constants';
import helper from 'utils/helper';
import { FeatureFlags } from 'types/user-profile';
import { SelectOption } from 'ui-component/extended/Form/CustomControlledSelect';
import { FileType } from 'ui-component/extended/Form/CustomFileUpload';
import { EmailAttachment, NotificationTypeEnum } from 'ui-component/extended/MailtoComposer';
import { MediaProviderFeesObj, ProviderTypeEnum } from 'views/application/accounts/types';
import { ActivityStatusEnum } from 'views/application/activities/types';
import { aiAnalyticsFilters } from 'views/application/aiAnalytics';
import { OutputTypeEnum, PromptTypeEnum } from 'views/application/aiAnalytics/types';
import { CampaignCategoryEnum, ChannelType, PayerTypeEnum } from 'views/application/campaigns/types';
import { AnalyticsAssetItem } from 'views/application/mediaMixes/googleAnalytics/type';
import { BanchMarks } from 'views/application/mediaMixes/statInsights/StatisticInsightsTooltip';
import { MediaMixApprovalStatusEnum } from 'views/application/mediaMixes/types';
import { UserNotifications } from 'views/application/usersiot/useredit/UserNotificationSubscriptionsSettings';
import { ClientReply } from 'views/pages/external/approval/MediaPlanApprovalCont';

export const getCurrentAccountId = (pathname:string,main_only:boolean) => {
    const path_parts = pathname.split('/').filter((p)=> p.trim().length > 0);

        const is_accounts = path_parts.length > 0 && path_parts[0].toLowerCase() === 'accounts';
            
        if (is_accounts) {
            if(helper.isInteger(path_parts[1])){
                const account_id = helper.getNumeric(path_parts[1]);
                if(account_id > 0){

                    if(!main_only){
                        // check if sub account
                        const is_sub_accounts = path_parts.length > 2 && path_parts[2].toLowerCase() === 'subaccounts';
                        if (is_sub_accounts) {
                            if(helper.isInteger(path_parts[3])){
                                const sub_account_id = helper.getNumeric(path_parts[3]);
                                if(sub_account_id > 0){
                                    return sub_account_id;
                                }
                            }
                        }
                    }
                    return account_id;
                }
            }
        }
        return undefined;
}

export const fetchRequest = async (url: string, method: string, data: any,isJson?:boolean,file?:File,) => {
   //  const { CurrentAccount } = useGlobal(); 
   // const gcntx = useContext(GlobalContext);   
    const currentAccountId = getCurrentAccountId(window.location.pathname,false);
    const serviceToken = window.localStorage.getItem('serviceToken');
    const serviceLocalToken = window.localStorage.getItem('serviceLocalToken');
    const token = serviceLocalToken ? serviceLocalToken?.toString() : '';
    const AWSToken = serviceToken ? serviceToken?.toString() : '';

    let headersObj:HeadersInit | undefined  = {
        Accept: 'application/json',
        'Content-type': isJson ? 'application/json; charset=utf-8' : 'application/x-www-form-urlencoded; charset=UTF-8',
        'Auth-Token': token,
        'Aws-Token': AWSToken,
        'Request-Account-Id': currentAccountId?.toString() || ''
    };
    
    const formData = new FormData();
    if(file) {
        formData.append('file', file); // video file
        if(isJson){
            formData.append('data', data);
        }else{
            const data_obj = Object.fromEntries(new URLSearchParams(data));
            formData.append('data', JSON.stringify(data_obj)); // key-val string
        }
        headersObj = {
            Accept: 'application/json',
            'Auth-Token': token,
            'Aws-Token': AWSToken,
            'Request-Account-Id': currentAccountId?.toString() || ''
        };
    }
    return new Promise((resolve, reject) => {
        fetch(url, {
            method: method || 'GET',
            credentials: 'include', // 'same-origin',
            body: file ? formData : data,
            headers: headersObj
        })
            .then((response) => {
                
                if (response.ok) {
                    if(isJson){
                        let parsed_result = '';
                        response.text().then((res_text)=>{
                            parsed_result = parseAsmxResponseText(res_text);
                            resolve(parsed_result);
                        })
                        
                        
                    }else{
                        resolve(response.text());
                    }
                } else {
                    
                    if (response.status == 401) {
                        console.error(response);
                        localStorage.removeItem('serviceLocalToken');
                        // const navigate = useNavigate();
                        // navigate('/login');
                        window.open('/login', '_self');
                        return;
                    }
                    if (response.status == 403) {
                        // forbidden
                        dispatch(openGeneralAlertSnackbar({
                            success: false,
                            isDelete: false,
                            message:'requered permission missing'
                        }));
                        return;
                    }
                    // crashSendLog("fetchRequest Error " , response.statusText , "url : " + url + " || data : " + data);

                    // handle errors in the way you want to
                    /* switch (response.status) {
            case 404:
              console.log('Object not found');
              break;
            case 500:
              console.log('Internal server error');
              break;
            default:
              console.log('Some error occured');
              break;
          } */
                    response.text().then((err_msg:any) =>{
                        console.error(response.url,"Status:", response.status,"error:", err_msg);
                    }); 
          
                    reject(response);
                }
            })
            .catch((error) => {
                console.log(error);
                crashSendLog('fetchRequest catch Error ', error, `url : ${url} || data : ${data}`);
                reject(error);
            });
    });
};
// back_app (src/back/app/bs.js): POSTs params as json, resolves its json
// reply ({err} on failure). 401/403 as fetchRequest. No credentials: its
// cors() answers '*'
export const fetch_app = async (path: string, params: any) => {
    const account_id = getCurrentAccountId(window.location.pathname, false);
    const response = await fetch(back_app_url + path, {
        method: 'POST',
        credentials: 'omit',
        headers: {Accept: 'application/json', 'Content-Type': 'application/json',
            'Auth-Token': window.localStorage.getItem('serviceLocalToken') || '',
            'Aws-Token': window.localStorage.getItem('serviceToken') || '',
            'Request-Account-Id': account_id?.toString() || ''},
        body: JSON.stringify(params || {})
    });
    if (response.status == 401) {
        localStorage.removeItem('serviceLocalToken');
        window.open('/login', '_self');
        return {err: 'unauthorized'};
    }
    if (response.status == 403) {
        dispatch(openGeneralAlertSnackbar({success: false, isDelete: false,
            message: 'requered permission missing'}));
        return {err: 'forbidden'};
    }
    if (!response.ok)
        throw new Error(`${path} failed: ${response.status}`);
    return response.json();
};
export const fetchSecureBlob = async (url: string): Promise<Blob> => {
    const serviceToken = window.localStorage.getItem('serviceToken');
    const serviceLocalToken = window.localStorage.getItem('serviceLocalToken');

    const token = serviceLocalToken || '';
    const AWSToken = serviceToken || '';

    const response = await fetch(url, {
        method: 'GET',
        headers: {
            'Auth-Token': token,
            'Aws-Token': AWSToken,
        },
    });

    if (!response.ok) {
        throw new Error(`Request failed: ${response.status}`);
    }

    return response.blob();
};
export const downloadSecureFile = async (download_url: string,file_name:string) => {

    try {
        const blob = await fetchSecureBlob(download_url);
        const blobUrl = window.URL.createObjectURL(blob);


        const a = document.createElement('a');
        a.href = blobUrl;
        a.download = file_name || 'presentation.pptx';

        document.body.appendChild(a);
        a.click();
        a.remove();

        window.URL.revokeObjectURL(blobUrl);
    }
    catch (ex) {
        console.error('Download failed', ex);
    }
};

export const parseAsmxResponseText = (responseText: string) => {
    if (!responseText) {
        return null;
    }

    // Case 1/2:
    // JSON object
    // ASMX JSON wrapper: { d: ... }
    try {
        const json = JSON.parse(responseText);
        const result = json.d ?? json;

        return typeof result === 'string'
            ? JSON.parse(result)
            : result;
    } catch {
        // Continue to XML parsing
    }

    // Case 3:
    // ASMX XML wrapper: <string>{"Success":true}</string>
    const xml = new DOMParser().parseFromString(responseText, 'text/xml');

    const parserError = xml.getElementsByTagName('parsererror')[0];

    if (parserError) {
        throw new Error('Response is not valid JSON or XML.');
    }

    const stringNode = xml.getElementsByTagName('string')[0];

    if (!stringNode || !stringNode.textContent) {
        throw new Error('XML response does not contain <string> value.');
    }

    return JSON.parse(stringNode.textContent);
};

export type ClientResponse={
  Success:boolean;
     ErrorMessage : string;
     Response:string;
     ErrorFields: ErrorField[];
};
export type ErrorField = { 
    FieldName:string;
    ErrorMessage:string;
}

export const crashSendLog = async (error: string, info: string, componentStack: string) => {
    if (is_bs_app) {
        return fetch_app('/pub/crash/send.json', {err: error, info,
            stack: componentStack}).catch((err) => console.log(err));
    }
    // XXX colin: remove the asmx path once back_app is on prod
    const serviceToken = window.localStorage.getItem('serviceToken');
    const serviceLocalToken = window.localStorage.getItem('serviceLocalToken');
    const token = serviceLocalToken ? serviceLocalToken?.toString() : '';
    const AWSToken = serviceToken ? serviceToken?.toString() : '';

    const data = new URLSearchParams({
        Error: error,
        Info: info,
        ComponentStack: componentStack
    }).toString();

    return new Promise((resolve) => {
        fetch(`${constConfig.url.API_URL}/WebServices/MainService.asmx/CrashSend`, {
            method: 'POST',
            body: data,
            headers: {
                Accept: 'application/json',
                'Content-type': 'application/x-www-form-urlencoded; charset=UTF-8',
                'Auth-Token': token,
                'Aws-Token': AWSToken
            }
        })
            .then((response) => {
                if (response.ok) {
                    console.log('Crash Send Log OK');
                }
            })

            .catch((err) => {
                console.log(err);
            });
    });
};

// the asmx api's secure files (by Auth-Token, see fetchSecureBlob)
export const file_url_get = (file_id?: string | number) =>
    `${constConfig.url.API_URL}/api/file_handler?file_id=${file_id}`;
export const AuthApi = {
    // resolves the C# LogInByAws UserCls, rejects with an Error
    logInByAws: (jwt_token: string, email: string): Promise<any> => {
        if (is_bs_app) {
            return fetch_app('/pub/user/login_aws.json', {jwt_token, email})
                .then((res: any) => {
                    if (res.err)
                        throw new Error(res.err);
                    const u = res.user;
                    return {Token: u.token, Name: u.lbl, Permissions: u.perms,
                        IsSystemAdmin: u.is_system_admin, IsDeveloper: u.is_developer,
                        Company: {Name: u.company.lbl, Logo: u.company.logo},
                        Features: u.features};
                });
        }
        // XXX colin: remove the asmx path once back_app is on prod
        const data = new URLSearchParams({
            JwtToken: jwt_token,
            Email: email
        }).toString();
        return fetchRequest(`${constConfig.url.API_URL}/WebServices/AuthService.asmx/LogInByAws`, 'post', data)
            .then((response: any) => new Promise((resolve, reject) => {
                parseString(response, (err: any, result: any) => {
                    if (!result)
                        return;
                    const res = JSON.parse(result.string._);
                    if (res.Success && res.Response) {
                        resolve(JSON.parse(res.Response));
                        return;
                    }
                    console.error('Error during LogInByAws ErrorMessage:', res.ErrorMessage);
                    reject(new Error('Error during LogInByAws ErrorMessage'));
                });
            }));
    }
};

const accounts_path = '/WebServices/AccountsService.asmx';

export const AccountsApi = {
    getAccountsList: (from_date:string,to_date:string,activityStatus?: ActivityStatusEnum,mainAccountId?:number) => {
        return new Promise((resolve) => {
            fetchRequest(
                `${constConfig.url.API_URL + accounts_path}/GetAccountsList`,
                'post',
                new URLSearchParams({mainAccountId: mainAccountId?.toString() || '-1',
                fromDate:from_date,
                toDate:to_date,
                activityStatus: activityStatus != undefined ? activityStatus.toString() : '-1'}).toString()
            )
                .then((response: any) => {
                    parseString(response, (err: any, result: any) => {
                        if (result) {
                            const res = JSON.parse(result.string._);

                            if (res.Success) {
                                if (res.Response) {
                                    const responseData = JSON.parse(res.Response);
                                    resolve(responseData);
                                }
                            } else {
                                console.error('Error during getAccountsList ErrorMessage:', res.ErrorMessage);
                            }
                        }
                    });
                })

                .catch((err) => {
                    resolve(null);
                    console.log('getAccountsList failed!!!');
                });
        });
    },
    getMainAccount: (id: any) => {
        return new Promise((resolve) => {
            fetchRequest(
                `${constConfig.url.API_URL + accounts_path}/GetMainAccount`,
                'post',
                new URLSearchParams({ accountId: id }).toString()
            )
                .then((response: any) => {
                    parseString(response, (err: any, result: any) => {
                        if (result) {
                            const res = JSON.parse(result.string._);

                            if (res.Success) {
                                if (res.Response) {
                                    const responseData = JSON.parse(res.Response);
                                    resolve(responseData);
                                }
                            } else {
                                console.error('Error during GetMainAccount ErrorMessage:', res.ErrorMessage);
                            }
                        }
                    });
                })

                .catch((err) => {
                    resolve(null);
                    console.log('GetMainAccount failed!!!', err);
                });
        });
    },
    getAccountInfo: (id: any) => {
        return new Promise((resolve) => {
            fetchRequest(
                `${constConfig.url.API_URL + accounts_path}/GetAccountInfo`,
                'post',
                new URLSearchParams({ accountId: id }).toString()
            )
                .then((response: any) => {
                    parseString(response, (err: any, result: any) => {
                        if (result) {
                            const res = JSON.parse(result.string._);

                            if (res.Success) {
                                if (res.Response) {
                                    const responseData = JSON.parse(res.Response);
                                    resolve(responseData);
                                }
                            } else {
                                console.error('Error during getAccountInfo ErrorMessage:', res.ErrorMessage);
                            }
                        }
                    });
                })

                .catch((err) => {
                    resolve(null);
                    console.log('getAccountInfo failed!!!', err);
                });
        });
    },

    saveAccount: (account: any,applayVATToSubAccounts:boolean) => {

        return new Promise((resolve,reject) => {
            fetchRequest(
                `${constConfig.url.API_URL + accounts_path}/${account.ID > 0 ?'UpdateAccount' : 'CreateAccount'}`,
                'post',
                // new URLSearchParams({ account: JSON.stringify(account),
                //     applayVATToSubAccounts: applayVATToSubAccounts.toString() }).toString()
                JSON.stringify({ 
                    account: JSON.stringify(account),
                    applayVATToSubAccounts: applayVATToSubAccounts.toString() 
                }),
                true // send json i.o. urlencoded
            )
                .then((res: any) => {
                    if (res.Success) {
                        if (res.Response) {
                            const responseData = JSON.parse(res.Response);
                            resolve(responseData);
                        }
                    } else {
                        console.error('Error during saveAccount ErrorMessage:', res.ErrorMessage);
                        reject(new Error(res.ErrorMessage));
                    }
                })
                .catch((err) => {
                    reject(err);
                    console.log('saveAccount failed!!!', err);
                });
        });
    },

    deleteAccount: (id: any) => {
        return new Promise((resolve,reject) => {
            fetchRequest(
                `${constConfig.url.API_URL + accounts_path}/DeleteAccount`,
                'post',
                new URLSearchParams({ accountId: id }).toString()
            )
                .then((response: any) => {
                    parseString(response, (err: any, result: any) => {
                        if (result) {
                            const res = JSON.parse(result.string._);

                            if (res.Success) {
                                if (res.Response) {
                                    const responseData = JSON.parse(res.Response);
                                    resolve(responseData);
                                }
                            } else {
                                console.error('Error during deleteAccount ErrorMessage:', res.ErrorMessage);
                                reject(new Error(res.ErrorMessage));
                            }
                        }
                    });
                })

                .catch((err) => {
                     reject(err);
                    console.log('deleteAccount failed!!!', err);
                });
        });
    },

    // activity transfer (AccountsService SubAccountsCreate, MainAccountMake,
    // MainAccountMakePreview, ActivitiesMove): the parsed Response, or a
    // rejected Error(ErrorMessage)
    transfer_req: (method: string, params: any) => new Promise<any>((resolve, reject) => {
        fetchRequest(`${constConfig.url.API_URL + accounts_path}/${method}`, 'post',
            JSON.stringify(params), true)
            .then((res: any) => {
                if (!res.Success)
                    return reject(new Error(res.ErrorMessage));
                resolve(res.Response ? JSON.parse(res.Response) : {});
            })
            .catch(reject);
    }),
    sub_accounts_create: (account_id: number, subs: {Name: string, ActivityIds: number[]}[]) =>
        AccountsApi.transfer_req('SubAccountsCreate', {accountId: account_id,
            subs: JSON.stringify(subs)}),
    main_account_make_preview: (account_id: number) =>
        AccountsApi.transfer_req('MainAccountMakePreview', {accountId: account_id}),
    main_account_make: (account_id: number, name: string) =>
        AccountsApi.transfer_req('MainAccountMake', {accountId: account_id, name}),
    activities_move: (activity_ids: number[], target_account_id: number) =>
        AccountsApi.transfer_req('ActivitiesMove', {
            activityIds: JSON.stringify(activity_ids),
            targetAccountId: target_account_id}),
    ChannelTypes: {
        initAccountChannelTypes : (reload:boolean) => {
            return new Promise((resolve) => {
                fetchRequest(
                    `${constConfig.url.API_URL + accounts_path}/InitAccountChannelTypes`,
                    'post',
                    new URLSearchParams({reload: reload.toString()}).toString()
                )
                    .then((response: any) => {
                        parseString(response, (err: any, result: any) => {
                            if (result) {
                                const res = JSON.parse(result.string._);
    
                                if (res.Success) {
                                    if (res.Response) {
                                        const responseData = JSON.parse(res.Response);
                                        resolve(responseData);
                                    }
                                } else {
                                    console.error('Error during initAccountChannelTypes ErrorMessage:', res.ErrorMessage);
                                }
                            }
                        });
                    })
    
                    .catch((err) => {
                        resolve(null);
                        console.log('initAccountChannelTypes failed!!!');
                    });
            });
        },
        getMediaChannelInfo: (id:number) => {
            return new Promise((resolve) => {
                fetchRequest(
                    `${constConfig.url.API_URL + accounts_path}/GetMediaChannelInfo`,
                    'post',
                    new URLSearchParams({channelId:id.toString()}).toString()
                )
                    .then((response: any) => {
                        parseString(response, (err: any, result: any) => {
                            if (result) {
                                const res = JSON.parse(result.string._);
    
                                if (res.Success) {
                                    if (res.Response) {
                                        const responseData = JSON.parse(res.Response);
                                        resolve(responseData);
                                    }
                                } else {
                                    console.error('Error during getMediaChannelInfo ErrorMessage:', res.ErrorMessage);
                                }
                            }
                        });
                    })
    
                    .catch((err) => {
                        resolve(null);
                        console.log('getMediaChannelInfo failed!!!');
                    });
            });
        },
        saveMediaChannel: (item:ChannelType) => {
            return new Promise((resolve,reject) => {
                fetchRequest(
                    `${constConfig.url.API_URL + accounts_path}/SaveMediaChannel`,
                    'post',
                    new URLSearchParams({ 
                        mediaChannel:JSON.stringify(item),
                     }).toString()
                )
                    .then((response: any) => {
                       // console.log(response);
                        parseString(response, (err: any, result: any) => {
                            if (result) {
                                const res = JSON.parse(result.string._);
    
                                if (res.Success) {
                                    const responseData = JSON.parse(res.Response);
                                    resolve(responseData);
                                  
                                } else {
                                    console.error('Error during saveMediaChannel ErrorMessage:', res.ErrorMessage);
                                    reject(new Error(res.ErrorMessage));
                                }
                            }
                        });
                    })
                    .catch((err) => {
                        reject(err);
                        console.log('saveMediaChannel failed!!!', err);
                    });
            });
        },
        deleteMediaChannel: (id:number) => {
            return new Promise((resolve) => {
                fetchRequest(
                    `${constConfig.url.API_URL + accounts_path}/DeleteMediaChannel`,
                    'post',
                    new URLSearchParams({channelId:id.toString()}).toString()
                )
                    .then((response: any) => {
                        parseString(response, (err: any, result: any) => {
                            if (result) {
                                const res = JSON.parse(result.string._);
    
                                if (res.Success) {
                                    resolve(true);
                                } else {
                                    if (res.Response) {
                                        const responseData = JSON.parse(res.Response);
                                        resolve(responseData);
                                    }
                                    console.error('Error during deleteMediaChannel ErrorMessage:', res.ErrorMessage);
                                }
                            }
                        });
                    })
    
                    .catch((err) => {
                        resolve(null);
                        console.log('deleteMediaChannel failed!!!');
                    });
            });
        },
        getCustomCampaignInfo: (id:number) => {
            return new Promise((resolve) => {
                fetchRequest(
                    `${constConfig.url.API_URL + accounts_path}/GetCustomCampaignInfo`,
                    'post',
                    new URLSearchParams({campaignId:id.toString()}).toString()
                )
                    .then((response: any) => {
                        parseString(response, (err: any, result: any) => {
                            if (result) {
                                const res = JSON.parse(result.string._);
    
                                if (res.Success) {
                                    if (res.Response) {
                                        const responseData = JSON.parse(res.Response);
                                        resolve(responseData);
                                    }
                                } else {
                                    console.error('Error during getCustomCampaignInfo ErrorMessage:', res.ErrorMessage);
                                }
                            }
                        });
                    })
    
                    .catch((err) => {
                        resolve(null);
                        console.log('getCustomCampaignInfo failed!!!');
                    });
            });
        },
        saveCustomCampaign: (channelId:number,item:any) => {
            return new Promise((resolve) => {
                fetchRequest(
                    `${constConfig.url.API_URL + accounts_path}/SaveCustomCampaign`,
                    'post',
                    new URLSearchParams({ 
                        channelId:channelId.toString(),
                        campaign:JSON.stringify(item),
                     }).toString()
                )
                    .then((response: any) => {
                       // console.log(response);
                        parseString(response, (err: any, result: any) => {
                            if (result) {
                                const res = JSON.parse(result.string._);
    
                                if (res.Success) {
                                    const responseData = JSON.parse(res.Response);
                                    resolve(responseData);
                                  
                                } else {
                                    console.error('Error during saveCustomCampaign ErrorMessage:', res.ErrorMessage);
                                    resolve(res);
                                }
                            }
                        });
                    })
                    .catch((err) => {
                        resolve(null);
                        console.log('saveCustomCampaign failed!!!', err);
                    });
            });
        },
        updateChannelTypesField : (id:number, field_name:string, field_value:string ) => { // fields: {field_name:string, field_value:string}[]) => {
            return new Promise((resolve) => {
                fetchRequest(
                    `${constConfig.url.API_URL + accounts_path}/UpdateChannelTypesField`,
                    'post',
                    new URLSearchParams({ 
                        Id: id.toString(),
                        field_name,field_value
                        // fields:JSON.stringify(fields),
                     }).toString()
                )
                    .then((response: any) => {
                       // console.log(response);
                        parseString(response, (err: any, result: any) => {
                            if (result) {
                                const res = JSON.parse(result.string._);
    
                                if (res.Success) {
                                    const responseData = JSON.parse(res.Response);
                                    resolve(responseData);
                                  
                                } else {
                                    console.error('Error during updateChannelTypesField ErrorMessage:', res.ErrorMessage);
                                    resolve(res);
                                }
                            }
                        });
                    })
                    .catch((err) => {
                        resolve(null);
                        console.log('updateChannelTypesField failed!!!', err);
                    });
            });
        },
        saveAccountChannelField: (ids:number[], fieldName:string,fieldValue:string ) => { 
            return new Promise((resolve) => {
                fetchRequest(
                    `${constConfig.url.API_URL + accounts_path}/SaveAccountChannelField`,
                    'post',
                    new URLSearchParams({ 
                        ids: JSON.stringify(ids),
                        fieldName,
                        fieldValue
                     }).toString()
                ).then((response: any) => {
                        parseString(response, (err: any, result: any) => {
                            if (result) {
                                const res = JSON.parse(result.string._);
    
                                if (res.Success) {
                                   
                                    resolve(true);
                                  
                                } else {
                                    console.error('Error during saveAccountChannelField ErrorMessage:', res.ErrorMessage);
                                    resolve(res);
                                }
                            }
                        });
                    })
                    .catch((err) => {
                        resolve(null);
                        console.log('saveAccountChannelField failed!!!', err);
                    });
            });
        },
        saveAccountManagementFee: (ids:number[], management_fee:string ) => { // fields: {field_name:string, field_value:string}[]) => {
            return new Promise((resolve) => {
                fetchRequest(
                    `${constConfig.url.API_URL + accounts_path}/SaveAccountManagementFee`,
                    'post',
                    new URLSearchParams({ 
                        ids: JSON.stringify(ids),
                        management_fee
                        // fields:JSON.stringify(fields),
                     }).toString()
                )
                    .then((response: any) => {
                       // console.log(response);
                        parseString(response, (err: any, result: any) => {
                            if (result) {
                                const res = JSON.parse(result.string._);
    
                                if (res.Success) {
                                   
                                    resolve(true);
                                  
                                } else {
                                    console.error('Error during updateChannelTypesField ErrorMessage:', res.ErrorMessage);
                                    resolve(res);
                                }
                            }
                        });
                    })
                    .catch((err) => {
                        resolve(null);
                        console.log('updateChannelTypesField failed!!!', err);
                    });
            });
        },
        saveAccountSystemFee: (ids:number[], system_fee:string ) => { 
            return new Promise((resolve) => {
                fetchRequest(
                    `${constConfig.url.API_URL + accounts_path}/SaveAccountSystemFee`,
                    'post',
                    new URLSearchParams({ 
                        ids: JSON.stringify(ids),
                        system_fee
                        // fields:JSON.stringify(fields),
                     }).toString()
                ).then((response: any) => {
                        parseString(response, (err: any, result: any) => {
                            if (result) {
                                const res = JSON.parse(result.string._);
    
                                if (res.Success) {
                                   
                                    resolve(true);
                                  
                                } else {
                                    console.error('Error during saveAccountSystemFee ErrorMessage:', res.ErrorMessage);
                                    resolve(res);
                                }
                            }
                        });
                    })
                    .catch((err) => {
                        resolve(null);
                        console.log('saveAccountSystemFee failed!!!', err);
                    });
            });
        },
        getChannelTypeAccounts: (globalChannelTypeId: number) => {
            return new Promise((resolve,reject) => {
            fetchRequest(
                `${constConfig.url.API_URL + accounts_path}/GetChannelTypeAccounts`,
                'post',
                JSON.stringify({ globalChannelTypeId }),
                true // send json i.o. urlencoded
            )
                .then((res: any) => {
                    if (res.Success) {
                        if (res.Response) {
                            const responseData = JSON.parse(res.Response);
                            resolve(responseData);
                        }
                    } else {
                        console.error('Error during getChannelTypeAccounts ErrorMessage:', res.ErrorMessage);
                        reject(new Error(res.ErrorMessage));
                    }

                })
                .catch((err) => {
                    reject(err);
                    console.log('getChannelTypeAccounts failed!!!', err);
                });
        });
        }
    },
    MediaProviderFees: {
        initAccountMediaProviderFees : () => {
            return new Promise((resolve,reject) => {
                fetchRequest(
                    `${constConfig.url.API_URL + accounts_path}/InitAccountMediaProviderFees`,
                    'post',
                    new URLSearchParams({}).toString()
                )
                    .then((response: any) => {
                        parseString(response, (err: any, result: any) => {
                            if (result) {
                                const res = JSON.parse(result.string._);
    
                                if (res.Success) {
                                    if (res.Response) {
                                        const responseData = JSON.parse(res.Response);
                                        resolve(responseData);
                                    }
                                } else {
                                    console.error('Error during initAccountMediaProviderFees ErrorMessage:', res.ErrorMessage);
                                    reject(new Error(res.ErrorMessage));
                                }
                            }
                        });
                    })
    
                    .catch((err) => {
                        reject(err);
                        console.log('initAccountMediaProviderFees failed!!!');
                    });
            });
        },
        updateMediaProviderFeeField : (providerType:ProviderTypeEnum, field_name:string, field_value:string ) => { 
            return new Promise((resolve,reject) => {
                fetchRequest(
                    `${constConfig.url.API_URL + accounts_path}/UpdateMediaProviderFeeField`,
                    'post',
                    new URLSearchParams({ 
                        providerType: providerType.toString(),
                        field_name,field_value
                        // fields:JSON.stringify(fields),
                     }).toString()
                )
                    .then((response: any) => {
                       // console.log(response);
                        parseString(response, (err: any, result: any) => {
                            if (result) {
                                const res = JSON.parse(result.string._);
    
                                if (res.Success) {
                                    
                                    resolve(true);
                                  
                                } else {
                                    console.error('Error during updateMediaProviderFeeField ErrorMessage:', res.ErrorMessage);
                                    reject(new Error(res.ErrorMessage));
                                }
                            }
                        });
                    })
                    .catch((err) => {
                        reject(err);
                        console.log('updateMediaProviderFeeField failed!!!', err);
                    });
            });
        },
        saveAccountMediaProviderFees: (provider_types:ProviderTypeEnum[], provider_fees:MediaProviderFeesObj ) => { // fields: {field_name:string, field_value:string}[]) => {
            return new Promise((resolve,reject) => {
                fetchRequest(
                    `${constConfig.url.API_URL + accounts_path}/SaveAccountMediaProviderFees`,
                    'post',
                    new URLSearchParams({ 
                        provider_types: JSON.stringify(provider_types),
                        provider_fees: JSON.stringify(provider_fees),
                     }).toString()
                )
                    .then((response: any) => {
                       // console.log(response);
                        parseString(response, (err: any, result: any) => {
                            if (result) {
                                const res = JSON.parse(result.string._);
    
                                if (res.Success) {
                                   
                                    resolve(true);
                                  
                                } else {
                                    console.error('Error during saveAccountMediaProviderFees ErrorMessage:', res.ErrorMessage);
                                    reject(new Error(res.ErrorMessage));
                                }
                            }
                        });
                    })
                    .catch((err) => {
                        reject(err);
                        console.log('saveAccountMediaProviderFees failed!!!', err);
                    });
            });
        },       
    },
    Analitics:{
        getGroupPromptsList: () => {
            return new Promise((resolve) => {
                fetchRequest(
                    `${constConfig.url.API_URL + accounts_path}/GetGroupPromptsList`,
                    'post',
                    new URLSearchParams({}).toString()
                )
                    .then((response: any) => {
                        parseString(response, (err: any, result: any) => {
                            if (result) {
                                const res = JSON.parse(result.string._);
    
                                if (res.Success) {
                                    if (res.Response) {
                                        const responseData = JSON.parse(res.Response);
                                        resolve(responseData);
                                    }
                                } else {
                                    console.error('Error during getGroupPromptsList ErrorMessage:', res.ErrorMessage);
                                }
                            }
                        });
                    })
    
                    .catch((err) => {
                        resolve(null);
                        console.log('getGroupPromptsList failed!!!');
                    });
            });
        },
        getPresentationTemplates: () => {
            return new Promise((resolve) => {
                fetchRequest(
                    `${constConfig.url.API_URL + accounts_path}/GetPresentationTemplates`,
                    'post',
                    null, true
                ).then((res: any) => {
                    if (res.Success) {
                        if (res.Response) {
                            const responseData = JSON.parse(res.Response);
                            resolve(responseData);
                        }
                    } else {
                        console.error('Error during getPresentationTemplates ErrorMessage:', res.ErrorMessage);
                    }
                }).catch((err) => {
                    resolve(null);
                    console.log('getPresentationTemplates failed!!!');
                });
            });
        },
        saveGroupPrompts: (item:any) => {
            return new Promise((resolve) => {
                fetchRequest(
                    `${constConfig.url.API_URL + accounts_path}/SaveGroupPrompts`,
                    'post',
                    new URLSearchParams({ 
                        groupPrompts:JSON.stringify(item),
                     }).toString()
                )
                    .then((response: any) => {
                       // console.log(response);
                        parseString(response, (err: any, result: any) => {
                            if (result) {
                                const res = JSON.parse(result.string._);
    
                                if (res.Success) {
                                   
                                    resolve(true);
                                  
                                } else {
                                    console.error('Error during saveGroupPrompts ErrorMessage:', res.ErrorMessage);
                                    resolve(res);
                                }
                            }
                        });
                    })
                    .catch((err) => {
                        resolve(null);
                        console.log('saveGroupPrompts failed!!!', err);
                    });
            });
        },
        savePresentationTemplate: (file:File, promptType: PromptTypeEnum) => {
        return new Promise((resolve,reject) => {
            fetchRequest(
                `${constConfig.url.API_URL + accounts_path}/SavePresentationTemplate`,
                'post',
                JSON.stringify({promptType}),
                true,
                file
            )
                .then((res: any) => {
                    if (res.Success) {
                        if (res.Response) {
                            const responseData = JSON.parse(res.Response);
                            resolve(responseData);
                        }
                    } else {
                        console.error('Error during savePresentationTemplate ErrorMessage:', res.ErrorMessage);
                        reject(new Error(res.ErrorMessage));
                    }
                })
                .catch((err) => {
                    reject(err);
                    console.log('uploadFile failed!!!');
                });
        });
    },
    },
    Categories:{
        getAccountCategories: () => {
            return new Promise((resolve,reject) => {
                fetchRequest(
                    `${constConfig.url.API_URL + accounts_path}/GetAccountCategories`,
                    'post',
                    new URLSearchParams({}).toString()
                )
                    .then((response: any) => {
                        parseString(response, (err: any, result: any) => {
                            if (result) {
                                const res = JSON.parse(result.string._);
    
                                if (res.Success) {
                                    if (res.Response) {
                                        const responseData = JSON.parse(res.Response);
                                        resolve(responseData);
                                    }
                                } else {
                                    console.error('Error during getAccountCategories ErrorMessage:', res.ErrorMessage);
                                    reject(new Error(res.ErrorMessage));
                                }
                            }
                        });
                    })
    
                    .catch((err) => {
                        reject(err);
                        console.log('getAccountCategories failed!!!');
                    });
            });
        },
        saveAccountCategories: (item:any) => {
            return new Promise((resolve) => {
                fetchRequest(
                    `${constConfig.url.API_URL + accounts_path}/SaveAccountCategories`,
                    'post',
                    new URLSearchParams({ 
                        categoryIds:JSON.stringify(item),
                     }).toString()
                )
                    .then((response: any) => {
                       // console.log(response);
                        parseString(response, (err: any, result: any) => {
                            if (result) {
                                const res = JSON.parse(result.string._);
    
                                if (res.Success) {
                                   
                                    resolve(true);
                                  
                                } else {
                                    console.error('Error during saveAccountCategories ErrorMessage:', res.ErrorMessage);
                                    resolve(res);
                                }
                            }
                        });
                    })
                    .catch((err) => {
                        resolve(null);
                        console.log('saveAccountCategories failed!!!', err);
                    });
            });
        },
    }
};

const activities_path = '/WebServices/ActivitesService.asmx';
export const ActivitiesApi = {
    getActivitiesList: (accountId:number,from_date:string,to_date:string) => {
        return new Promise((resolve) => {
            fetchRequest(
                `${constConfig.url.API_URL + activities_path}/GetActivitiesList`,
                'post',
                new URLSearchParams({
                    accountId:accountId.toString(),
                    fromDate:from_date,
                    toDate:to_date}).toString(),
            )
                .then((response: any) => {
                    parseString(response, (err: any, result: any) => {
                        if (result) {
                            const res = JSON.parse(result.string._);

                            if (res.Success) {
                                if (res.Response) {
                                    const responseData = JSON.parse(res.Response);
                                    resolve(responseData);
                                }
                            } else {
                                console.error('Error during getActivitiesList ErrorMessage:', res.ErrorMessage);
                            }
                        }
                    });
                })

                .catch((err) => {
                    resolve(null);
                    console.log('getActivitiesList failed!!!');
                });
        });
    },
    getActivitiesOptions: (accountId:number) => {
        return new Promise((resolve) => {
            fetchRequest(
                `${constConfig.url.API_URL + activities_path}/GetActivitiesOptions`,
                'post',
                new URLSearchParams({
                    accountId:accountId.toString()}).toString(),
                ).then((response: any) => {
                    parseString(response, (err: any, result: any) => {
                        if (result) {
                            const res = JSON.parse(result.string._);

                            if (res.Success) {
                                if (res.Response) {
                                    const responseData = JSON.parse(res.Response);
                                    resolve(responseData);
                                }
                            } else {
                                console.error('Error during getActivitiesList ErrorMessage:', res.ErrorMessage);
                            }
                        }
                    });
                })

                .catch((err) => {
                    resolve(null);
                    console.log('getActivitiesList failed!!!');
                });
        });
    },
    getActivitiesPerformanceList: (accountId:number, from_date:string,to_date:string) => {
        return new Promise((resolve) => {
            fetchRequest(
                `${constConfig.url.API_URL + activities_path}/GetActivitiesPerformanceList`,
                'post',
                new URLSearchParams({
                    accountId:accountId.toString(),
                   // isPublished: (isPublished ? '1' : '-1'),
                    fromDate:from_date,
                    toDate:to_date}).toString(),
            )
                .then((response: any) => {
                    parseString(response, (err: any, result: any) => {
                        if (result) {
                            const res = JSON.parse(result.string._);

                            if (res.Success) {
                                if (res.Response) {
                                    const responseData = JSON.parse(res.Response);
                                    resolve(responseData);
                                }
                            } else {
                                console.error('Error during getActivitiesPerformanceList ErrorMessage:', res.ErrorMessage);
                            }
                        }
                    });
                })

                .catch((err) => {
                    resolve(null);
                    console.log('getActivitiesPerformanceList failed!!!');
                });
        });
    },
    getActivityInfo: (id: any) => {
        return new Promise((resolve) => {
            fetchRequest(
                `${constConfig.url.API_URL + activities_path}/GetActivityInfo`,
                'post',
                new URLSearchParams({ activityId: id }).toString()
            )
                .then((response: any) => {
                    parseString(response, (err: any, result: any) => {
                        if (result) {
                            const res = JSON.parse(result.string._);

                            if (res.Success) {
                                if (res.Response) {
                                    const responseData = JSON.parse(res.Response);
                                    resolve(responseData);
                                }
                            } else {
                                console.error('Error during getActivityInfo ErrorMessage:', res.ErrorMessage);
                            }
                        }
                    });
                })

                .catch((err) => {
                    resolve(null);
                    console.log('getActivityInfo failed!!!', err);
                });
        });
    },

    saveActivity: (activity: any,copyFromActivityId:any) => {
        return new Promise((resolve) => {
            fetchRequest(
                `${constConfig.url.API_URL + activities_path}/SaveActivity`,
                'post',
                new URLSearchParams({activity: JSON.stringify(activity),
                    copyFromActivityId: copyFromActivityId ? copyFromActivityId.toString() : '-1' }).toString()
            )
                .then((response: any) => {
                    parseString(response, (err: any, result: any) => {
                        if (result) {
                            const res = JSON.parse(result.string._);

                            if (res.Success) {
                                if (res.Response) {
                                    const responseData = JSON.parse(res.Response);
                                    resolve(responseData);
                                }
                            } else {
                                console.error('Error during saveActivity ErrorMessage:', res.ErrorMessage);
                                resolve(res.ErrorMessage);
                            }
                        }
                    });
                })
                .catch((err) => {
                    resolve(null);
                    console.log('saveActivity failed!!!', err);
                });
        });
    },
    
    deleteActivity: (id: any) => {
        return new Promise((resolve) => {
            fetchRequest(
                `${constConfig.url.API_URL + activities_path}/DeleteActivity`,
                'post',
                new URLSearchParams({ activityId: id }).toString()
            )
                .then((response: any) => {
                    parseString(response, (err: any, result: any) => {
                        if (result) {
                            const res = JSON.parse(result.string._);

                            if (res.Success) {
                                if (res.Response) {
                                    const responseData = JSON.parse(res.Response);
                                    resolve(responseData);
                                }
                            } else {
                                console.error('Error during deleteActivity ErrorMessage:', res.ErrorMessage);
                            }
                        }
                    });
                })

                .catch((err) => {
                    resolve(null);
                    console.log('deleteActivity failed!!!', err);
                });
        });
    },
    
    saveActivityDate: (activity_id: number, date_field:string, new_date:string) => {
        return new Promise((resolve) => {
            fetchRequest(
                `${constConfig.url.API_URL + activities_path}/UpdateActivity`,
                'post',
                new URLSearchParams({ 
                    activityId: activity_id.toString(),
                    fieldName: date_field, 
                    fieldVal: new_date 
                }).toString()
            )
                .then((response: any) => {
                    parseString(response, (err: any, result: any) => {
                        if (result) {
                            const res = JSON.parse(result.string._);
    
                            if (res.Success) {
                                if (res.Response) {
                                    const responseData = JSON.parse(res.Response);
                                    resolve(responseData);
                                }
                            } else {
                                console.error('Error during deleteActivity ErrorMessage:', res.ErrorMessage);
                            }
                        }
                    });
                })
    
                .catch((err) => {
                    resolve(null);
                    console.log('deleteActivity failed!!!', err);
                });
        });
    },
    
   getInactiveColumns: (activity_id: number,media_mix_id?:number) => {
   
           return new Promise((resolve,reject) => {
               fetchRequest(
                   `${constConfig.url.API_URL + activities_path}/GetInactiveColumns`,
                   'post',
                   JSON.stringify({ 
                       activityId: activity_id,
                       mediaMixId: media_mix_id || -1
                   }),
                   true // send json i.o. urlencoded
               )
                   .then((res: any) => {
                       if (res.Success) {
                           if (res.Response) {
                               const responseData = JSON.parse(res.Response);
                               resolve(responseData);
                           }
                       } else {
                           console.error('Error during getInactiveColumns ErrorMessage:', res.ErrorMessage);
                           reject(new Error(res.ErrorMessage));
                       }
                   })
                   .catch((err) => {
                       reject(err);
                       console.log('getInactiveColumns failed!!!', err);
                   });
           });
       },
    

};

const agent_settings_path = '/WebServices/AgentSettingsService.asmx';
export const AgentSettingsApi = {
    GeneralSettings:{
        getAgentSettings: () => {
            return new Promise((resolve) => {
                fetchRequest(
                    `${constConfig.url.API_URL + agent_settings_path}/GetAgentSettings`,
                    'post',
                    new URLSearchParams({}).toString()
                )
                    .then((response: any) => {
                        parseString(response, (err: any, result: any) => {
                            if (result) {
                                const res = JSON.parse(result.string._);
    
                                if (res.Success) {
                                    if (res.Response) {
                                        const responseData = JSON.parse(res.Response);
                                        resolve(responseData);
                                    }
                                } else {
                                    console.error('Error during getAgentSettings ErrorMessage:', res.ErrorMessage);
                                }
                            }
                        });
                    })
    
                    .catch((err) => {
                        resolve(null);
                        console.log('getAgentSettings failed!!!');
                    });
            });
        },
        saveAgentSettings: (item:any) => {
            return new Promise((resolve,reject) => {
                fetchRequest(
                    `${constConfig.url.API_URL + agent_settings_path}/SaveAgentSettings`,
                    'post',
                    new URLSearchParams({ 
                        settings:JSON.stringify(item),
                     }).toString()
                )
                    .then((response: any) => {
                        parseString(response, (err: any, result: any) => {
                            if (result) {
                                const res = JSON.parse(result.string._);
    
                                if (res.Success) {
                                    resolve(true);
                                } else {
                                    reject(new Error(res.ErrorMessage))
                                    console.error('Error during saveAgentSettings ErrorMessage:', res.ErrorMessage);
                                }
                            }
                        });
                    })
    
                    .catch((err) => {
                        reject(new Error("Operation Failed"))
                        console.log('saveAgentSettings failed!!!');
                    });
            });
        },
        getPerformanceExConfig: () => {
            return new Promise((resolve) => {
                fetchRequest(
                    `${constConfig.url.API_URL + agent_settings_path}/GetPerformanceExConfig`,
                    'post',
                    new URLSearchParams({}).toString()
                )
                    .then((response: any) => {
                        parseString(response, (err: any, result: any) => {
                            if (result) {
                                const res = JSON.parse(result.string._);
    
                                if (res.Success) {
                                    if (res.Response) {
                                        const responseData = JSON.parse(res.Response);
                                        resolve(responseData);
                                    }
                                } else {
                                    console.error('Error during getPerformanceExConfig ErrorMessage:', res.ErrorMessage);
                                }
                            }
                        });
                    })
    
                    .catch((err) => {
                        resolve(null);
                        console.log('getPerformanceExConfig failed!!!');
                    });
            });
        },
        savePerformanceExConfig: (item:any) => {
            return new Promise((resolve,reject) => {
                fetchRequest(
                    `${constConfig.url.API_URL + agent_settings_path}/SavePerformanceExConfig`,
                    'post',
                    new URLSearchParams({ 
                        settings:JSON.stringify(item),
                     }).toString()
                )
                    .then((response: any) => {
                        parseString(response, (err: any, result: any) => {
                            if (result) {
                                const res = JSON.parse(result.string._);
    
                                if (res.Success) {
                                    resolve(true);
                                } else {
                                    reject(new Error(res.ErrorMessage))
                                    console.error('Error during savePerformanceExConfig ErrorMessage:', res.ErrorMessage);
                                }
                            }
                        });
                    })
    
                    .catch((err) => {
                        reject(new Error("Operation Failed"))
                        console.log('savePerformanceExConfig failed!!!');
                    });
            });
        },
        initAgentMediaProviderFees : () => {
            return new Promise((resolve,reject) => {
                fetchRequest(
                    `${constConfig.url.API_URL + agent_settings_path}/InitAgentMediaProviderFees`,
                    'post',
                    new URLSearchParams({}).toString()
                )
                    .then((response: any) => {
                        parseString(response, (err: any, result: any) => {
                            if (result) {
                                const res = JSON.parse(result.string._);
    
                                if (res.Success) {
                                    if (res.Response) {
                                        const responseData = JSON.parse(res.Response);
                                        resolve(responseData);
                                    }
                                } else {
                                    console.error('Error during initAgentMediaProviderFees ErrorMessage:', res.ErrorMessage);
                                    reject(new Error(res.ErrorMessage));
                                }
                            }
                        });
                    })
    
                    .catch((err) => {
                        reject(err);
                        console.log('initAgentMediaProviderFees failed!!!');
                    });
            });
        },
        updateAgentMediaProviderFeeField : (providerType:ProviderTypeEnum, field_name:string, field_value:string ) => { 
            return new Promise((resolve,reject) => {
                fetchRequest(
                    `${constConfig.url.API_URL + agent_settings_path}/UpdateAgentMediaProviderFeeField`,
                    'post',
                    new URLSearchParams({ 
                        providerType: providerType.toString(),
                        field_name,field_value
                        // fields:JSON.stringify(fields),
                        }).toString()
                )
                    .then((response: any) => {
                        // console.log(response);
                        parseString(response, (err: any, result: any) => {
                            if (result) {
                                const res = JSON.parse(result.string._);
    
                                if (res.Success) {
                                    
                                    resolve(true);
                                    
                                } else {
                                    console.error('Error during updateAgentMediaProviderFeeField ErrorMessage:', res.ErrorMessage);
                                    reject(new Error(res.ErrorMessage));
                                }
                            }
                        });
                    })
                    .catch((err) => {
                        reject(err);
                        console.log('updateAgentMediaProviderFeeField failed!!!', err);
                    });
            });
        },
        saveAgentMediaProviderFees: (provider_types:ProviderTypeEnum[], provider_fees:MediaProviderFeesObj ) => { // fields: {field_name:string, field_value:string}[]) => {
            return new Promise((resolve,reject) => {
                fetchRequest(
                    `${constConfig.url.API_URL + agent_settings_path}/SaveAgentMediaProviderFees`,
                    'post',
                    new URLSearchParams({ 
                        provider_types: JSON.stringify(provider_types),
                        provider_fees: JSON.stringify(provider_fees),
                        }).toString()
                )
                    .then((response: any) => {
                        // console.log(response);
                        parseString(response, (err: any, result: any) => {
                            if (result) {
                                const res = JSON.parse(result.string._);
    
                                if (res.Success) {
                                    
                                    resolve(true);
                                    
                                } else {
                                    console.error('Error during saveAgentMediaProviderFees ErrorMessage:', res.ErrorMessage);
                                    reject(new Error(res.ErrorMessage));
                                }
                            }
                        });
                    })
                    .catch((err) => {
                        reject(err);
                        console.log('saveAgentMediaProviderFees failed!!!', err);
                    });
            });
        }, 
    },
    ExchangeRates:{
    getExchangeRatesList: () => {
        return new Promise((resolve) => {
            fetchRequest(
                `${constConfig.url.API_URL + agent_settings_path}/GetExchangeRatesList`,
                'post',
                new URLSearchParams({}).toString()
            )
                .then((response: any) => {
                    parseString(response, (err: any, result: any) => {
                        if (result) {
                            const res = JSON.parse(result.string._);

                            if (res.Success) {
                                if (res.Response) {
                                    const responseData = JSON.parse(res.Response);
                                    resolve(responseData);
                                }
                            } else {
                                console.error('Error during getExchangeRatesList ErrorMessage:', res.ErrorMessage);
                            }
                        }
                    });
                })

                .catch((err) => {
                    resolve(null);
                    console.log('getExchangeRatesList failed!!!');
                });
        });
    },
    getExchangeRateInfo: (id:number) => {
        return new Promise((resolve) => {
            fetchRequest(
                `${constConfig.url.API_URL + agent_settings_path}/GetExchangeRateInfo`,
                'post',
                new URLSearchParams({exRateId:id.toString()}).toString()
            )
                .then((response: any) => {
                    parseString(response, (err: any, result: any) => {
                        if (result) {
                            const res = JSON.parse(result.string._);

                            if (res.Success) {
                                if (res.Response) {
                                    const responseData = JSON.parse(res.Response);
                                    resolve(responseData);
                                }
                            } else {
                                console.error('Error during getMediaChannelInfo ErrorMessage:', res.ErrorMessage);
                            }
                        }
                    });
                })

                .catch((err) => {
                    resolve(null);
                    console.log('getMediaChannelInfo failed!!!');
                });
        });
    },
    saveExchangeRate: (item:any) => {
        return new Promise((resolve) => {
            fetchRequest(
                `${constConfig.url.API_URL + agent_settings_path}/SaveExchangeRate`,
                'post',
                new URLSearchParams({ 
                    exRate:JSON.stringify(item),
                 }).toString()
            )
                .then((response: any) => {
                   // console.log(response);
                    parseString(response, (err: any, result: any) => {
                        if (result) {
                            const res = JSON.parse(result.string._);

                            if (res.Success) {
                                const responseData = JSON.parse(res.Response);
                                resolve(responseData);
                              
                            } else {
                                console.error('Error during saveExchangeRate ErrorMessage:', res.ErrorMessage);
                                resolve(res);
                            }
                        }
                    });
                })
                .catch((err) => {
                    resolve(null);
                    console.log('saveExchangeRate failed!!!', err);
                });
        });
    },
   
    },
    Analitics:{
        getGroupPromptsList: () => {
            return new Promise((resolve) => {
                fetchRequest(
                    `${constConfig.url.API_URL + agent_settings_path}/GetGroupPromptsList`,
                    'post',
                    new URLSearchParams({}).toString()
                )
                    .then((response: any) => {
                        parseString(response, (err: any, result: any) => {
                            if (result) {
                                const res = JSON.parse(result.string._);
    
                                if (res.Success) {
                                    if (res.Response) {
                                        const responseData = JSON.parse(res.Response);
                                        resolve(responseData);
                                    }
                                } else {
                                    console.error('Error during getGroupPromptsList ErrorMessage:', res.ErrorMessage);
                                }
                            }
                        });
                    })
    
                    .catch((err) => {
                        resolve(null);
                        console.log('getGroupPromptsList failed!!!');
                    });
            });
        },
        getPresentationTemplates: () => {
            return new Promise((resolve) => {
                fetchRequest(
                    `${constConfig.url.API_URL + agent_settings_path}/GetPresentationTemplates`,
                    'post',
                    null, true
                ).then((res: any) => {
                    if (res.Success) {
                        if (res.Response) {
                            const responseData = JSON.parse(res.Response);
                            resolve(responseData);
                        }
                    } else {
                        console.error('Error during getPresentationTemplates ErrorMessage:', res.ErrorMessage);
                    }
                }).catch((err) => {
                    resolve(null);
                    console.log('getPresentationTemplates failed!!!');
                });
            });
        },
        saveGroupPrompts: (item:any) => {
            return new Promise((resolve) => {
                fetchRequest(
                    `${constConfig.url.API_URL + agent_settings_path}/SaveGroupPrompts`,
                    'post',
                    new URLSearchParams({ 
                        groupPrompts:JSON.stringify(item),
                     }).toString()
                )
                    .then((response: any) => {
                       // console.log(response);
                        parseString(response, (err: any, result: any) => {
                            if (result) {
                                const res = JSON.parse(result.string._);
    
                                if (res.Success) {
                                    
                                    resolve(true);
                                  
                                } else {
                                    console.error('Error during saveGroupPrompts ErrorMessage:', res.ErrorMessage);
                                    resolve(res);
                                }
                            }
                        });
                    })
                    .catch((err) => {
                        resolve(null);
                        console.log('saveGroupPrompts failed!!!', err);
                    });
            });
        },
        savePresentationTemplate: (file:File, promptType: PromptTypeEnum) => {
            return new Promise((resolve,reject) => {
                fetchRequest(
                    `${constConfig.url.API_URL + agent_settings_path}/SavePresentationTemplate`,
                    'post',
                    JSON.stringify({promptType}),
                    true,
                    file
                )
                    .then((res: any) => {
                        if (res.Success) {
                            if (res.Response) {
                                const responseData = JSON.parse(res.Response);
                                resolve(responseData);
                            }
                        } else {
                            console.error('Error during savePresentationTemplate ErrorMessage:', res.ErrorMessage);
                            reject(new Error(res.ErrorMessage));
                        }
                    })
                    .catch((err) => {
                        reject(err);
                        console.log('uploadFile failed!!!');
                    });
            });
        },
    },
    MediaPlanApproval:{
        getMediaPlanApprovalSettings: () => {
            return new Promise((resolve,reject) => {
                fetchRequest(
                    `${constConfig.url.API_URL + agent_settings_path}/GetMediaPlanApprovalSettings`,
                    'post',
                    new URLSearchParams({ }).toString()
                )
                    .then((response: any) => {
                        parseString(response, (err: any, result: any) => {
                            if (result) {
                                const res = JSON.parse(result.string._);
    
                                if (res.Success) {
                                    if (res.Response) {
                                        const responseData = JSON.parse(res.Response);
                                        resolve(responseData);
                                    }
                                } else {
                                    reject(res.ErrorMessage);
                                    console.error('Error during getMediaPlanApprovalSettings ErrorMessage:', res.ErrorMessage);
                                }
                            }
                        });
                    })
    
                    .catch((err) => {
                        reject(err);
                        console.log('getMediaPlanApprovalSettings failed!!!', err);
                    });
            });
        },
        saveMediaPlanApprovalField: (id:number, accountId:string,  fieldName:string,  fieldValue:string) => {
            return new Promise((resolve,reject) => {
                fetchRequest(
                    `${constConfig.url.API_URL + agent_settings_path}/SaveMediaPlanApprovalField`,
                    'post',
                    new URLSearchParams({ 
                        id:id.toString(),
                        accountID: accountId.toString(),
                        fieldName,
                        fieldValue }).toString()
                )
                    .then((response: any) => {
                        parseString(response, (err: any, result: any) => {
                            if (result) {
                                const res = JSON.parse(result.string._);
    
                                if (res.Success) {
                                    if (res.Response) {
                                        const responseData = JSON.parse(res.Response);
                                        resolve(responseData);
                                    }
                                } else {
                                    reject(res.ErrorMessage);
                                    console.error('Error during saveMediaPlanApprovalField ErrorMessage:', res.ErrorMessage);
                                }
                            }
                        });
                    })
    
                    .catch((err) => {
                        reject(err);
                        console.log('saveMediaPlanApprovalField failed!!!', err);
                    });
            });
        },
        saveMediaPlanApprovalSetting: (approval:any) => {
            return new Promise((resolve,reject) => {
                fetchRequest(
                    `${constConfig.url.API_URL + agent_settings_path}/SaveMediaPlanApprovalSetting`,
                    'post',
                    new URLSearchParams({ 
                        approval: JSON.stringify(approval)}).toString()
                )
                    .then((response: any) => {
                        parseString(response, (err: any, result: any) => {
                            if (result) {
                                const res = JSON.parse(result.string._);
    
                                if (res.Success) {
                                    resolve(true);
                                } else {
                                    reject(new Error(res.ErrorMessage));
                                    console.error('Error during saveBulkMediaPlanApprovalSettings ErrorMessage:', res.ErrorMessage);
                                }
                            }
                        });
                    })
    
                    .catch((err) => {
                        reject(err);
                        console.log('saveBulkMediaPlanApprovalSettings failed!!!', err);
                    });
            });
        },
        saveBulkMediaPlanApprovalSettings: (accountIds:number[],approval:any) => {
            return new Promise((resolve,reject) => {
                fetchRequest(
                    `${constConfig.url.API_URL + agent_settings_path}/SaveBulkMediaPlanApprovalSettings`,
                    'post',
                    new URLSearchParams({ 
                        accountIds: JSON.stringify(accountIds),
                        approval: JSON.stringify(approval)}).toString()
                )
                    .then((response: any) => {
                        parseString(response, (err: any, result: any) => {
                            if (result) {
                                const res = JSON.parse(result.string._);
    
                                if (res.Success) {
                                    resolve(true);
                                } else {
                                    reject(res.ErrorMessage);
                                    console.error('Error during saveBulkMediaPlanApprovalSettings ErrorMessage:', res.ErrorMessage);
                                }
                            }
                        });
                    })
    
                    .catch((err) => {
                        reject(err);
                        console.log('saveBulkMediaPlanApprovalSettings failed!!!', err);
                    });
            });
        },
        deleteMediaPlanApprovalSettings: (id:number, accountId:string) => {
            return new Promise((resolve,reject) => {
                fetchRequest(
                    `${constConfig.url.API_URL + agent_settings_path}/DeleteMediaPlanApprovalSettings`,
                    'post',
                    new URLSearchParams({ 
                        id:id.toString(),
                        accountId: accountId.toString() }).toString()
                )
                    .then((response: any) => {
                        parseString(response, (err: any, result: any) => {
                            if (result) {
                                const res = JSON.parse(result.string._);
    
                                if (res.Success) {
                                    resolve(true);
                                } else {
                                    reject(res.ErrorMessage);
                                    console.error('Error during deleteMediaPlanApprovalSettings ErrorMessage:', res.ErrorMessage);
                                }
                            }
                        });
                    })
    
                    .catch((err) => {
                        reject(err);
                        console.log('deleteMediaPlanApprovalSettings failed!!!', err);
                    });
            });
        },
        
    },
    Billing:{
        getMaterialNumbers: () => {
            return new Promise((resolve,reject) => {
                fetchRequest(
                    `${constConfig.url.API_URL + agent_settings_path}/GetMaterialNumbers`,
                    'post',
                    new URLSearchParams({ }).toString()
                )
                    .then((response: any) => {
                        parseString(response, (err: any, result: any) => {
                            if (result) {
                                const res = JSON.parse(result.string._);
    
                                if (res.Success) {
                                    if (res.Response) {
                                        const responseData = JSON.parse(res.Response);
                                        resolve(responseData);
                                    }
                                } else {
                                    reject(res.ErrorMessage);
                                    console.error('Error during getMaterialNumbers ErrorMessage:', res.ErrorMessage);
                                }
                            }
                        });
                    })
    
                    .catch((err) => {
                        reject(err);
                        console.log('getMaterialNumbers failed!!!', err);
                    });
            });
        },
        saveMaterialNumber: (isCustomChannel:boolean, channelId:string,  campaignCategory:CampaignCategoryEnum, payerType:PayerTypeEnum,  materialNumber:string) => {
            return new Promise((resolve,reject) => {
                fetchRequest(
                    `${constConfig.url.API_URL + agent_settings_path}/SaveMaterialNumber`,
                    'post',
                    new URLSearchParams({ 
                        isCustomChannel: isCustomChannel ? 'true' : 'false',
                        channelId: channelId.toString(),
                        campaignCategory: campaignCategory.toString(),
                        payerType:payerType.toString(),
                        materialNumber }).toString()
                )
                    .then((response: any) => {
                        parseString(response, (err: any, result: any) => {
                            if (result) {
                                const res = JSON.parse(result.string._);
    
                                if (res.Success) {
                                    resolve(true);
                                } else {
                                    reject(res.ErrorMessage);
                                    console.error('Error during saveMediaPlanApprovalSettings ErrorMessage:', res.ErrorMessage);
                                }
                            }
                        });
                    })
    
                    .catch((err) => {
                        reject(err);
                        console.log('saveMediaPlanApprovalSettings failed!!!', err);
                    });
            });
        },
        saveBulkMaterialNumber: (customChannelIds:number[],channelIds:number[],campaignCategory:CampaignCategoryEnum, payerType:PayerTypeEnum,  materialNumber:string) => {
            
            return new Promise((resolve,reject) => {
                fetchRequest(
                    `${constConfig.url.API_URL + agent_settings_path}/SaveBulkMaterialNumber`,
                    'post',
                    new URLSearchParams({ 
                        customChannelIds: JSON.stringify(customChannelIds),
                        channelIds: JSON.stringify(channelIds),
                        campaignCategory: campaignCategory.toString(),
                        payerType:payerType.toString(),
                        materialNumber}).toString()
                )
                    .then((response: any) => {
                        parseString(response, (err: any, result: any) => {
                            if (result) {
                                const res = JSON.parse(result.string._);
    
                                if (res.Success) {
                                    resolve(true);
                                } else {
                                    reject(res.ErrorMessage);
                                    console.error('Error during saveBulkMediaPlanApprovalSettings ErrorMessage:', res.ErrorMessage);
                                }
                            }
                        });
                    })
    
                    .catch((err) => {
                        reject(err);
                        console.log('saveBulkMediaPlanApprovalSettings failed!!!', err);
                    });
            });
        },
        saveSubmissionSumMaterialNumber: (materialNumber:string) => {
            
            return new Promise((resolve,reject) => {
                fetchRequest(
                    `${constConfig.url.API_URL + agent_settings_path}/SaveSubmissionSumMaterialNumber`,
                    'post',
                    new URLSearchParams({ materialNumber}).toString()
                )
                    .then((response: any) => {
                        parseString(response, (err: any, result: any) => {
                            if (result) {
                                const res = JSON.parse(result.string._);
    
                                if (res.Success) {
                                    resolve(true);
                                } else {
                                    reject(res.ErrorMessage);
                                    console.error('Error during saveBulkMediaPlanApprovalSettings ErrorMessage:', res.ErrorMessage);
                                }
                            }
                        });
                    })
    
                    .catch((err) => {
                        reject(err);
                        console.log('saveBulkMediaPlanApprovalSettings failed!!!', err);
                    });
            });
        },
    }
   
    

};

const campaigns_path = '/WebServices/CampaignsService.asmx';
export const CampaignsApi = {
    
    getAllCampaignsList: (channelTypeId:any,campaignType:any) => {
        return new Promise((resolve) => {
            fetchRequest(
                `${constConfig.url.API_URL + campaigns_path}/GetAllCampaignsList`,
                'post',
                new URLSearchParams({channelTypeId,
                    campaignType: campaignType ? campaignType.toString() : ''}).toString()
            )
                .then((response: any) => {
                    parseString(response, (err: any, result: any) => {
                        if (result) {
                            const res = JSON.parse(result.string._);

                            if (res.Success) {
                                if (res.Response) {
                                    const responseData = JSON.parse(res.Response);
                                    resolve(responseData);
                                }
                            } else {
                                resolve(res);
                                console.error('Error during getCampaignsList ErrorMessage:', res.ErrorMessage);
                            }
                        }
                    });
                })

                .catch((err) => {
                    resolve(null);
                    console.log('getCampaignsList failed!!!');
                });
        });
    },
    getConversionActions: (channelTypeId:any,campaignIds:any) => {
        return new Promise((resolve) => {
            fetchRequest(
                `${constConfig.url.API_URL + campaigns_path}/GetConversionActions`,
                'post',
                new URLSearchParams({
                    channelTypeId,
                    campaignIds: campaignIds.join()}).toString()
            )
                .then((response: any) => {
                    parseString(response, (err: any, result: any) => {
                        if (result) {
                            const res = JSON.parse(result.string._);

                            if (res.Success) {
                                if (res.Response) {
                                    const responseData = JSON.parse(res.Response);
                                    resolve(responseData);
                                }
                            } else {
                                resolve(res);
                                console.error('Error during getConversionActions ErrorMessage:', res.ErrorMessage);
                            }
                        }
                    });
                })
                .catch((err) => {
                    resolve(null);
                    console.log('getConversionActions failed!!!');
                });
        });
    },
    getChannelAccountsList: (channelTypeId: number, globalConnectorId:number,agentConnectorId:number) => {
        return new Promise((resolve) => {
            fetchRequest(
                `${constConfig.url.API_URL + campaigns_path}/GetChannelAccountsList`,
                'post',
                new URLSearchParams({
                    channelTypeId:channelTypeId.toString(),
                    globalConnectorId:globalConnectorId.toString(),
                    agentConnectorId: agentConnectorId.toString()}).toString()
            )
                .then((response: any) => {
                    parseString(response, (err: any, result: any) => {
                        if (result) {
                            const res = JSON.parse(result.string._);

                            if (res.Success) {
                                if (res.Response) {
                                    const responseData = JSON.parse(res.Response);
                                    resolve(responseData);
                                }
                            } else {
                                resolve(false);
                                console.error('Error during getChannelAccountsList ErrorMessage:', res.ErrorMessage);
                            }
                        }
                    });
                })
                .catch((err) => {
                    resolve(null);
                    console.log('getChannelAccountsList failed!!!');
                });
        });
    },
    getCampaignsList: (connectorId:any) => {
        return new Promise((resolve) => {
            fetchRequest(
                `${constConfig.url.API_URL + campaigns_path}/GetCampaignsList`,
                'post',
                new URLSearchParams({connectorId}).toString()
            )
                .then((response: any) => {
                    parseString(response, (err: any, result: any) => {
                        if (result) {
                            const res = JSON.parse(result.string._);

                            if (res.Success) {
                                if (res.Response) {
                                    const responseData = JSON.parse(res.Response);
                                    resolve(responseData);
                                }
                            } else {
                                console.error('Error during getCampaignsList ErrorMessage:', res.ErrorMessage);
                            }
                        }
                    });
                })

                .catch((err) => {
                    resolve(null);
                    console.log('getCampaignsList failed!!!');
                });
        });
    },

    getCampaignInfo: (id: any) => {
        return new Promise((resolve) => {
            fetchRequest(
                `${constConfig.url.API_URL + campaigns_path}/GetCampaignInfo`,
                'post',
                new URLSearchParams({ campaignId: id }).toString()
            )
                .then((response: any) => {
                    parseString(response, (err: any, result: any) => {
                        if (result) {
                            const res = JSON.parse(result.string._);

                            if (res.Success) {
                                if (res.Response) {
                                    const responseData = JSON.parse(res.Response);
                                    resolve(responseData);
                                }
                            } else {
                                console.error('Error during getCampaignInfo ErrorMessage:', res.ErrorMessage);
                            }
                        }
                    });
                })

                .catch((err) => {
                    resolve(null);
                    console.log('getCampaignInfo failed!!!', err);
                });
        });
    },

    saveCampaign: (campaign: any) => {
        return new Promise((resolve) => {
            fetchRequest(
                `${constConfig.url.API_URL + campaigns_path}/SaveCampaign`,
                'post',
                new URLSearchParams({ campaign: JSON.stringify(campaign) }).toString()
            )
                .then((response: any) => {
                    parseString(response, (err: any, result: any) => {
                        if (result) {
                            const res = JSON.parse(result.string._);

                            if (res.Success) {
                                if (res.Response) {
                                    const responseData = JSON.parse(res.Response);
                                    resolve(responseData);
                                }
                            } else {
                                console.error('Error during saveCampaign ErrorMessage:', res.ErrorMessage);
                                resolve(res.ErrorMessage);
                            }
                        }
                    });
                })
                .catch((err) => {
                    resolve(null);
                    console.log('saveCampaign failed!!!', err);
                });
        });
    },

    deleteCampaign: (id: any) => {
        return new Promise((resolve) => {
            fetchRequest(
                `${constConfig.url.API_URL + campaigns_path}/DeleteCampaign`,
                'post',
                new URLSearchParams({ campaignId: id }).toString()
            )
                .then((response: any) => {
                    parseString(response, (err: any, result: any) => {
                        if (result) {
                            const res = JSON.parse(result.string._);

                            if (res.Success) {
                                if (res.Response) {
                                    const responseData = JSON.parse(res.Response);
                                    resolve(responseData);
                                }
                            } else {
                                console.error('Error during deleteCampaign ErrorMessage:', res.ErrorMessage);
                            }
                        }
                    });
                })

                .catch((err) => {
                    resolve(null);
                    console.log('deleteCampaign failed!!!', err);
                });
        });
    },
    GoogleAnalytics:{
         getMediaChannelAssets: (mediaChannelId:number,dynamicFieldId:number) => {
            return new Promise((resolve,reject) => {
                fetchRequest(
                    `${constConfig.url.API_URL + campaigns_path}/GetMediaChannelAssets`,
                    'post',
                    new URLSearchParams({
                        mediaChannelId:mediaChannelId.toString(),
                        dynamicFieldId:dynamicFieldId.toString()
                    }).toString()
                )
                    .then((response: any) => {
                        parseString(response, (err: any, result: any) => {
                            if (result) {
                                const res = JSON.parse(result.string._);
    
                                if (res.Success) {
                                    if (res.Response) {
                                        const responseData = JSON.parse(res.Response);
                                        resolve(responseData);
                                    }
                                } else {
                                    reject(new Error(res.ErrorMessage))
                                    console.error('Error during getMediaChannelAssets ErrorMessage:', res.ErrorMessage);
                                }
                            }
                        });
                    })
    
                    .catch((err) => {
                        reject(err);
                        console.log('getMediaChannelAssets failed!!!', err);
                    });
            });
        },
        getGoogleAnalyticsAssets: () => {
            return new Promise((resolve,reject) => {
                fetchRequest(
                    `${constConfig.url.API_URL + campaigns_path}/GetGoogleAnalyticsAssets`,
                    'post',
                    new URLSearchParams().toString()
                )
                    .then((response: any) => {
                        parseString(response, (err: any, result: any) => {
                            if (result) {
                                const res = JSON.parse(result.string._);
    
                                if (res.Success) {
                                    if (res.Response) {
                                        const responseData = JSON.parse(res.Response);
                                        resolve(responseData);
                                    }
                                } else {
                                    reject(new Error(res.ErrorMessage))
                                    console.error('Error during getGoogleAnalyticsAssets ErrorMessage:', res.ErrorMessage);
                                }
                            }
                        });
                    })
    
                    .catch((err) => {
                        reject(err);
                        console.log('getGoogleAnalyticsAssets failed!!!', err);
                    });
            });
        },
        getGoogleAnalyticsMetaData: (assetId:string) => {
            return new Promise((resolve,reject) => {
                fetchRequest(
                    `${constConfig.url.API_URL + campaigns_path}/GetGoogleAnalyticsMetaData`,
                    'post',
                    new URLSearchParams({assetId}).toString()
                )
                    .then((response: any) => {
                        parseString(response, (err: any, result: any) => {
                            if (result) {
                                const res = JSON.parse(result.string._);
    
                                if (res.Success) {
                                    if (res.Response) {
                                        const responseData = JSON.parse(res.Response);
                                        resolve(responseData);
                                    }
                                } else {
                                    reject(new Error(res.ErrorMessage))
                                    console.error('Error during setGoogleAnalyticsMetaData ErrorMessage:', res.ErrorMessage);
                                }
                            }
                        });
                    })
    
                    .catch((err) => {
                        reject(err);
                        console.log('setGoogleAnalyticsMetaData failed!!!', err);
                    });
            });
        },
        saveMediaChannelAsset: (mediaChannelId:number,dynamicFieldId:number,asset:AnalyticsAssetItem) => {
            return new Promise((resolve,reject) => {
                fetchRequest(
                    `${constConfig.url.API_URL + campaigns_path}/SaveMediaChannelAsset`,
                    'post',
                    new URLSearchParams({ 
                        asset: JSON.stringify(asset),
                        mediaChannelId:mediaChannelId.toString(),
                        dynamicFieldId:dynamicFieldId.toString()}).toString()
                )
                    .then((response: any) => {
                        parseString(response, (err: any, result: any) => {
                            if (result) {
                                const res = JSON.parse(result.string._);
    
                                if (res.Success) {
                                     if (res.Response) {
                                        const responseData = JSON.parse(res.Response);
                                        resolve(responseData);
                                    }
                                  
                                } else {
                                    reject(new Error(res.ErrorMessage))
                                    console.error('Error during saveMediaChannelAsset ErrorMessage:', res.ErrorMessage);
                                }
                            }
                        });
                    })
    
                    .catch((err) => {
                        reject(err);
                        console.log('saveMediaChannelAsset failed!!!', err);
                    });
            });
        },
        removeMediaChannelAsset: (mediaChannelId:number,dynamicFieldId:number,assetId:number) => {
            return new Promise((resolve,reject) => {
                fetchRequest(
                    `${constConfig.url.API_URL + campaigns_path}/RemoveMediaChannelAsset`,
                    'post',
                    new URLSearchParams({ 
                        assetId: assetId.toString(),
                        mediaChannelId:mediaChannelId.toString(),
                        dynamicFieldId:dynamicFieldId.toString()}).toString()
                )
                    .then((response: any) => {
                        parseString(response, (err: any, result: any) => {
                            if (result) {
                                const res = JSON.parse(result.string._);
    
                                if (res.Success) {
                                      resolve(true);
                                  
                                } else {
                                    reject(new Error(res.ErrorMessage))
                                    console.error('Error during removeMediaChannelAsset ErrorMessage:', res.ErrorMessage);
                                }
                            }
                        });
                    })
    
                    .catch((err) => {
                        reject(err);
                        console.log('removeMediaChannelAsset failed!!!', err);
                    });
            });
        },
    },
    MediaServe:{
        getMediaServeList: (from_date:string,to_date:string) => {
            return new Promise((resolve,reject) => {
                fetchRequest(
                    `${constConfig.url.API_URL + campaigns_path}/GetMediaServeList`,
                    'post', 
                    JSON.stringify({ fromDate:from_date,toDate:to_date }),
                    true 
                ).then((res: any) => {
                     if (res.Success) {
                        if (res.Response) {
                            const responseData = JSON.parse(res.Response);
                            resolve(responseData);
                        }
                    } else {
                        console.error('Error during getMediaServeList ErrorMessage:', res.ErrorMessage);
                        reject(new Error(res.ErrorMessage));
                    }
                })
                .catch((err) => {
                    reject(err);
                    console.log('getMediaServeList failed!!!', err);
                });
            });
        },
        getMediaServeDetailedList: (from_date:string,to_date:string,activity_id:number,provider:ProviderTypeEnum) => {
            return new Promise((resolve,reject) => {
                fetchRequest(
                    `${constConfig.url.API_URL + campaigns_path}/GetMediaServeDetailedList`,
                    'post', 
                    JSON.stringify({ fromDate:from_date,
                                     toDate:to_date,
                                     activityID:activity_id,
                                     providerType: provider }),
                    true 
                ).then((res: any) => {
                    if (res.Success) {
                        if (res.Response) {
                            const responseData = JSON.parse(res.Response);
                            resolve(responseData);
                        }
                    } else {
                        console.error('Error during getMediaServeDetailedList ErrorMessage:', res.ErrorMessage);
                        reject(res.ErrorMessage);
                    }
                    
                })
                .catch((err) => {
                    reject(err);
                    console.log('getMediaServeDetailedList failed!!!', err);
                });
            });
        },
        getBannersByMediaMix: (id: any) => {
            return new Promise((resolve) => {
                fetchRequest(
                    `${constConfig.url.API_URL + campaigns_path}/GetBannersByMediaMix`,
                    'post',
                    new URLSearchParams({ mediaMixId: id }).toString()
                )
                    .then((response: any) => {
                        parseString(response, (err: any, result: any) => {
                            if (result) {
                                const res = JSON.parse(result.string._);
    
                                if (res.Success) {
                                    if (res.Response) {
                                        const responseData = JSON.parse(res.Response);
                                        resolve(responseData);
                                    }
                                } else {
                                    console.error('Error during getBannersByMediaMix ErrorMessage:', res.ErrorMessage);
                                }
                            }
                        });
                    })
    
                    .catch((err) => {
                        resolve(null);
                        console.log('getBannersByMediaMix failed!!!', err);
                    });
            });
        },
        getBannerInfo: (id: any) => {
            return new Promise((resolve) => {
                fetchRequest(
                    `${constConfig.url.API_URL + campaigns_path}/GetBannerInfo`,
                    'post',
                    new URLSearchParams({ bannerId: id }).toString()
                )
                    .then((response: any) => {
                        parseString(response, (err: any, result: any) => {
                            if (result) {
                                const res = JSON.parse(result.string._);
    
                                if (res.Success) {
                                    if (res.Response) {
                                        const responseData = JSON.parse(res.Response);
                                        resolve(responseData);
                                    }
                                } else {
                                    console.error('Error during getBannerInfo ErrorMessage:', res.ErrorMessage);
                                }
                            }
                        });
                    })
    
                    .catch((err) => {
                        resolve(null);
                        console.log('getBannerInfo failed!!!', err);
                    });
            });
        },
        getBannerTrafficStatus: (id: any) => {
            return new Promise((resolve,reject) => {
                fetchRequest(
                    `${constConfig.url.API_URL + campaigns_path}/GetBannerTrafficStatus`,
                    'post',
                    new URLSearchParams({ bannerId: id }).toString()
                )
                    .then((response: any) => {
                        parseString(response, (err: any, result: any) => {
                            if (result) {
                                const res = JSON.parse(result.string._);
    
                                if (res.Success) {
                                    resolve(res.Response);
                                    
                                } else {
                                    reject(new Error(res.ErrorMessage));
                                    console.error('Error during getBannerTrafficStatus ErrorMessage:', res.ErrorMessage);
                                }
                            }
                        });
                    })
    
                    .catch((err) => {
                        reject(err);
                        console.log('getBannerTrafficStatus failed!!!', err);
                    });
            });
        },
        saveBanner: (banner: any, mediaChannelId: number) => {
            return new Promise((resolve,reject) => {
                fetchRequest(
                    `${constConfig.url.API_URL + campaigns_path}/SaveBanner`,
                    'post', 
                    // new URLSearchParams({ banner: JSON.stringify(banner) }).toString()
                    JSON.stringify({ 
                        banner: JSON.stringify(banner),
                        mediaChannelId: mediaChannelId.toString() }),
                    true // send json i.o. urlencoded
                )
                    .then((res: any) => {
                        if (res.Success) {
                            if (res.Response) {
                                const responseData = JSON.parse(res.Response);
                                resolve(responseData);
                            }
                        } else {
                            console.error('Error during saveBanner ErrorMessage:', res.ErrorMessage);
                            reject(res.ErrorMessage);
                        }
                    })
                    .catch((err) => {
                        reject(err);
                        console.log('saveBanner failed!!!', err);
                    });
            });
        },
    
        deleteBanner: (id: any) => {
            return new Promise((resolve,reject) => {
                fetchRequest(
                    `${constConfig.url.API_URL + campaigns_path}/DeleteBanner`,
                    'post',
                    new URLSearchParams({ bannerId: id }).toString()
                )
                    .then((response: any) => {
                        parseString(response, (err: any, result: any) => {
                            if (result) {
                                const res = JSON.parse(result.string._);
    
                                if (res.Success) {
                                    resolve(true);
                                    
                                } else {
                                    console.error('Error during deleteBanner ErrorMessage:', res.ErrorMessage);
                                    reject(new Error(res.ErrorMessage));
                                }
                            }
                        });
                    })
    
                    .catch((err) => {
                        reject(err);
                        console.log('deleteBanner failed!!!', err);
                    });
            });
        },
        deleteBannerVariant: (id: any) => {
            return new Promise((resolve,reject) => {
                fetchRequest(
                    `${constConfig.url.API_URL + campaigns_path}/DeleteBannerVariant`,
                    'post',
                    new URLSearchParams({ variantId: id }).toString()
                )
                    .then((response: any) => {
                        parseString(response, (err: any, result: any) => {
                            if (result) {
                                const res = JSON.parse(result.string._);
    
                                if (res.Success) {
                                    resolve(true);
                                    
                                } else {
                                    console.error('Error during deleteBannerVariant ErrorMessage:', res.ErrorMessage);
                                    reject(new Error(res.ErrorMessage));
                                }
                            }
                        });
                    })
    
                    .catch((err) => {
                        reject(err);
                        console.log('deleteBannerVariant failed!!!', err);
                    });
            });
        },
         saveBannerCreative:(file:File,isCustom:boolean, bannerId:number,creativeFormatId:number,tempFileObj:any,varianId:number)=>{
            tempFileObj.preview = '';
            return new Promise((resolve,reject) => {
                fetchRequest(
                    `${constConfig.url.API_URL + campaigns_path}/SaveBannerCreative`,
                    'post',
                     JSON.stringify({ 
                        isCustom: isCustom ? 'true' : 'false',
                        bannerId: bannerId.toString(),
                        varianId: varianId.toString(),
                        creativeFormatId:creativeFormatId.toString(),
                        creative: JSON.stringify(tempFileObj) 
                    }),
                    true, // content-type json
                    file
                )
                    .then((res: any) => {
                        if (res.Success) {
                            if (res.Response) {
                                const responseData = JSON.parse(res.Response);
                                resolve(responseData);
                            }
                        } else {
                            console.error('Error during saveBannerCreative ErrorMessage:', res.ErrorMessage);
                            reject(new Error(res.ErrorMessage));
                        }
                    })
                    .catch((err) => {
                        reject(err);
                        console.log('saveBannerCreative failed!!!', err);
                    });
            });
        },
        saveBannerCreativeFile:(file:File,isCustom:boolean, bannerId:number,creativeFormatId:number,tempFileObj:any)=>{
            return new Promise((resolve,reject) => {
                fetchRequest(
                    `${constConfig.url.API_URL + campaigns_path}/SaveBannerCreativeFile`,
                    'post',
                    JSON.stringify({  
                        isCustom: isCustom ? 'true' : 'false',
                        bannerId: bannerId.toString(),
                        creativeFormatId:creativeFormatId.toString(),
                        creative: JSON.stringify(tempFileObj) }),
                        true,
                        file,
                    
                )
                    .then((res: any) => {
                        if (res.Success) {
                            if (res.Response) {
                                const responseData = JSON.parse(res.Response);
                                resolve(responseData);
                            }
                        } else {
                            console.error('Error during saveBannerCreativeFile ErrorMessage:', res.ErrorMessage);
                            reject(new Error(res.ErrorMessage));
                        }
                    })
                    .catch((err) => {
                        reject(err);
                        console.log('saveBannerCreativeFile failed!!!', err);
                    });
            });
        },
        deleteBannerCreative:(bannerId:number,creativeId:number)=>{
            return new Promise((resolve) => {
                fetchRequest(
                    `${constConfig.url.API_URL + campaigns_path}/DeleteBannerCreative`,
                    'post',
                    new URLSearchParams({ 
                        bannerId: bannerId.toString(),
                        creativeId: creativeId.toString()
                    })).then((response: any) => {
                        parseString(response, (err: any, result: any) => {
                            if (result) {
                                const res = JSON.parse(result.string._);
    
                                if (res.Success) {
                                    resolve(true);
                                } else {
                                    console.error('Error during deleteBannerCreative ErrorMessage:', res.ErrorMessage);
                                    resolve(false);
                                }
                            }
                        });
                    })
                    .catch((err) => {
                        resolve(null);
                        console.log('deleteBannerCreative failed!!!', err);
                    });
            });
        },
        clearBannerCache: (bannerId:number,tagId?:number)=>{
            return new Promise((resolve) => {
                fetchRequest(
                    `${constConfig.url.API_URL + campaigns_path}/ClearBannerCache`,
                    'post',
                    new URLSearchParams({ 
                        bannerId: bannerId.toString(),
                        tagId: (tagId || -1).toString()
                    })).then((response: any) => {
                        parseString(response, (err: any, result: any) => {
                            if (result) {
                                const res = JSON.parse(result.string._);
    
                                if (res.Success) {
                                    resolve(true);
                                } else {
                                    console.error('Error during clearBannerCache ErrorMessage:', res.ErrorMessage);
                                    resolve(false);
                                }
                            }
                        });
                    })
                    .catch((err) => {
                        resolve(null);
                        console.log('clearBannerCache failed!!!', err);
                    });
            });
        },
    }
};

const connectors_path = '/WebServices/ConnectorsService.asmx';
export const ConnectorsApi = {
    getConnectorsList: (accountId:number) => {
        return new Promise((resolve) => {
            fetchRequest(
                `${constConfig.url.API_URL + connectors_path}/GetConnectorsList`,
                'post',
                new URLSearchParams({accountId:accountId.toString()}).toString()
            )
                .then((response: any) => {
                    parseString(response, (err: any, result: any) => {
                        if (result) {
                            const res = JSON.parse(result.string._);

                            if (res.Success) {
                                if (res.Response) {
                                    const responseData = JSON.parse(res.Response);
                                    resolve(responseData);
                                }
                            } else {
                                console.error('Error during getConnectorsList ErrorMessage:', res.ErrorMessage);
                            }
                        }
                    });
                })

                .catch((err) => {
                    resolve(null);
                    console.log('getConnectorsList failed!!!');
                });
        });
    },

    getConnectorInfo: (id: any) => {
        return new Promise((resolve) => {
            fetchRequest(
                `${constConfig.url.API_URL + connectors_path}/GetConnectorInfo`,
                'post',
                new URLSearchParams({ connectorId: id }).toString()
            )
                .then((response: any) => {
                    parseString(response, (err: any, result: any) => {
                        if (result) {
                            const res = JSON.parse(result.string._);

                            if (res.Success) {
                                if (res.Response) {
                                    const responseData = JSON.parse(res.Response);
                                    resolve(responseData);
                                }
                            } else {
                                console.error('Error during getConnectorInfo ErrorMessage:', res.ErrorMessage);
                            }
                        }
                    });
                })

                .catch((err) => {
                    resolve(null);
                    console.log('getConnectorInfo failed!!!', err);
                });
        });
    },

    saveConnector: (accountId:number,connector: any) => {
        
        return new Promise((resolve) => {
            fetchRequest(
                `${constConfig.url.API_URL + connectors_path}/SaveConnector`,
                'post',
                new URLSearchParams({ 
                    accountId:accountId.toString(),
                    connector: JSON.stringify(connector) }).toString()
            )
                .then((response: any) => {
                    parseString(response, (err: any, result: any) => {
                        if (result) {
                            const res = JSON.parse(result.string._);

                            if (res.Success) {
                                if (res.Response) {
                                    const responseData = JSON.parse(res.Response);
                                    resolve(responseData);
                                }
                            } else {
                                console.error('Error during saveConnector ErrorMessage:', res.ErrorMessage);
                                resolve(res.ErrorMessage);
                            }
                        }
                    });
                })
                .catch((err) => {
                    resolve(null);
                    console.log('saveConnector failed!!!', err);
                });
        });
    },
    updateConnectorGlobalStatus: (connectorId:number,connected: boolean) => {
        
        return new Promise((resolve) => {
            fetchRequest(
                `${constConfig.url.API_URL + connectors_path}/UpdateConnectorGlobalStatus`,
                'post',
                new URLSearchParams({ 
                    connectorId:connectorId.toString(),
                    connected: connected.toString() }).toString()
            )
                .then((response: any) => {
                    parseString(response, (err: any, result: any) => {
                        if (result) {
                            const res = JSON.parse(result.string._);

                            if (res.Success) {
                                resolve(true);
                            } else {
                                console.error('Error during saveConnector ErrorMessage:', res.ErrorMessage);
                                resolve(res.ErrorMessage);
                            }
                        }
                    });
                })
                .catch((err) => {
                    resolve(null);
                    console.log('saveConnector failed!!!', err);
                });
        });
    },
    deleteConnector: (id: any) => {
        return new Promise((resolve) => {
            fetchRequest(
                `${constConfig.url.API_URL + connectors_path}/DeleteConnector`,
                'post',
                new URLSearchParams({ connectorId: id }).toString()
            )
                .then((response: any) => {
                    parseString(response, (err: any, result: any) => {
                        if (result) {
                            const res = JSON.parse(result.string._);

                            if (res.Success) {
                                if (res.Response) {
                                    const responseData = JSON.parse(res.Response);
                                    resolve(responseData);
                                }
                            } else {
                                console.error('Error during deleteConnector ErrorMessage:', res.ErrorMessage);
                            }
                        }
                    });
                })

                .catch((err) => {
                    resolve(null);
                    console.log('deleteConnector failed!!!', err);
                });
        });
    },
    AgentConnectors:{
        getAgentConnectorsList: () => {
            return new Promise((resolve) => {
                fetchRequest(
                    `${constConfig.url.API_URL + connectors_path}/GetAgentConnectorsList`,
                    'post',
                    new URLSearchParams().toString()
                )
                    .then((response: any) => {
                        parseString(response, (err: any, result: any) => {
                            if (result) {
                                const res = JSON.parse(result.string._);
    
                                if (res.Success) {
                                    if (res.Response) {
                                        const responseData = JSON.parse(res.Response);
                                        resolve(responseData);
                                    }
                                } else {
                                    console.error('Error during getAgentConnectorsList ErrorMessage:', res.ErrorMessage);
                                }
                            }
                        });
                    })
    
                    .catch((err) => {
                        resolve(null);
                        console.log('getAgentConnectorsList failed!!!');
                    });
            });
        },
        getAgentConnectorInfo: (id: any) => {
            return new Promise((resolve) => {
                fetchRequest(
                    `${constConfig.url.API_URL + connectors_path}/GetAgentConnectorInfo`,
                    'post',
                    new URLSearchParams({ connectorId: id }).toString()
                )
                    .then((response: any) => {
                        parseString(response, (err: any, result: any) => {
                            if (result) {
                                const res = JSON.parse(result.string._);
    
                                if (res.Success) {
                                    if (res.Response) {
                                        const responseData = JSON.parse(res.Response);
                                        resolve(responseData);
                                    }
                                } else {
                                    console.error('Error during getAgentConnectorInfo ErrorMessage:', res.ErrorMessage);
                                }
                            }
                        });
                    })
    
                    .catch((err) => {
                        resolve(null);
                        console.log('getAgentConnectorInfo failed!!!', err);
                    });
            });
        },
        // getAgentConnectorInfoByType: (channelTypeId: number) => {
        //     return new Promise((resolve,reject) => {
        //         fetchRequest(
        //             `${constConfig.url.API_URL + connectors_path}/GetAgentConnectorInfoByType`,
        //             'post',
        //             JSON.stringify({ channelTypeId }),
        //             true
        //         )
        //             .then((res: any) => {
        //                 if (res.Success) {
        //                     if (res.Response) {
        //                         const responseData = JSON.parse(res.Response);
        //                         resolve(responseData);
        //                     }
        //                 } else {
        //                     console.error('Error during getAgentConnectorInfoByType ErrorMessage:', res.ErrorMessage);
        //                     reject(new Error(res.ErrorMessage));
        //                 }
        //             }).catch((err) => {
        //                 reject(err);
        //                 console.log('getAgentConnectorInfoByType failed!!!', err);
        //             });
        //     });
        // },
    
        saveAgentConnector: (connector: any,requestToken?:any) => {
            
            return new Promise((resolve,reject) => {
                fetchRequest(
                    `${constConfig.url.API_URL + connectors_path}/SaveAgentConnector`,
                    'post',
                    JSON.stringify({  
                        connector: JSON.stringify(connector),
                        requestToken: requestToken ? JSON.stringify(requestToken) : '' }), 
                        true
                )
                    .then((res: any) => {
                        if (res.Success) {
                            if (res.Response) {
                                const responseData = JSON.parse(res.Response);
                                resolve(responseData);
                            }
                        } else {
                            console.error('Error during saveAgentConnector ErrorMessage:', res.ErrorMessage);
                            reject(new Error(res.ErrorMessage));
                        }
                    })
                    .catch((err) => {
                        reject(err);
                        console.log('saveAgentConnector failed!!!', err);
                    });
            });
        },
        deleteAgentConnector: (id: any) => {
            return new Promise((resolve) => {
                fetchRequest(
                    `${constConfig.url.API_URL + connectors_path}/DeleteAgentConnector`,
                    'post',
                    new URLSearchParams({ connectorId: id }).toString()
                )
                    .then((response: any) => {
                        parseString(response, (err: any, result: any) => {
                            if (result) {
                                const res = JSON.parse(result.string._);
    
                                if (res.Success) {
                                    if (res.Response) {
                                        const responseData = JSON.parse(res.Response);
                                        resolve(responseData);
                                    }
                                } else {
                                    console.error('Error during deleteAgentConnector ErrorMessage:', res.ErrorMessage);
                                }
                            }
                        });
                    })
    
                    .catch((err) => {
                        resolve(null);
                        console.log('deleteAgentConnector failed!!!', err);
                    });
            });
        },
        getChannelRequestToken:(channelTypeId: number) => {
            return new Promise((resolve, reject) => {
                fetchRequest(
                    `${constConfig.url.API_URL + connectors_path}/GetChannelRequestToken`,
                    'post',
                     JSON.stringify({ channelTypeId: channelTypeId.toString()  }),
                    true 
                )
                    .then((res: any) => {
                        if (res.Success) {
                            if (res.Response) {
                                const responseData = JSON.parse(res.Response);
                                resolve(responseData);
                            } else{
                                reject(new Error('Response empty'));
                            }
                        } else {
                            console.error('Error during getChannelRequestToken ErrorMessage:', res.ErrorMessage);
                            reject(new Error(res.ErrorMessage));
                        }
                        
                    }).catch((err) => {
                        reject(err);
                        console.log('getChannelRequestToken failed!!!', err);
                    });
            });
        },
        setChannelAuth:(channelTypeId: number,connId:any,authObj:any) => {
            return new Promise((resolve, reject) => {
                fetchRequest(
                    `${constConfig.url.API_URL + connectors_path}/SetChannelAuth`,
                    'post',
                     JSON.stringify({ channelTypeId: channelTypeId.toString(), 
                                        connId: connId.toString(),
                                        authObj: JSON.stringify(authObj)  }),
                    true 
                )
                    .then((res: any) => {
                        if (res.Success) {
                            if (res.Response) {
                                const responseData = JSON.parse(res.Response);
                                resolve(responseData);
                            }
                        } else {
                            console.error('Error during setChannelAuth ErrorMessage:', res.ErrorMessage);
                            reject(new Error(res.ErrorMessage));
                        }
                    }).catch((err) => {
                        reject(err);
                        console.log('setChannelAuth failed!!!', err);
                    });
            });
        },
    }
};

const dashboards_path = '/WebServices/DashboardsService.asmx';
type BudgetSummary = {
  Subject: string;
  SpentBudget: number;
  MediaBudget:string;
  GrossBudget:string;
  percent:string;
  ManagementFee:number;
  channelId:string;
  AccountId:string;
};
type BudgetCompare = {
  Channel: string;
  Period1: string;
  Period2:string;
  Period1Cost:number;
  Period2Cost:number;
  CostDifference:number;
  PercentChange:string;
  
};
export const DashboardsApi = {
     getBudgetSummaryByAccounts: (status:number,fromDate:string,toDate:string) : Promise<BudgetSummary[] | null>=> {
        return new Promise((resolve,reject) => {
            fetchRequest(
                `${constConfig.url.API_URL + dashboards_path}/GetBudgetSummaryByAccounts`,
                'post',
                new URLSearchParams({ status: status.toString(),fromDate,toDate }).toString()
            )
                .then((response: any) => {
                    parseString(response, (err: any, result: any) => {
                        if (result) {
                            const res = JSON.parse(result.string._);

                            if (res.Success) {
                                if (res.Response) {
                                    const responseData = JSON.parse(res.Response);
                                    resolve(responseData);
                                }
                            } else {
                                console.error('Error during getBudgetSummaryByAccounts ErrorMessage:', res.ErrorMessage);
                                reject(res.ErrorMessage)
                            }
                        }
                    });
                })

                .catch((err) => {
                    resolve(null);
                    console.log('getBudgetSummaryByAccounts failed!!!', err);
                });
        });
    },
    getBudgetSummaryByMediaChannels: (status:number,fromDate:string,toDate:string) : Promise<BudgetSummary[] | null>=> {
        return new Promise((resolve,reject) => {
            fetchRequest(
                `${constConfig.url.API_URL + dashboards_path}/GetBudgetSummaryByMediaChannels`,
                'post',
                new URLSearchParams({ status: status.toString(),fromDate,toDate }).toString()
            )
                .then((response: any) => {
                    parseString(response, (err: any, result: any) => {
                        if (result) {
                            const res = JSON.parse(result.string._);

                            if (res.Success) {
                                if (res.Response) {
                                    const responseData = JSON.parse(res.Response);
                                    resolve(responseData);
                                }
                            } else {
                                console.error('Error during getBudgetSummaryByMediaChannels ErrorMessage:', res.ErrorMessage);
                                reject(res.ErrorMessage)
                            }
                        }
                    });
                })

                .catch((err) => {
                    resolve(null);
                    console.log('getBudgetSummaryByMediaChannels failed!!!', err);
                });
        });
    },
     getBudgetSummaryByMediaChannelXCampaignType: (status:number,fromDate:string,toDate:string,channelMedia:string) : Promise<BudgetSummary[] | null>=> {
        return new Promise((resolve,reject) => {
            fetchRequest(
                `${constConfig.url.API_URL + dashboards_path}/GetBudgetSummaryByMediaChannelXCampaignType`,
                'post',
                new URLSearchParams({ status: status.toString(),fromDate,toDate,channelMedia}).toString()
            )
                .then((response: any) => {
                    parseString(response, (err: any, result: any) => {
                        if (result) {
                            const res = JSON.parse(result.string._);

                            if (res.Success) {
                                if (res.Response) {
                                    const responseData = JSON.parse(res.Response);
                                    resolve(responseData);
                                }
                            } else {
                                console.error('Error during getBudgetSummaryByMediaChannelXCampaignType ErrorMessage:', res.ErrorMessage);
                                reject(res.ErrorMessage)
                            }
                        }
                    });
                })

                .catch((err) => {
                    resolve(null);
                    console.log('getBudgetSummaryByMediaChannelXCampaignType failed!!!', err);
                });
        });
    },
 getBudgetSummaryByCustomers:(status:number,fromDate:string,toDate:string,channelMedia:string,accountName:string) : Promise<BudgetSummary[] | null>=> {
        return new Promise((resolve,reject) => {
            fetchRequest(
                `${constConfig.url.API_URL + dashboards_path}/GetBudgetSummaryByMediaChannelXCampaignTypeXAccount`,
                'post',
                new URLSearchParams({ status: status.toString(),fromDate,toDate,channelMedia,accountName}).toString()
            )
                .then((response: any) => {
                    parseString(response, (err: any, result: any) => {
                        if (result) {
                            const res = JSON.parse(result.string._);

                            if (res.Success) {
                                if (res.Response) {
                                    const responseData = JSON.parse(res.Response);
                                    resolve(responseData);
                                }
                            } else {
                                console.error('Error during getBudgetSummaryByMediaChannelXCampaignTypeXAccount ErrorMessage:', res.ErrorMessage);
                                reject(res.ErrorMessage)
                            }
                        }
                    });
                })

                .catch((err) => {
                    resolve(null);
                    console.log('getBudgetSummaryByMediaChannelXCampaignTypeXAccount failed!!!', err);
                });
        });
    },
    getSummaryBudgetByForAccountXChannelMedia: (status:number,fromDate:string,toDate:string,accountId:number) : Promise<BudgetSummary[] | null>=> {
        return new Promise((resolve,reject) => {
            fetchRequest(
                `${constConfig.url.API_URL + dashboards_path}/GetSummaryBudgetByForAccountXChannelMedia`,
                'post',
                new URLSearchParams({ status: status.toString(),fromDate,toDate,accountId:accountId.toString()}).toString()
            )
                .then((response: any) => {
                    parseString(response, (err: any, result: any) => {
                        if (result) {
                            const res = JSON.parse(result.string._);

                            if (res.Success) {
                                if (res.Response) {
                                    const responseData = JSON.parse(res.Response);
                                    resolve(responseData);
                                }
                            } else {
                                console.error('Error during getSummaryBudgetByForAccountXChannelMedia ErrorMessage:', res.ErrorMessage);
                                reject(res.ErrorMessage)
                            }
                        }
                    });
                })

                .catch((err) => {
                    resolve(null);
                    console.log('getSummaryBudgetByForAccountXChannelMedia failed!!!', err);
                });
        });
    },
    getBudgetSummaryByMediaChannelXCampaignTypeXAccount: (status:number,fromDate:string,toDate:string,channelMedia:string,accountId:number) : Promise<BudgetSummary[] | null>=> {
        return new Promise((resolve,reject) => {
            fetchRequest(
                `${constConfig.url.API_URL + dashboards_path}/GetBudgetSummaryByMediaChannelXCampaignTypeXAccount`,
                'post',
                new URLSearchParams({ status: status.toString(),fromDate,toDate,channelMedia,accountId:accountId.toString()}).toString()
            )
                .then((response: any) => {
                    parseString(response, (err: any, result: any) => {
                        if (result) {
                            const res = JSON.parse(result.string._);

                            if (res.Success) {
                                if (res.Response) {
                                    const responseData = JSON.parse(res.Response);
                                    resolve(responseData);
                                }
                            } else {
                                console.error('Error during getBudgetSummaryByMediaChannelXCampaignTypeXAccount ErrorMessage:', res.ErrorMessage);
                                reject(res.ErrorMessage)
                            }
                        }
                    });
                })

                .catch((err) => {
                    resolve(null);
                    console.log('getBudgetSummaryByMediaChannelXCampaignTypeXAccount failed!!!', err);
                });
        });
    },
      getSummaryBudgetByOrg: (status:number,fromDate:string,toDate:string) : Promise<BudgetSummary[] | null>=> {
        return new Promise((resolve,reject) => {
            fetchRequest(
                `${constConfig.url.API_URL + dashboards_path}/GetSummaryBudgetByOrg`,
                'post',
                new URLSearchParams({ status: status.toString(),fromDate,toDate }).toString()
            )
                .then((response: any) => {
                    parseString(response, (err: any, result: any) => {
                        if (result) {
                            const res = JSON.parse(result.string._);

                            if (res.Success) {
                                if (res.Response) {
                                    const responseData = JSON.parse(res.Response);
                                    resolve(responseData);
                                }
                            } else {
                                console.error('Error during getSummaryBudgetByOrg ErrorMessage:', res.ErrorMessage);
                                reject(res.ErrorMessage)
                            }
                        }
                    });
                })

                .catch((err) => {
                    resolve(null);
                    console.log('getSummaryBudgetByOrg failed!!!', err);
                });
        });
    },
     getBudgetSummaryByMediaChannelsBilling: (fromDate:string) : Promise<BudgetSummary[] | null>=> {
        return new Promise((resolve,reject) => {
            fetchRequest(
                `${constConfig.url.API_URL + dashboards_path}/GetBudgetSummaryByMediaChannelsBilling`,
                'post',
                new URLSearchParams({fromDate}).toString()
            )
                .then((response: any) => {
                    parseString(response, (err: any, result: any) => {
                        if (result) {
                            const res = JSON.parse(result.string._);

                            if (res.Success) {
                                if (res.Response) {
                                    const responseData = JSON.parse(res.Response);
                                    resolve(responseData);
                                }
                            } else {
                                console.error('Error during getBudgetSummaryByMediaChannelsBilling ErrorMessage:', res.ErrorMessage);
                                reject(res.ErrorMessage)
                            }
                        }
                    });
                })

                .catch((err) => {
                    resolve(null);
                    console.log('getBudgetSummaryByMediaChannelsBilling failed!!!', err);
                });
        });
    },
  
      getBudgetSummaryByMediaChannelXCampaignTypeBilling: (fromDate:string,channelMedia:string) : Promise<BudgetSummary[] | null>=> {
        return new Promise((resolve,reject) => {
            fetchRequest(
                `${constConfig.url.API_URL + dashboards_path}/GetBudgetSummaryByMediaChannelXCampaignTypeBilling`,
                'post',
                new URLSearchParams({ fromDate,channelMedia}).toString()
            )
                .then((response: any) => {
                    parseString(response, (err: any, result: any) => {
                        if (result) {
                            const res = JSON.parse(result.string._);

                            if (res.Success) {
                                if (res.Response) {
                                    const responseData = JSON.parse(res.Response);
                                    resolve(responseData);
                                }
                            } else {
                                console.error('Error during getBudgetSummaryByMediaChannelXCampaignTypeBilling ErrorMessage:', res.ErrorMessage);
                                reject(res.ErrorMessage)
                            }
                        }
                    });
                })

                .catch((err) => {
                    resolve(null);
                    console.log('getBudgetSummaryByMediaChannelXCampaignTypeBilling failed!!!', err);
                });
        });
    },
    getSummaryBudgetByForAccountXChannelMediaBilling: (status:number,fromDate:string,toDate:string,accountId:number) : Promise<BudgetSummary[] | null>=> {
        return new Promise((resolve,reject) => {
            fetchRequest(
                `${constConfig.url.API_URL + dashboards_path}/GetSummaryBudgetByForAccountXChannelMediaBilling`,
                'post',
                new URLSearchParams({ fromDate,accountId:accountId.toString()}).toString()
            )
                .then((response: any) => {
                    parseString(response, (err: any, result: any) => {
                        if (result) {
                            const res = JSON.parse(result.string._);

                            if (res.Success) {
                                if (res.Response) {
                                    const responseData = JSON.parse(res.Response);
                                    resolve(responseData);
                                }
                            } else {
                                console.error('Error during getSummaryBudgetByForAccountXChannelMediaBilling ErrorMessage:', res.ErrorMessage);
                                reject(res.ErrorMessage)
                            }
                        }
                    });
                })

                .catch((err) => {
                    resolve(null);
                    console.log('getSummaryBudgetByForAccountXChannelMediaBilling failed!!!', err);
                });
        });
    },
       getBudgetSummaryByMediaChannelXCampaignTypeXAccountBilling: (fromDate:string,channelMedia:string,accountId:number) : Promise<BudgetSummary[] | null>=> {
        return new Promise((resolve,reject) => {
            fetchRequest(
                `${constConfig.url.API_URL + dashboards_path}/GetBudgetSummaryByMediaChannelXCampaignTypeXAccountBilling`,
                'post',
                new URLSearchParams({fromDate,channelMedia,accountId:accountId.toString()}).toString()
            )
                .then((response: any) => {
                    parseString(response, (err: any, result: any) => {
                        if (result) {
                            const res = JSON.parse(result.string._);

                            if (res.Success) {
                                if (res.Response) {
                                    const responseData = JSON.parse(res.Response);
                                    resolve(responseData);
                                }
                            } else {
                                console.error('Error during getBudgetSummaryByMediaChannelXCampaignTypeXAccountBilling ErrorMessage:', res.ErrorMessage);
                                reject(res.ErrorMessage)
                            }
                        }
                    });
                })

                .catch((err) => {
                    resolve(null);
                    console.log('getBudgetSummaryByMediaChannelXCampaignTypeXAccountBilling failed!!!', err);
                });
        });
    },
      getBudgetSummaryByMediaChannelsCompare: (fromDate:string,toDate:string) : Promise<BudgetCompare[] | null>=> {
        return new Promise((resolve,reject) => {
            fetchRequest(
                `${constConfig.url.API_URL + dashboards_path}/GetBudgetSummaryByMediaChannelsCompare`,
                'post',
                new URLSearchParams({fromDate,toDate}).toString()
            )
                .then((response: any) => {
                    parseString(response, (err: any, result: any) => {
                        if (result) {
                            const res = JSON.parse(result.string._);

                            if (res.Success) {
                                if (res.Response) {
                                    const responseData = JSON.parse(res.Response);
                                    resolve(responseData);
                                }
                            } else {
                                console.error('Error during getBudgetSummaryByMediaChannelsCompare ErrorMessage:', res.ErrorMessage);
                                reject(res.ErrorMessage)
                            }
                        }
                    });
                })

                .catch((err) => {
                    resolve(null);
                    console.log('getBudgetSummaryByMediaChannelXCampaignTypeXAccountBilling failed!!!', err);
                });
        });
    },
     getBudgetSummaryByMediaChannelsComparePeriods: (fromDatePeriod1:string,toDatePeriod1:string,fromDatePeriod2:string,toDatePeriod2:string) : Promise<BudgetCompare[] | null>=> {
        return new Promise((resolve,reject) => {
            fetchRequest(
                `${constConfig.url.API_URL + dashboards_path}/GetBudgetSummaryByMediaChannelsComparePeriods`,
                'post',
                 JSON.stringify({ 
                    fromDate_period1: fromDatePeriod1,
                    toDate_period1: toDatePeriod1,
                    fromDate_period2: fromDatePeriod2,
                    toDate_period2: toDatePeriod2, 
                }),
                true
            )
            .then((res: any) => {
                if (res.Success) {
                    if (res.Response) {
                        const responseData = JSON.parse(res.Response);
                        resolve(responseData);
                    }
                } else {
                    console.error('Error during getBudgetSummaryByMediaChannelsComparePeriods ErrorMessage:', res.ErrorMessage);
                    reject(new Error(res.ErrorMessage))
                }
            })
            .catch((err) => {
                reject(err);
                console.log('getBudgetSummaryByMediaChannelsComparePeriods failed!!!', err);
            });
        });
    },
    // fromMonth, toMonth: 'YYYY-MM'
    getMediaDashboard2: (fromMonth:string,toMonth:string) : Promise<MediaDashboard2Data>=> {
        return new Promise((resolve,reject) => {
            fetchRequest(
                `${constConfig.url.API_URL + dashboards_path}/GetMediaDashboard2`,
                'post',
                JSON.stringify({ fromMonth, toMonth }),
                true
            )
            .then((res: any) => {
                if (res?.Success) {
                    resolve(JSON.parse(res.Response));
                } else {
                    console.error('Error during getMediaDashboard2 ErrorMessage:', res?.ErrorMessage);
                    reject(new Error(res?.ErrorMessage));
                }
            })
            .catch((err) => {
                reject(err);
                console.log('getMediaDashboard2 failed!!!', err);
            });
        });
    },
    // month: 'YYYY-MM', rate: NIS for 1 USD
    saveMediaDashboard2Rate: (month:string,rate:string) : Promise<void>=> {
        return new Promise((resolve,reject) => {
            fetchRequest(
                `${constConfig.url.API_URL + dashboards_path}/SaveMediaDashboard2Rate`,
                'post',
                JSON.stringify({ month, rate }),
                true
            )
            .then((res: any) => {
                if (res?.Success) {
                    resolve();
                } else {
                    console.error('Error during saveMediaDashboard2Rate ErrorMessage:', res?.ErrorMessage);
                    reject(new Error(res?.ErrorMessage));
                }
            })
            .catch((err) => {
                reject(err);
                console.log('saveMediaDashboard2Rate failed!!!', err);
            });
        });
    },
};
export type MediaDashboard2Month = {
  Month: string;
  IsPartial: boolean;
  ReportLastDate: string;
  ErrorRows: number;
  ErrorPlan: number;
  UsdRate: number | null;
  HasUsd: boolean;
  MissingRateCost: number;
  // spend of EUR accounts, left out of the NIS amounts
  EurCost: number;
};
// amounts in NIS
export type MediaDashboard2Row = {
  Month: string;
  ActivityId: number;
  // the activity's owner (employee)
  OwnerUserId: number;
  OwnerName: string;
  AccountId: number;
  AccountName: string;
  IsUsd: boolean;
  IsSubmissionSum: boolean;
  ChannelKey: string;
  ChannelName: string;
  CampaignCategory: number | null;
  PayerType: number;
  Plan: number;
  Cost: number;
  CostUsd: number | null;
  ManagementFee: number;
  SystemFee: number;
  Gross: number;
  TotalBilling: number;
};
export type MediaDashboard2Data = {
  Months: MediaDashboard2Month[];
  Rows: MediaDashboard2Row[];
};

const external_path = '/WebServices/ExternalService.asmx';
export const ExternalApi = {
    sendOTP: (token: any) => {
        return new Promise((resolve,reject) => {
            fetchRequest(
                `${constConfig.url.API_URL + external_path}/SendOTP`,
                'post',
                JSON.stringify({ token }),
                        true 
                ).then((res: any) => {
                    if (res.Success) {
                        if (res.Response) {
                            const responseData = JSON.parse(res.Response);
                            resolve(responseData);
                        }
                    } else {
                        reject(new Error(res.ErrorMessage))
                        console.error('Error during sendOTP ErrorMessage:', res.ErrorMessage);
                    }
                }).catch((err) => {
                    reject(err);
                    console.log('sendOTP failed!!!', err);
                });
        });
    },
    submitOTP: (token: any,otp: string) => {
        return new Promise((resolve,reject) => {
            fetchRequest(
                `${constConfig.url.API_URL + external_path}/SubmitOTP`,
                'post',
                JSON.stringify({ token,otp }),
                        true 
                ).then((res: any) => {
                    if (res.Success) {
                        if (res.Response) {
                            const responseData = JSON.parse(res.Response);
                            resolve(responseData);
                        }
                    } else {
                        reject(new Error(res.ErrorMessage))
                        console.error('Error during submitOTP ErrorMessage:', res.ErrorMessage);
                    }
                }).catch((err) => {
                    reject(err);
                    console.log('submitOTP failed!!!', err);
                });
        });
    },
    getMediaMixByToken: (token: any) => {
        return new Promise((resolve,reject) => {
            fetchRequest(
                `${constConfig.url.API_URL + external_path}/GetMediaMixByToken`,
                'post',
                new URLSearchParams({ token: token.toString() }).toString()
            )
                .then((response: any) => {
                    parseString(response, (err: any, result: any) => {
                        if (result) {
                            const res = JSON.parse(result.string._);

                            if (res.Success) {
                                if (res.Response) {
                                    const responseData = JSON.parse(res.Response);
                                    resolve(responseData);
                                }
                            } else {
                                reject(new Error(res.ErrorMessage))
                                console.error('Error during getMediaMixByToken ErrorMessage:', res.ErrorMessage);
                            }
                        }
                    });
                })

                .catch((err) => {
                    reject(err);
                    console.log('getMediaMixByToken failed!!!', err);
                });
        });
    },

    submitMediaPlanReply: (token: any,reply: ClientReply,reservationNumber:string,mediaPlanSnapshot:string) => {
        return new Promise((resolve,reject) => {
            fetchRequest(
                `${constConfig.url.API_URL + external_path}/SubmitMediaPlanReply`,
                'post',
                JSON.stringify({
                    token: token.toString(),
                    reply: JSON.stringify(reply),
                    reservationNumber: reservationNumber.toString(),
                    mediaPlanSnapshot: mediaPlanSnapshot.toString(),
                }),
                        true 
            )
                .then((res: any) => {
                    if (res.Success) {
                        resolve(true);
                    } else {
                        console.error('Error during submitMediaPlanReply ErrorMessage:', res.ErrorMessage);
                        reject(new Error(res.ErrorMessage));
                    }
                })
                .catch((err) => {
                    reject(err);
                    console.log('submitMediaPlanReply failed!!!', err);
                });
        });
    },
    getMediaMixReportByToken: (token: any) => {
        return new Promise((resolve,reject) => {
            fetchRequest(
                `${constConfig.url.API_URL + external_path}/GetMediaMixReportByToken`,
                'post',
                JSON.stringify({ token }),
                        true 
                ).then((res: any) => {
                    if (res.Success) {
                        if (res.Response) {
                            const responseData = JSON.parse(res.Response);
                            resolve(responseData);
                        }
                    } else {
                        reject(new Error(res.ErrorMessage))
                        console.error('Error during getMediaMixReportByToken ErrorMessage:', res.ErrorMessage);
                    }
                }).catch((err) => {
                    reject(err);
                    console.log('getMediaMixReportByToken failed!!!', err);
                });
        });
    },
   
    

};

const main_path = '/WebServices/MainService.asmx';

export enum CompareType {
    Equals,
    GreaterThan,
    GreaterThanOrEqual,
    LessThan,
    LessThanOrEqual,
    NotEqual
}
export type FilterType = 
'accounts' | 
'main_accounts' | 
'categories' | 
'conn_channels' | 
'media_channels' | 
'active_channels' |
'global_connectors' | 
'agent_connectors' | 
// 'target_types' | 
'group_types' |
'approvers' |
'users'; 

export type SystemFilters = {
    AccountsList: SelectOption[];
    MainAccountsList: SelectOption[];
    CategoryList: SelectOption[];
    ConnectorChannelsList: SelectOption[];
    MediaChannelsList: SelectOption[];
    ActiveChannelsList: SelectOption[];
    AgentConnectorsList: SelectOption[];
    GlobalConnectorsList: SelectOption[];
    // TargetTypesList: SelectOption[];
    GroupTypes: SelectOption[];
    Approvers: SelectOption[];
    UsersList: SelectOption[];
};

// back_app /private/filter/get.json lists -> SystemFilters
const filter_keys: {[k: string]: keyof SystemFilters} = {
    accounts: 'AccountsList', main_accounts: 'MainAccountsList',
    categories: 'CategoryList', conn_channels: 'ConnectorChannelsList',
    media_channels: 'MediaChannelsList', active_channels: 'ActiveChannelsList',
    agent_connectors: 'AgentConnectorsList',
    global_connectors: 'GlobalConnectorsList', group_types: 'GroupTypes',
    approvers: 'Approvers', users: 'UsersList'
};
const filters_get = (res: any) => {
    const ret: any = {};
    for (const k in filter_keys) {
        ret[filter_keys[k]] = res[k] ? res[k].map((o: any) => ({id: o.id,
            label: o.lbl, customData: o.data})) : null;
    }
    return ret as SystemFilters;
};

export const GeneralSystemApi = {
    getAwsData: () => {
        return new Promise((resolve) => {
            fetchRequest(`${constConfig.url.API_URL}/WebServices/SiteService.asmx/GetAwsThings`, 'post', new URLSearchParams({}).toString())
                .then((response: any) => {
                    parseString(response, (err: any, result: any) => {
                        if (result) {
                            const res = JSON.parse(result.string._);

                            if (res.Success) {
                                if (res.Response) {
                                    const responseData = JSON.parse(res.Response);
                                    resolve(responseData);
                                }
                            } else {
                                alert(res.ErrorMessage);
                                console.error('Error during getData ErrorMessage:', res.ErrorMessage);
                            }
                        }
                    });
                })

                .catch((err) => {
                    resolve(null);
                    console.log('GetJobsList failed!!!');
                });
        });
    },
    uploadBase64Image: (image_base64: string, file_name: string, file_type: any) => {
        return new Promise((resolve) => {
            fetchRequest(
                `${constConfig.url.API_URL}/WebServices/FilesService.asmx/uploadBase64Image`,
                'post',
                new URLSearchParams({ 
                    imageBase64: image_base64, 
                    fileName: file_name,
                    fileType: file_type }).toString()
            )
                .then((response: any) => {
                    parseString(response, (err: any, result: any) => {
                        if (result) {
                            const res = JSON.parse(result.string._);

                            if (res.Success) {
                                if (res.Response) {
                                    const responseData = JSON.parse(res.Response);
                                    resolve(responseData);
                                }
                            } else {
                                alert(res.ErrorMessage);
                                console.error('Error during uploadBase64Image ErrorMessage:', res.ErrorMessage);
                            }
                        }
                    });
                })

                .catch((err) => {
                    resolve(null);
                    console.log('uploadBase64Image failed!!!');
                });
        });
    },
    uploadFile: (file:File, file_name: string, file_type: any,image_base64: string) => {
        return new Promise((resolve,reject) => {
            fetchRequest(
                `${constConfig.url.API_URL}/WebServices/FilesService.asmx/UploadFile`,
                'post',
                JSON.stringify({ 
                    imageBase64: image_base64, 
                    fileName: file_name,
                    fileType: file_type 
                }),
                true,
                file
            )
                .then((res: any) => {
                    if (res.Success) {
                        if (res.Response) {
                            const responseData = JSON.parse(res.Response);
                            resolve(responseData);
                        }
                    } else {
                        console.error('Error during uploadFile ErrorMessage:', res.ErrorMessage);
                        reject(new Error(res.ErrorMessage));
                    }
                })
                .catch((err) => {
                    reject(err);
                    console.log('uploadFile failed!!!');
                });
        });
    },
    getAutocompleteAddress: (address_search: string) => {
        return new Promise((resolve) => {
            fetchRequest(
                `${constConfig.url.API_URL}/WebServices/MainService.asmx/AutocompleteAddress`,
                'post',
                new URLSearchParams({ address: address_search }).toString()
            )
                .then((response: any) => {
                    parseString(response, (err: any, result: any) => {
                        if (result) {
                            const res = JSON.parse(result.string._);

                            if (res.Success) {
                                if (res.Response) {
                                    const responseData = JSON.parse(res.Response);
                                    resolve(responseData);
                                }
                            } else {
                                console.error('Error during AutocompleteAddress ErrorMessage:', res.ErrorMessage);
                            }
                        }
                    });
                })

                .catch((err) => {
                    resolve(null);
                    console.error('AutocompleteAddress failed!!!', err);
                });
        });
    },
    getFilters: (filters: FilterType[]) => {
        if (is_bs_app) {
            return fetch_app('/private/filter/get.json', {filters})
                .then((res: any) => {
                    if (res.err)
                        throw new Error(res.err);
                    return filters_get(res);
                });
        }
        // XXX colin: remove the asmx path once back_app is on prod
        return new Promise<SystemFilters>((resolve, reject) => {
            fetchRequest(
                `${constConfig.url.API_URL}/WebServices/MainService.asmx/GetFilters`,
                'post',
                new URLSearchParams({ filters: filters.join(',') }).toString()
            )
                .then((response: any) => {
                    parseString(response, (err: any, result: any) => {
                        if (result) {
                            const res = JSON.parse(result.string._);

                            if (res.Success) {
                                if (res.Response) {
                                    const responseData = JSON.parse(res.Response);
                                    resolve(responseData);
                                }
                            } else {
                                reject(new Error(res.ErrorMessage));
                                console.error('Error during getFilters ErrorMessage:', res.ErrorMessage);
                            }
                        }
                    });
                })

                .catch((err) => {
                    reject(err);
                    console.error('getFilters failed!!!', err);
                });
        });
    },
    sendNotification: (notificationType:NotificationTypeEnum, to: string,cc: string,subject: string,body: string,attachment?:EmailAttachment) => {
      if (is_bs_app) {
          return fetch_app('/private/notification/send.json', {
              type: notificationType, to, cc, subject, body,
              attach: attachment ? {file_name: attachment.fileName,
                  content_type: attachment.contentType,
                  base64: attachment.base64} : undefined
          }).then((res: any) => {
              if (res.err)
                  throw new Error(res.err);
              return true;
          });
      }
      // XXX colin: remove the asmx path once back_app is on prod
      return new Promise((resolve, reject) => {
                    fetchRequest(
                        `${constConfig.url.API_URL + main_path}/SendNotification`,
                        'post',
                         JSON.stringify({notificationType, to,cc,subject, body,
                            attachment: attachment ? JSON.stringify(attachment) : ''
                           }),
                        true 
                    )
                        .then((res: any) => {
                            if (res.Success) {
                                resolve(true);
                            } else {
                                console.error('Error during sendNotification ErrorMessage:', res.ErrorMessage);
                                reject(new Error(res.ErrorMessage));
                            }
                        }).catch((err) => {
                            reject(err);
                            console.log('setChannelAuth failed!!!', err);
                        });
                });
            }
    // getTargetFieldTypes: () => {
    //     return new Promise((resolve, reject) => {
    //         fetchRequest(
    //             `${constConfig.url.API_URL}/WebServices/MainService.asmx/GetTargetFieldTypes`,
    //             'post',
    //             new URLSearchParams().toString()
    //         )
    //             .then((response: any) => {
    //                 parseString(response, (err: any, result: any) => {
    //                     if (result) {
    //                         const res = JSON.parse(result.string._);

    //                         if (res.Success) {
    //                             if (res.Response) {
    //                                 const responseData = JSON.parse(res.Response);
    //                                 resolve(responseData);
    //                             }
    //                         } else {
    //                             reject(res.ErrorMessage);
    //                             console.error('Error during getTargetFieldTypes ErrorMessage:', res.ErrorMessage);
    //                         }
    //                     }
    //                 });
    //             })

    //             .catch((err) => {
    //                 reject(err);
    //                 console.error('getTargetFieldTypes failed!!!', err);
    //             });
    //     });
    // },
   
};

const global_settings_path = '/WebServices/GlobalSettingsService.asmx';
export const GlobalSettingsApi = {
    ChannelTypes:{
    getGlobalChannelTypesList: () => {
        return new Promise((resolve) => {
            fetchRequest(
                `${constConfig.url.API_URL + global_settings_path}/GetGlobalChannelTypesList`,
                'post',
                new URLSearchParams({}).toString()
            )
                .then((response: any) => {
                    parseString(response, (err: any, result: any) => {
                        if (result) {
                            const res = JSON.parse(result.string._);

                            if (res.Success) {
                                if (res.Response) {
                                    const responseData = JSON.parse(res.Response);
                                    resolve(responseData);
                                }
                            } else {
                                console.error('Error during getGlobalChannelTypesList ErrorMessage:', res.ErrorMessage);
                            }
                        }
                    });
                })

                .catch((err) => {
                    resolve(null);
                    console.log('getGlobalChannelTypesList failed!!!');
                });
        });
    },
    getGlobalChannelInfo: (id:number) => {
        return new Promise((resolve) => {
            fetchRequest(
                `${constConfig.url.API_URL + global_settings_path}/GetGlobalChannelInfo`,
                'post',
                new URLSearchParams({channelId:id.toString()}).toString()
            )
                .then((response: any) => {
                    parseString(response, (err: any, result: any) => {
                        if (result) {
                            const res = JSON.parse(result.string._);

                            if (res.Success) {
                                if (res.Response) {
                                    const responseData = JSON.parse(res.Response);
                                    resolve(responseData);
                                }
                            } else {
                                console.error('Error during getMediaChannelInfo ErrorMessage:', res.ErrorMessage);
                            }
                        }
                    });
                })

                .catch((err) => {
                    resolve(null);
                    console.log('getMediaChannelInfo failed!!!');
                });
        });
    },
    saveGlobalChannel: (item:any) => {
        return new Promise((resolve) => {
            fetchRequest(
                `${constConfig.url.API_URL + global_settings_path}/SaveGlobalChannel`,
                'post',
                new URLSearchParams({ 
                    globalChannel:JSON.stringify(item),
                 }).toString()
            )
                .then((response: any) => {
                   // console.log(response);
                    parseString(response, (err: any, result: any) => {
                        if (result) {
                            const res = JSON.parse(result.string._);

                            if (res.Success) {
                                const responseData = JSON.parse(res.Response);
                                resolve(responseData);
                              
                            } else {
                                console.error('Error during SaveGlobalChannel ErrorMessage:', res.ErrorMessage);
                                resolve(res);
                            }
                        }
                    });
                })
                .catch((err) => {
                    resolve(null);
                    console.log('SaveGlobalChannel failed!!!', err);
                });
        });
    },
    deleteGlobalChannel: (id:number) => {
        return new Promise((resolve) => {
            fetchRequest(
                `${constConfig.url.API_URL + global_settings_path}/DeleteGlobalChannel`,
                'post',
                new URLSearchParams({channelId:id.toString()}).toString()
            )
                .then((response: any) => {
                    parseString(response, (err: any, result: any) => {
                        if (result) {
                            const res = JSON.parse(result.string._);

                            if (res.Success) {
                                resolve(true);
                                
                            } else {
                                if (res.Response) {
                                    const responseData = JSON.parse(res.Response);
                                    resolve(responseData);
                                }
                                console.error('Error during getGlobalCampaignInfo ErrorMessage:', res.ErrorMessage);
                            }
                        }
                    });
                })

                .catch((err) => {
                    resolve(null);
                    console.log('getGlobalCampaignInfo failed!!!');
                });
        });
    },
    getGlobalCampaignInfo: (id:number) => {
        return new Promise((resolve) => {
            fetchRequest(
                `${constConfig.url.API_URL + global_settings_path}/GetGlobalCampaignInfo`,
                'post',
                new URLSearchParams({campaignId:id.toString()}).toString()
            )
                .then((response: any) => {
                    parseString(response, (err: any, result: any) => {
                        if (result) {
                            const res = JSON.parse(result.string._);

                            if (res.Success) {
                                if (res.Response) {
                                    const responseData = JSON.parse(res.Response);
                                    resolve(responseData);
                                }
                            } else {
                                console.error('Error during getGlobalCampaignInfo ErrorMessage:', res.ErrorMessage);
                            }
                        }
                    });
                })

                .catch((err) => {
                    resolve(null);
                    console.log('getGlobalCampaignInfo failed!!!');
                });
        });
    },
    saveGlobalCampaign: (channelId:number,item:any) => {
        return new Promise((resolve) => {
            fetchRequest(
                `${constConfig.url.API_URL + global_settings_path}/SaveGlobalCampaign`,
                'post',
                new URLSearchParams({ 
                    channelId: channelId.toString(),
                    globalCampaign:JSON.stringify(item),
                 }).toString()
            )
                .then((response: any) => {
                   // console.log(response);
                    parseString(response, (err: any, result: any) => {
                        if (result) {
                            const res = JSON.parse(result.string._);

                            if (res.Success) {
                                const responseData = JSON.parse(res.Response);
                                resolve(responseData);
                              
                            } else {
                                console.error('Error during saveGlobalCampaign ErrorMessage:', res.ErrorMessage);
                                resolve(res);
                            }
                        }
                    });
                })
                .catch((err) => {
                    resolve(null);
                    console.log('saveGlobalCampaign failed!!!', err);
                });
        });
    },
    copyCampaignAndCreative:(sourseChannelId:number,targetChannelIds:string[]) => {
        return new Promise((resolve) => {
            fetchRequest(
                `${constConfig.url.API_URL + global_settings_path}/CopyCampaignAndCreative`,
                'post',
                new URLSearchParams({ 
                    sourseChannelId:sourseChannelId.toString(),
                    targetChannelIds:targetChannelIds.toString(),
                 }).toString()
            )
                .then((response: any) => {
                   // console.log(response);
                    parseString(response, (err: any, result: any) => {
                        if (result) {
                            const res = JSON.parse(result.string._);
                            resolve(res.Success);
                            if (!res.Success) {
                                console.error('Error during copyCampaignAndCreative ErrorMessage:', res.ErrorMessage);
                            } 
                        }
                    });
                })
                .catch((err) => {
                    resolve(null);
                    console.log('copyCampaignAndCreative failed!!!', err);
                });
        });
    }
    },
    Connectors:{
        getGlobalConnectorsList: () => {
            return new Promise((resolve) => {
                fetchRequest(
                    `${constConfig.url.API_URL + global_settings_path}/GetGlobalConnectorsList`,
                    'post',
                    new URLSearchParams().toString()
                )
                    .then((response: any) => {
                        parseString(response, (err: any, result: any) => {
                            if (result) {
                                const res = JSON.parse(result.string._);
    
                                if (res.Success) {
                                    if (res.Response) {
                                        const responseData = JSON.parse(res.Response);
                                        resolve(responseData);
                                    }
                                } else {
                                    console.error('Error during getGlobalConnectorsList ErrorMessage:', res.ErrorMessage);
                                }
                            }
                        });
                    })
    
                    .catch((err) => {
                        resolve(null);
                        console.log('getGlobalConnectorsList failed!!!');
                    });
            });
        },
    
        getGlobalConnectorInfo: (id: any) => {
            return new Promise((resolve) => {
                fetchRequest(
                    `${constConfig.url.API_URL + global_settings_path}/GetGlobalConnectorInfo`,
                    'post',
                    new URLSearchParams({ connectorId: id }).toString()
                )
                    .then((response: any) => {
                        parseString(response, (err: any, result: any) => {
                            if (result) {
                                const res = JSON.parse(result.string._);
    
                                if (res.Success) {
                                    if (res.Response) {
                                        const responseData = JSON.parse(res.Response);
                                        resolve(responseData);
                                    }
                                } else {
                                    console.error('Error during getGlobalConnectorInfo ErrorMessage:', res.ErrorMessage);
                                }
                            }
                        });
                    })
    
                    .catch((err) => {
                        resolve(null);
                        console.log('getGlobalConnectorInfo failed!!!', err);
                    });
            });
        },
    
        saveGlobalConnector: (connector: any) => {
            
            return new Promise((resolve) => {
                fetchRequest(
                    `${constConfig.url.API_URL + global_settings_path}/SaveGlobalConnector`,
                    'post',
                    new URLSearchParams({ 
                        connector: JSON.stringify(connector) }).toString()
                )
                    .then((response: any) => {
                        parseString(response, (err: any, result: any) => {
                            if (result) {
                                const res = JSON.parse(result.string._);
    
                                if (res.Success) {
                                    if (res.Response) {
                                        const responseData = JSON.parse(res.Response);
                                        resolve(responseData);
                                    }
                                } else {
                                    console.error('Error during saveGlobalConnector ErrorMessage:', res.ErrorMessage);
                                    resolve(res.ErrorMessage);
                                }
                            }
                        });
                    })
                    .catch((err) => {
                        resolve(null);
                        console.log('saveGlobalConnector failed!!!', err);
                    });
            });
        },
        deleteGlobalConnector: (id: any) => {
            return new Promise((resolve) => {
                fetchRequest(
                    `${constConfig.url.API_URL + global_settings_path}/DeleteGlobalConnector`,
                    'post',
                    new URLSearchParams({ connectorId: id }).toString()
                )
                    .then((response: any) => {
                        parseString(response, (err: any, result: any) => {
                            if (result) {
                                const res = JSON.parse(result.string._);
    
                                if (res.Success) {
                                    if (res.Response) {
                                        const responseData = JSON.parse(res.Response);
                                        resolve(responseData);
                                    }
                                } else {
                                    console.error('Error during deleteGlobalConnector ErrorMessage:', res.ErrorMessage);
                                }
                            }
                        });
                    })
    
                    .catch((err) => {
                        resolve(null);
                        console.log('deleteGlobalConnector failed!!!', err);
                    });
            });
        }
    },
    AI:{
        getGlobalPrompt: (promptType: PromptTypeEnum,outputType:OutputTypeEnum)=>{
            return new Promise((resolve,reject) => {
                fetchRequest(
                    `${constConfig.url.API_URL + global_settings_path}/GetGlobalPrompt`,
                    'post',
                    new URLSearchParams({ 
                        promptType:promptType.toString(),
                        outputType: outputType.toString()
                     }).toString()
                )
                    .then((response: any) => {
                       // console.log(response);
                        parseString(response, (err: any, result: any) => {
                            if (result) {
                                const res = JSON.parse(result.string._);
    
                                if (res.Success) {
                                    
                                    if (res.Response) {
                                        const responseData = JSON.parse(res.Response);
                                        resolve(responseData);
                                    }
                                  
                                } else {
                                    console.error('Error during getGlobalPrompt ErrorMessage:', res.ErrorMessage);
                                    reject(new Error(res.ErrorMessage));
                                }
                            }
                        });
                    })
                    .catch((err) => {
                        reject(new Error(err.message));
                        console.log('getGlobalPrompt failed!!!', err);
                    });
            });
        },
        saveGlobalPrompt: (promptType: PromptTypeEnum, outputType: OutputTypeEnum, promptContent:string)=>{
            return new Promise((resolve,reject) => {
                fetchRequest(
                    `${constConfig.url.API_URL + global_settings_path}/SaveGlobalPrompt`,
                    'post',
                    new URLSearchParams({ 
                        promptType:promptType.toString(),
                        outputType: outputType.toString(),
                        promptContentB64: promptContent
                     }).toString()
                )
                    .then((response: any) => {
                       // console.log(response);
                        parseString(response, (err: any, result: any) => {
                            if (result) {
                                const res = JSON.parse(result.string._);
    
                                if (res.Success) {
                                    
                                    resolve(true);
                                  
                                } else {
                                    console.error('Error during saveGlobalPrompt ErrorMessage:', res.ErrorMessage);
                                    reject(new Error(res.ErrorMessage));
                                }
                            }
                        });
                    })
                    .catch((err) => {
                        reject(new Error(err.message));
                        console.log('saveGlobalPrompt failed!!!', err);
                    });
            });
        },
        getAiConfig:() => {
            return new Promise((resolve) => {
                fetchRequest(
                    `${constConfig.url.API_URL + global_settings_path}/GetAiConfig`,
                    'post',
                    new URLSearchParams({}).toString()
                )
                    .then((response: any) => {
                        parseString(response, (err: any, result: any) => {
                            if (result) {
                                const res = JSON.parse(result.string._);
    
                                if (res.Success) {
                                    if (res.Response) {
                                        const responseData = JSON.parse(res.Response);
                                        resolve(responseData);
                                    }
                                } else {
                                    console.error('Error during getAiConfig ErrorMessage:', res.ErrorMessage);
                                }
                            }
                        });
                    })
    
                    .catch((err) => {
                        resolve(null);
                        console.log('getAiConfig failed!!!');
                    });
            });
        },
        // features a system admin turns on per agency (org.Org.Features):
        // {features, orgs: [{ID, Name, Active, Features}]} or {err}
        org_features_get: ()=>new Promise<any>((resolve)=>{
            fetchRequest(`${constConfig.url.API_URL+global_settings_path}/GetOrgFeatures`, 'post',
                new URLSearchParams({}).toString())
            .then((response: any)=>parseString(response, (err: any, result: any)=>{
                if (!result)
                    return resolve({err: err || 'no response'});
                let res = JSON.parse(result.string._);
                if (!res.Success)
                    return resolve({err: res.ErrorMessage});
                let data = JSON.parse(res.Response);
                resolve({features: data.Features, orgs: data.Orgs});
            }))
            .catch((err)=>resolve({err: String(err)}));
        }),
        // {} or {err}
        org_feature_set: ({org_id = undefined, feature = undefined, is_on = undefined}:
            {org_id?: number, feature?: string, is_on?: boolean})=>new Promise<any>((resolve)=>{
            fetchRequest(`${constConfig.url.API_URL+global_settings_path}/SaveOrgFeature`, 'post',
                new URLSearchParams({orgId: String(org_id), feature: feature || '', isOn: String(!!is_on)}).toString())
            .then((response: any)=>parseString(response, (err: any, result: any)=>{
                if (!result)
                    return resolve({err: err || 'no response'});
                let res = JSON.parse(result.string._);
                resolve(res.Success ? {} : {err: res.ErrorMessage});
            }))
            .catch((err)=>resolve({err: String(err)}));
        }),
        getOpenAiConfig: () => {
            return new Promise((resolve) => {
                fetchRequest(
                    `${constConfig.url.API_URL + global_settings_path}/GetOpenAiConfig`,
                    'post',
                    new URLSearchParams({}).toString()
                )
                    .then((response: any) => {
                        parseString(response, (err: any, result: any) => {
                            if (result) {
                                const res = JSON.parse(result.string._);
    
                                if (res.Success) {
                                    if (res.Response) {
                                        const responseData = JSON.parse(res.Response);
                                        resolve(responseData);
                                    }
                                } else {
                                    console.error('Error during getPerformanceExConfig ErrorMessage:', res.ErrorMessage);
                                }
                            }
                        });
                    })
    
                    .catch((err) => {
                        resolve(null);
                        console.log('getPerformanceExConfig failed!!!');
                    });
            });
        },
        saveOpenAiConfig: (item:any) => {
            return new Promise((resolve,reject) => {
                fetchRequest(
                    `${constConfig.url.API_URL + global_settings_path}/SaveOpenAiConfig`,
                    'post',
                    new URLSearchParams({ 
                        settings:JSON.stringify(item),
                     }).toString()
                )
                    .then((response: any) => {
                        parseString(response, (err: any, result: any) => {
                            if (result) {
                                const res = JSON.parse(result.string._);
    
                                if (res.Success) {
                                    resolve(true);
                                } else {
                                    reject(new Error(res.ErrorMessage))
                                    console.error('Error during savePerformanceExConfig ErrorMessage:', res.ErrorMessage);
                                }
                            }
                        });
                    })
    
                    .catch((err) => {
                        reject(new Error("Operation Failed"))
                        console.log('savePerformanceExConfig failed!!!');
                    });
            });
        },
        getClaudeConfig: () => {
            return new Promise((resolve) => {
                fetchRequest(
                    `${constConfig.url.API_URL + global_settings_path}/GetClaudeConfig`,
                    'post',
                    new URLSearchParams({}).toString()
                )
                    .then((response: any) => {
                        parseString(response, (err: any, result: any) => {
                            if (result) {
                                const res = JSON.parse(result.string._);
    
                                if (res.Success) {
                                    if (res.Response) {
                                        const responseData = JSON.parse(res.Response);
                                        resolve(responseData);
                                    }
                                } else {
                                    console.error('Error during getPerformanceExConfig ErrorMessage:', res.ErrorMessage);
                                }
                            }
                        });
                    })
    
                    .catch((err) => {
                        resolve(null);
                        console.log('getPerformanceExConfig failed!!!');
                    });
            });
        },
        saveClaudeConfig: (item:any) => {
            return new Promise((resolve,reject) => {
                fetchRequest(
                    `${constConfig.url.API_URL + global_settings_path}/SaveClaudeConfig`,
                    'post',
                    new URLSearchParams({ 
                        settings:JSON.stringify(item),
                     }).toString()
                )
                    .then((response: any) => {
                        parseString(response, (err: any, result: any) => {
                            if (result) {
                                const res = JSON.parse(result.string._);
    
                                if (res.Success) {
                                    resolve(true);
                                } else {
                                    reject(new Error(res.ErrorMessage))
                                    console.error('Error during saveClaudeConfig ErrorMessage:', res.ErrorMessage);
                                }
                            }
                        });
                    })
    
                    .catch((err) => {
                        reject(new Error("Operation Failed"))
                        console.log('saveClaudeConfig failed!!!');
                    });
            });
        },
        savePresentationTemplate: (file:File, promptType: PromptTypeEnum) => {
                return new Promise((resolve,reject) => {
                    fetchRequest(
                        `${constConfig.url.API_URL + global_settings_path}/SavePresentationTemplate`,
                        'post',
                        JSON.stringify({promptType}),
                        true,
                        file
                    )
                        .then((res: any) => {
                            if (res.Success) {
                                resolve(true);
                            } else {
                                console.error('Error during savePresentationTemplate ErrorMessage:', res.ErrorMessage);
                                reject(new Error(res.ErrorMessage));
                            }
                        })
                        .catch((err) => {
                            reject(err);
                            console.log('uploadFile failed!!!');
                        });
                });
            },
    }
    
   
    

};

const media_mix_path = '/WebServices/MediaMixService.asmx';
export const MediaMixApi = {    
    getMediaMixesList: (activityId:any) => {
        return new Promise((resolve) => {
            fetchRequest(
                `${constConfig.url.API_URL + media_mix_path}/GetMediaMixesList`,
                'post',
                new URLSearchParams({activityId}).toString()
            )
                .then((response: any) => {
                    parseString(response, (err: any, result: any) => {
                        if (result) {
                            const res = JSON.parse(result.string._);

                            if (res.Success) {
                                if (res.Response) {
                                    const responseData = JSON.parse(res.Response);
                                    resolve(responseData);
                                }
                            } else {
                                console.error('Error during getMediaMixesList ErrorMessage:', res.ErrorMessage);
                            }
                        }
                    });
                })

                .catch((err) => {
                    resolve(null);
                    console.log('getMediaMixesList failed!!!');
                });
        });
    },
    getMediaMixInfo: (id: any) => {
        return new Promise((resolve) => {
            fetchRequest(
                `${constConfig.url.API_URL + media_mix_path}/GetMediaMixInfo`,
                'post',
                new URLSearchParams({ mediaMixId: id }).toString()
            )
                .then((response: any) => {
                    parseString(response, (err: any, result: any) => {
                        if (result) {
                            const res = JSON.parse(result.string._);

                            if (res.Success) {
                                if (res.Response) {
                                    const responseData = JSON.parse(res.Response);
                                    resolve(responseData);
                                }
                            } else {
                                console.error('Error during getCampaignInfo ErrorMessage:', res.ErrorMessage);
                            }
                        }
                    });
                })

                .catch((err) => {
                    resolve(null);
                    console.log('getCampaignInfo failed!!!', err);
                });
        });
    },
    copyMediaMix: (id: any) => {
        return new Promise((resolve) => {
            fetchRequest(
                `${constConfig.url.API_URL + media_mix_path}/CopyMediaMix`,
                'post',
                new URLSearchParams({ mediaMixId: id }).toString()
            )
                .then((response: any) => {
                    parseString(response, (err: any, result: any) => {
                        if (result) {
                            const res = JSON.parse(result.string._);

                            if (res.Success) {
                                if (res.Response) {
                                    const responseData = JSON.parse(res.Response);
                                    resolve(responseData);
                                }
                            } else {
                                console.error('Error during getCampaignInfo ErrorMessage:', res.ErrorMessage);
                            }
                        }
                    });
                })

                .catch((err) => {
                    resolve(null);
                    console.log('getCampaignInfo failed!!!', err);
                });
        });
    },
    // rows of a published plan that copyMediaMix unlinks: linked through the
    // connectors of the account's old parent (activity transfer). {Rows}
    foreign_links_get: (media_mix_id: number) => new Promise<any>((resolve, reject) => {
        fetchRequest(`${constConfig.url.API_URL + media_mix_path}/MediaMixForeignLinksGet`,
            'post', JSON.stringify({mediaMixId: media_mix_id}), true)
            .then((res: any) => {
                if (!res.Success)
                    return reject(new Error(res.ErrorMessage));
                resolve(res.Response ? JSON.parse(res.Response) : {Rows: 0});
            })
            .catch(reject);
    }),

    createMediaMix: (activityId: number,media_mix?: any,templateId?:number) => {
        return new Promise((resolve) => {
            fetchRequest(
                `${constConfig.url.API_URL + media_mix_path}/CreateMediaMix`,
                'post',
                new URLSearchParams({ 
                    activityId: activityId.toString(),
                    mediaMix: JSON.stringify(media_mix),
                    templateId: templateId ? templateId.toString() : '-1' }).toString(),
                    
            )
                .then((response: any) => {
                    parseString(response, (err: any, result: any) => {
                        if (result) {
                            const res = JSON.parse(result.string._);

                            if (res.Success) {
                                if (res.Response) {
                                    const new_media_mix_id = helper.getNumeric(res.Response);
                                    resolve(new_media_mix_id);
                                }
                            } else {
                                console.error('Error during createMediaMix ErrorMessage:', res.ErrorMessage);
                                resolve(res.ErrorMessage);
                            }
                        }
                    });
                })
                .catch((err) => {
                    resolve(null);
                    console.log('createMediaMix failed!!!', err);
                });
        });
    },
    
    updateMediaMix: (media_mix: any) => {
        return new Promise((resolve) => {
            fetchRequest(
                `${constConfig.url.API_URL + media_mix_path}/UpdateMediaMix`,
                'post',
                new URLSearchParams({ mediaMix: JSON.stringify(media_mix) }).toString()
            )
                .then((response: any) => {
                    parseString(response, (err: any, result: any) => {
                        if (result) {
                            const res = JSON.parse(result.string._);

                            if (res.Success) {
                                if (res.Response) {
                                    const responseData = JSON.parse(res.Response);
                                    resolve(responseData);
                                }
                            } else {
                                console.error('Error during saveMediaMix ErrorMessage:', res.ErrorMessage);
                                resolve(res.ErrorMessage);
                            }
                        }
                    });
                })
                .catch((err) => {
                    resolve(null);
                    console.log('saveMediaMix failed!!!', err);
                });
        });
    },
    deleteMediaMix: (id: any) => {
        return new Promise((resolve) => {
            fetchRequest(
                `${constConfig.url.API_URL + media_mix_path}/DeleteMediaMix`,
                'post',
                new URLSearchParams({ mediaMixId: id }).toString()
            )
                .then((response: any) => {
                    parseString(response, (err: any, result: any) => {
                        if (result) {
                            const res = JSON.parse(result.string._);

                            if (res.Success) {
                                if (res.Response) {
                                    const responseData = JSON.parse(res.Response);
                                    resolve(responseData);
                                }
                            } else {
                                console.error('Error during deleteCampaign ErrorMessage:', res.ErrorMessage);
                            }
                        }
                    });
                })

                .catch((err) => {
                    resolve(null);
                    console.log('deleteCampaign failed!!!', err);
                });
        });
    },
   
    sendMediaMixToClient: (media_mix_id:number) => {
        return new Promise((resolve,reject) => {
            fetchRequest(
                `${constConfig.url.API_URL + media_mix_path}/SendMediaMixToClient`,
                'post',
                new URLSearchParams({ mediaMixId: media_mix_id.toString() }).toString()
            )
                .then((response: any) => {
                    parseString(response, (err: any, result: any) => {
                        if (result) {
                            const res = JSON.parse(result.string._);

                            if (res.Success) {
                                if (res.Response) {
                                    const responseData = JSON.parse(res.Response);
                                    resolve(responseData);
                                }
                            } else {
                                console.error('Error during sendMediaMixToClient ErrorMessage:', res.ErrorMessage);
                                reject(new Error(res.ErrorMessage));
                            }
                        }
                    });
                })
                .catch((err) => {
                    reject(err);
                    console.log('sendMediaMixToClient failed!!!', err);
                });
        });
    },
    getMediaMixDetailed: (media_mix_id:any) => {
        return new Promise((resolve,reject) => {
            fetchRequest(
                `${constConfig.url.API_URL + media_mix_path}/getMediaMixDetailed`,
                'post',
                new URLSearchParams({mediaMixId:media_mix_id}).toString()
            )
                .then((response: any) => {
                    parseString(response, (err: any, result: any) => {
                        if (result) {
                            const res = JSON.parse(result.string._);

                            if (res.Success) {
                                if (res.Response) {
                                    const responseData = JSON.parse(res.Response);
                                    resolve(responseData);
                                }
                            } else {
                                reject(new Error(res.ErrorMessage || 'failed getting media mix'));
                                console.error('Error during getMediaMixDetailed ErrorMessage:', res.ErrorMessage);
                            }
                        } else {
                            reject(new Error('failed getting media mix'));
                        }
                    });
                })

                .catch((err) => {
                    reject(err);
                    console.log('getMediaMixDetailed failed!!!');
                });
        });
    },
    
    saveMediaMixCustomGrid: (id: any,fields:string[],field_name:string) => {
        return new Promise((resolve,reject) => {
            fetchRequest(
                `${constConfig.url.API_URL + media_mix_path}/UpdateMediaMixCustomGrid`,
                'post',
                new URLSearchParams({ 
                    runId: id, 
                    fieldName: field_name, 
                    fieldVal: fields.join('~') 
                }).toString()
            )
                .then((response: any) => {
                    parseString(response, (err: any, result: any) => {
                        if (result) {
                            const res = JSON.parse(result.string._);

                            if (res.Success) {
                                resolve(true);
                            } else {
                                reject(new Error( res.ErrorMessage));
                                console.error('Error during saveMediaMixCustomGrid ErrorMessage:', res.ErrorMessage);
                            }
                        }
                    });
                })

                .catch((err) => {
                    reject(err);
                    console.log('saveMediaMixCustomGrid failed!!!', err);
                });
        });
    },
    getDynamicFieldsDetailed: () => {
        return new Promise((resolve) => {
            fetchRequest(
                `${constConfig.url.API_URL + media_mix_path}/GetDynamicFieldsDetailed`,
                'post',
                new URLSearchParams().toString()
            )
                .then((response: any) => {
                    parseString(response, (err: any, result: any) => {
                        if (result) {
                            const res = JSON.parse(result.string._);

                            if (res.Success) {
                                if (res.Response) {
                                    const responseData = JSON.parse(res.Response);
                                    resolve(responseData);
                                }
                            } else {
                                console.error('Error during GetDynamicFieldsDetailed ErrorMessage:', res.ErrorMessage);
                            }
                        }
                    });
                })

                .catch((err) => {
                    resolve(null);
                    console.log('GetDynamicFieldsDetailed failed!!!', err);
                });
        });
    },
    MediaMix :{
        publishMediaMix : (media_mix_id:number) => {
            return new Promise((resolve,reject) => {
                fetchRequest(
                    `${constConfig.url.API_URL + media_mix_path}/PublishMediaMix`,
                    'post',
                    new URLSearchParams({ 
                        mediaMixId: media_mix_id.toString()
                    }).toString()
                )
                    .then((response: any) => {
                        parseString(response, (err: any, result: any) => {
                            if (result) {
                                const res = JSON.parse(result.string._);

                                if (res.Success) {
                                    resolve(true);
                                } else {
                                    let error: any = new Error(res.ErrorMessage);
                                    // a blocked line start date change: GetRowStartDateCheck result
                                    if (res.Response)
                                        error.start_check = JSON.parse(res.Response);
                                    reject(error);
                                    console.error('Error during publishMediaMix ErrorMessage:', res.ErrorMessage);
                                }
                            }
                        });
                    })
                    .catch((err) => {
                        reject(err);
                        console.log('publishMediaMix failed!!!', err);
                    });
            });
        }, 
        unpublishMediaMix : (media_mix_id:number) => {
            return new Promise((resolve,reject) => {
                fetchRequest(
                    `${constConfig.url.API_URL + media_mix_path}/UnpublishMediaMix`,
                    'post',
                    JSON.stringify({ 
                        mediaMixId: media_mix_id.toString() 
                    }),
                    true // send json i.o. urlencoded
                ).then((res: any) => {                        
                        if (res.Success) {
                            resolve(true);
                        } else {
                            reject(new Error(res.ErrorMessage));
                            console.error('Error during unpublishMediaMix ErrorMessage:', res.ErrorMessage);
                        }
                    })
                    .catch((err) => {
                        reject(err);
                        console.log('unpublishMediaMix failed!!!', err);
                    });
            });
        }, 
    },
    MediaMixChannel:{
        initMediaMixChannelTypes: () => {
            return new Promise((resolve,reject) => {
                fetchRequest(
                    `${constConfig.url.API_URL + media_mix_path}/InitMediaMixChannelTypes`,
                    'post',
                    new URLSearchParams().toString()
                )
                    .then((response: any) => {
                        parseString(response, (err: any, result: any) => {
                            if (result) {
                                const res = JSON.parse(result.string._);
    
                                if (res.Success) {
                                    if (res.Response) {
                                        const responseData = JSON.parse(res.Response);
                                        resolve(responseData);
                                    }
                                } else {
                                    reject(new Error(res.ErrorMessage));
                                    console.error('Error during initMediaMixChannelTypes ErrorMessage:', res.ErrorMessage);
                                }
                            }
                        });
                    })
                    .catch((err) => {
                        reject(new Error('operation failed'));
                        console.log('initMediaMixChannelTypes failed!!!');
                    });
            });
        },
        createMediaMixChannel: (mediaMixId: number) => {
            return new Promise((resolve) => {
                fetchRequest(
                    `${constConfig.url.API_URL + media_mix_path}/CreateMediaMixChannel`,
                    'post',
                    new URLSearchParams({ mediaMixId: mediaMixId.toString() }).toString()
                )
                    .then((response: any) => {
                        parseString(response, (err: any, result: any) => {
                            if (result) {
                                const res = JSON.parse(result.string._);
    
                                if (res.Success) {
                                    if (res.Response) {
                                        const new_media_mix_channel_id = helper.getNumeric(res.Response);
                                        resolve(new_media_mix_channel_id);
                                    }
                                } else {
                                    console.error('Error during createMediaMixChannel ErrorMessage:', res.ErrorMessage);
                                    resolve(res.ErrorMessage);
                                }
                            }
                        });
                    })
                    .catch((err) => {
                        resolve(null);
                        console.log('createMediaMixChannel failed!!!', err);
                    });
            });
        },
        updateMediaMixChannelField: (mediaMixGroupId:number, mediaMixChannelId: number, field_name:string, field_value:string) => { // fields: {field_name:string, field_value:string}[]) => {
            return new Promise((resolve,reject) => {
                fetchRequest(
                    `${constConfig.url.API_URL + media_mix_path}/UpdateMediaMixChannelField`,
                    'post',
                    new URLSearchParams({ 
                        mediaMixGroupId: mediaMixGroupId.toString(),
                        mediaMixChannelId: mediaMixChannelId.toString(),
                        field_name,field_value
                       // fields:JSON.stringify(fields),
                       // fieldValue:field_value,
                       // isDynamicField:isDynamicField ? "true" : "false"
                     }).toString()
                )
                    .then((response: any) => {
                       // console.log(response);
                        parseString(response, (err: any, result: any) => {
                            if (result) {
                                const res = JSON.parse(result.string._);
    
                                if (res.Success) {
                                    const responseData = JSON.parse(res.Response);
                                    resolve(responseData);
                                } else {
                                    console.error('Error during updateMediaMixChannelField ErrorMessage:', res.ErrorMessage);
                                    reject(new Error(res.ErrorMessage));   
                                }

                            }
                        });
                    })
                    .catch((err) => {
                        reject(new Error("operation failed"));   
                        console.log('updateMediaMixChannelField failed!!!', err);
                    });
            });
        },
        updateMediaMixChannelCampaigns: (mediaMixGroupId:number, mediaMixChannelId: number, campaigns:any,campaignType:string,is_submit_fee?:boolean,is_bonus?:boolean) => { // fields: {field_name:string, field_value:string}[]) => {
            return new Promise((resolve) => {
                fetchRequest(
                    `${constConfig.url.API_URL + media_mix_path}/UpdateMediaMixChannelCampaigns`,
                    'post',
                    new URLSearchParams({ 
                        mediaMixGroupId: mediaMixGroupId.toString(),
                        mediaMixChannelId: mediaMixChannelId.toString(),
                        campaigns:JSON.stringify(campaigns),
                        campaignType,
                        isSubmitFee: is_submit_fee != undefined ? is_submit_fee.toString() : '',
                        isBonus: is_bonus != undefined ? is_bonus.toString() : '',
                     }).toString()
                )
                    .then((response: any) => {
                       // console.log(response);
                        parseString(response, (err: any, result: any) => {
                            if (result) {
                                const res = JSON.parse(result.string._);
    
                                if (res.Success) {
                                    const responseData = JSON.parse(res.Response);
                                    resolve(responseData);
                                } else {
                                    console.error('Error during updateMediaMixChannelCampaigns ErrorMessage:', res.ErrorMessage);
                                    resolve(false);   
                                }

                            }
                        });
                    })
                    .catch((err) => {
                        resolve(null);
                        console.log('updateMediaMixChannelCampaigns failed!!!', err);
                    });
            });
        },
        updateMediaMixChannelConversionAction: (mediaMixGroupId:number, mediaMixChannelId: number, field_name:string, conversions:{action_name:string,action_path:string}[]) => {
            return new Promise((resolve) => {
                fetchRequest(
                    `${constConfig.url.API_URL + media_mix_path}/UpdateMediaMixChannelConversionAction`,
                    'post',
                    new URLSearchParams({ 
                        mediaMixGroupId: mediaMixGroupId.toString(),
                        mediaMixChannelId: mediaMixChannelId.toString(),
                        field_name,
                        conversions: JSON.stringify(conversions)
                        // action_name,action_path
                     }).toString()
                )
                    .then((response: any) => {
                       // console.log(response);
                        parseString(response, (err: any, result: any) => {
                            if (result) {
                                const res = JSON.parse(result.string._);
    
                                if (res.Success) {
                                    const responseData = JSON.parse(res.Response);
                                    resolve(responseData);
                                } else {
                                    console.error('Error during updateMediaMixChannelConversionAction ErrorMessage:', res.ErrorMessage);
                                    resolve(false);   
                                }

                            }
                        });
                    })
                    .catch((err) => {
                        resolve(null);
                        console.log('updateMediaMixChannelConversionAction failed!!!', err);
                    });
            });
        },
       
        deleteMediaMixChannel: (id: any) => {
            return new Promise((resolve,reject) => {
                fetchRequest(
                    `${constConfig.url.API_URL + media_mix_path}/DeleteMediaMixChannel`,
                    'post',
                    JSON.stringify({ 
                        mediaMixChannelId: id
                    }),
                    true // send json i.o. urlencoded
                ).then((res: any) => {
                    if (res.Success) {
                        if (res.Response) {
                            const responseData = JSON.parse(res.Response);
                            resolve(responseData);
                        }
                    } else {
                        reject(new Error(res.ErrorMessage))
                        console.error('Error during deleteMediaMixChannel ErrorMessage:', res.ErrorMessage);
                    }
                }).catch((err) => {
                    reject(err);
                    console.log('deleteMediaMixChannel failed!!!', err);
                });
            });
        },
        copyMediaMixChannel: (id: any) => {
            return new Promise((resolve) => {
                fetchRequest(
                    `${constConfig.url.API_URL + media_mix_path}/CopyMediaMixChannel`,
                    'post',
                    JSON.stringify({ 
                        mediaMixChannelId: id.toString() 
                    }),
                    true // send json i.o. urlencoded
                ).then((res: any) => {                        
                    if (res.Success) {
                        if (res.Response) {
                            const responseData = JSON.parse(res.Response);
                            resolve(responseData);
                        }
                    } else {
                        console.error('Error during copyMediaMixChannel ErrorMessage:', res.ErrorMessage);
                    }
                }).catch((err) => {
                    resolve(null);
                    console.log('copyMediaMixChannel failed!!!', err);
                });
            });
        },
        saveMediaMixRowsOrder: (groupId:number, rowIds:string[]) =>{
            return new Promise((resolve) => {
                fetchRequest(
                    `${constConfig.url.API_URL + media_mix_path}/SaveMediaMixRowsOrder`,
                    'post',
                    new URLSearchParams({ 
                        groupId: groupId.toString(), 
                        rowIds: rowIds.join()  
                    }).toString()
                )
                    .then((response: any) => {
                        parseString(response, (err: any, result: any) => {
                            if (result) {
                                const res = JSON.parse(result.string._);
    
                                if (res.Success) {
                                    resolve(true);
                                } else {
                                    console.error('Error during saveMediaMixRowsOrder ErrorMessage:', res.ErrorMessage);
                                    resolve(false);
                                }
                            }
                        });
                    })
    
                    .catch((err) => {
                        resolve(false);
                        console.log('saveMediaMixRowsOrder failed!!!', err);
                    });
            });
        },
        getRowBudgetUtil: (mediaMixChannelId: any, field_name:string, field_value:string) => {
            return new Promise((resolve,reject) => {
                fetchRequest(
                    `${constConfig.url.API_URL + media_mix_path}/GetRowBudgetUtil`,
                    'post',
                    JSON.stringify({ mediaMixChannelId,
                         fieldName: field_name, 
                          fieldValue:field_value
                     }),
                    true // send json i.o. urlencoded
                ).then((res: any) => {                        
                    if (res.Success) {
                        if (res.Response) {
                            const responseData = JSON.parse(res.Response);
                            resolve(responseData);
                        }
                    } else {
                        reject(new Error(res.ErrorMessage))
                        console.error('Error during getRowBudgetUtil ErrorMessage:', res.ErrorMessage);
                    }
                }).catch((err) => {
                    reject(err);
                    console.log('getRowBudgetUtil failed!!!', err);
                });
            });
        },
        // {Ok, Reason: billing|cross_mix|spend|unverified, FromDate, ToDate,
        // Amount, Currency, CampaignName, OtherActivityName, Message}
        getRowStartDateCheck: (mediaMixChannelId: any, start_date: string) => {
            return new Promise((resolve, reject) => {
                fetchRequest(
                    `${constConfig.url.API_URL + media_mix_path}/GetRowStartDateCheck`,
                    'post',
                    JSON.stringify({mediaMixChannelId, startDate: start_date}),
                    true // send json i.o. urlencoded
                ).then((res: any) => {
                    if (!res.Success) {
                        console.error('Error during getRowStartDateCheck ErrorMessage:', res.ErrorMessage);
                        reject(new Error(res.ErrorMessage));
                        return;
                    }
                    resolve(JSON.parse(res.Response));
                }).catch((err) => {
                    console.log('getRowStartDateCheck failed!!!', err);
                    reject(err);
                });
            });
        },
    },
    DynamicField:{
        getDynamicFieldInfo: (id: any) => {
            return new Promise((resolve) => {
                fetchRequest(
                    `${constConfig.url.API_URL + media_mix_path}/GetDynamicFieldInfo`,
                    'post',
                    new URLSearchParams({ dynamicFieldId: id }).toString()
                )
                    .then((response: any) => {
                        parseString(response, (err: any, result: any) => {
                            if (result) {
                                const res = JSON.parse(result.string._);
    
                                if (res.Success) {
                                    if (res.Response) {
                                        const responseData = JSON.parse(res.Response);
                                        resolve(responseData);
                                    }
                                } else {
                                    console.error('Error during getCampaignInfo ErrorMessage:', res.ErrorMessage);
                                }
                            }
                        });
                    })
    
                    .catch((err) => {
                        resolve(null);
                        console.log('getCampaignInfo failed!!!', err);
                    });
            });
        },
        saveDynamicField: (mediaMixGroupId:number,dynamicField: any,isPerformance:boolean) => {
            return new Promise((resolve) => {
                fetchRequest(
                    `${constConfig.url.API_URL + media_mix_path}/SaveDynamicField`,
                    'post',
                    new URLSearchParams({
                        mediaMixGroupId:mediaMixGroupId.toString(), 
                        dynamicField: JSON.stringify(dynamicField),
                        isPerformance: isPerformance.toString()
                    }).toString()
                )
                    .then((response: any) => {
                        parseString(response, (err: any, result: any) => {
                            if (result) {
                                const res = JSON.parse(result.string._);
    
                                if (res.Success) {
                                    if (res.Response) {
                                        const responseData = JSON.parse(res.Response);
                                        resolve(responseData);
                                    }
                                } else {
                                    console.error('Error during saveDynamicField ErrorMessage:', res.ErrorMessage);
                                    resolve(res.ErrorMessage);
                                }
                            }
                        });
                    })
                    .catch((err) => {
                        resolve(null);
                        console.log('saveDynamicField failed!!!', err);
                    });
            });
        },
        deleteDynamicField: (id: any) => {
            return new Promise((resolve,reject) => {
                fetchRequest(
                    `${constConfig.url.API_URL + media_mix_path}/DeleteDynamicField`,
                    'post',
                    new URLSearchParams({ dynamicFieldId: id }).toString()
                )
                    .then((response: any) => {
                        parseString(response, (err: any, result: any) => {
                            if (result) {
                                const res = JSON.parse(result.string._);
    
                                if (res.Success) {
                                    if (res.Response) {
                                        const responseData = JSON.parse(res.Response);
                                        resolve(responseData);
                                    }
                                } else {
                                    reject(new Error(res.ErrorMessage));
                                    console.error('Error during deleteMediaMixChannel ErrorMessage:', res.ErrorMessage);
                                }
                            }
                        });
                    })
    
                    .catch((err) => {
                        reject(err);
                        console.log('deleteMediaMixChannel failed!!!', err);
                    });
            });
        },
        getDynamicFields: () => {
            return new Promise((resolve,reject) => {
                fetchRequest(
                    `${constConfig.url.API_URL + media_mix_path}/GetDynamicFields`,
                    'post',
                    new URLSearchParams({ }).toString()
                )
                    .then((response: any) => {
                        parseString(response, (err: any, result: any) => {
                            if (result) {
                                const res = JSON.parse(result.string._);
    
                                if (res.Success) {
                                    if (res.Response) {
                                        const responseData = JSON.parse(res.Response);
                                        resolve(responseData);
                                    }
                                } else {
                                    console.error('Error during getDynamicFields ErrorMessage:', res.ErrorMessage);
                                    reject(new Error(res.ErrorMessage));
                                }
                            }
                        });
                    })
                    .catch((err) => {
                        reject(new Error('operation failed'));
                        console.error('getDynamicFields failed!!!', err);
                    });
            });
        },
    },
    MediaMixGroup:{
        getMediaMixGroupInfo: (id: any) => {
            return new Promise((resolve) => {
                fetchRequest(
                    `${constConfig.url.API_URL + media_mix_path}/GetMediaMixGroupInfo`,
                    'post',
                    new URLSearchParams({ mediaMixGroupId: id }).toString()
                )
                    .then((response: any) => {
                        parseString(response, (err: any, result: any) => {
                            if (result) {
                                const res = JSON.parse(result.string._);
    
                                if (res.Success) {
                                    if (res.Response) {
                                        const responseData = JSON.parse(res.Response);
                                        resolve(responseData);
                                    }
                                } else {
                                    console.error('Error during getMediaMixGroupInfo ErrorMessage:', res.ErrorMessage);
                                }
                            }
                        });
                    })
    
                    .catch((err) => {
                        resolve(null);
                        console.log('getMediaMixGroupInfo failed!!!', err);
                    });
            });
        },
        createMediaMixGroup: (mediaMixId: number,copyFromGroupId?:number,copyWithData?:boolean) => {
            return new Promise((resolve) => {
                fetchRequest(
                    `${constConfig.url.API_URL + media_mix_path}/CreateMediaMixGroup`,
                    'post',
                    new URLSearchParams({ 
                        mediaMixId: mediaMixId.toString(),
                        copyFromGroupId: copyFromGroupId ? copyFromGroupId.toString() : '-1',
                        copyWithData: copyWithData ? 'true' : 'false'
                    })).then((response: any) => {
                        parseString(response, (err: any, result: any) => {
                            if (result) {
                                const res = JSON.parse(result.string._);
    
                                if (res.Success) {
                                    resolve(true);
                                } else {
                                    console.error('Error during createMediaMix ErrorMessage:', res.ErrorMessage);
                                    resolve(res.ErrorMessage);
                                }
                            }
                        });
                    })
                    .catch((err) => {
                        resolve(null);
                        console.log('createMediaMix failed!!!', err);
                    });
            });
        },
        deleteMediaMixGroup: (mediaMixGroupId:number) => {
            return new Promise((resolve) => {
                fetchRequest(
                    `${constConfig.url.API_URL + media_mix_path}/DeleteMediaMixGroup`,
                    'post',
                    new URLSearchParams({ mediaMixGroupId: mediaMixGroupId.toString() }).toString()
                )
                    .then((response: any) => {
                        parseString(response, (err: any, result: any) => {
                            if (result) {
                                const res = JSON.parse(result.string._);
    
                                if (res.Success) {
                                    resolve(true);
                                } else {
                                    console.error('Error during deleteCampaign ErrorMessage:', res.ErrorMessage);
                                }
                            }
                        });
                    })
    
                    .catch((err) => {
                        resolve(null);
                        console.log('deleteCampaign failed!!!', err);
                    });
            });
        },
        saveMediaMixGroupItem: (mediaMixId:number,item:any) => { // groupName:string, fields:string[]
            return new Promise((resolve) => {
                fetchRequest(
                    `${constConfig.url.API_URL + media_mix_path}/SaveMediaMixGroupItem`,
                    'post',
                    new URLSearchParams({ 
                        mediaMixId: mediaMixId.toString(),
                        groupItem: JSON.stringify(item)
                    }).toString()
                )
                    .then((response: any) => {
                        parseString(response, (err: any, result: any) => {
                            if (result) {
                                const res = JSON.parse(result.string._);
    
                                if (res.Success) {
                                    resolve(true);
                                } else {
                                    console.error('Error during saveMediaMixGroupItem ErrorMessage:', res.ErrorMessage);
                                    resolve(false);
                                }
                            }
                        });
                    })
    
                    .catch((err) => {
                        resolve(false);
                        console.log('saveMediaMixGroupItem failed!!!', err);
                    });
            });
        },
        updateMediaMixGroupItem: (id:number, fieldName:string, fieldValue:string) => { // groupName:string, fields:string[]
            return new Promise((resolve) => {
                fetchRequest(
                    `${constConfig.url.API_URL + media_mix_path}/UpdateMediaMixGroupItem`,
                    'post',
                    new URLSearchParams({ 
                        id: id.toString(), fieldName,fieldValue
                    }).toString()
                )
                    .then((response: any) => {
                        parseString(response, (err: any, result: any) => {
                            if (result) {
                                const res = JSON.parse(result.string._);
    
                                if (res.Success) {
                                    resolve(true);
                                } else {
                                    console.error('Error during updateMediaMixGroupItem ErrorMessage:', res.ErrorMessage);
                                    resolve(false);
                                }
                            }
                        });
                    })
    
                    .catch((err) => {
                        resolve(false);
                        console.log('updateMediaMixGroupItem failed!!!', err);
                    });
            });
        },
        saveMediaMixGroupsOrder: (mediaMixId:number, groupIds:string[]) =>{
            return new Promise((resolve) => {
                fetchRequest(
                    `${constConfig.url.API_URL + media_mix_path}/SaveMediaMixGroupsOrder`,
                    'post',
                    new URLSearchParams({ 
                        mediaMixId: mediaMixId.toString(), 
                        groupIds: groupIds.join()  
                    }).toString()
                )
                    .then((response: any) => {
                        parseString(response, (err: any, result: any) => {
                            if (result) {
                                const res = JSON.parse(result.string._);
    
                                if (res.Success) {
                                    resolve(true);
                                } else {
                                    console.error('Error during saveMediaMixGroupsOrder ErrorMessage:', res.ErrorMessage);
                                    resolve(false);
                                }
                            }
                        });
                    })
    
                    .catch((err) => {
                        resolve(false);
                        console.log('saveMediaMixGroupsOrder failed!!!', err);
                    });
            });
        }
    },
    MediaMixTemplate:{
        getMediaMixTemplates: () => {
            return new Promise((resolve) => {
                fetchRequest(
                    `${constConfig.url.API_URL + media_mix_path}/GetMediaMixTemplates`,
                    'post',
                    new URLSearchParams().toString()
                )
                    .then((response: any) => {
                        parseString(response, (err: any, result: any) => {
                            if (result) {
                                const res = JSON.parse(result.string._);
    
                                if (res.Success) {
                                    if (res.Response) {
                                        const responseData = JSON.parse(res.Response);
                                        resolve(responseData);
                                    }
                                } else {
                                    console.error('Error during getMediaMixTemplates ErrorMessage:', res.ErrorMessage);
                                }
                            }
                        });
                    })
    
                    .catch((err) => {
                        resolve(null);
                        console.log('getMediaMixTemplates failed!!!', err);
                    });
            });
        },
        saveMediaMixTemplate: (id: any,name:string,override?:boolean) => {
            return new Promise((resolve) => {
                fetchRequest(
                    `${constConfig.url.API_URL + media_mix_path}/SaveMediaMixTemplate`, 
                    'post',
                    new URLSearchParams({ 
                        mediaMixId: id, 
                        templateName: name,
                        overrideExisting: (override== true).toString() }).toString()
                )
                    .then((response: any) => {
                        parseString(response, (err: any, result: any) => {
                            if (result) {
                                const res = JSON.parse(result.string._);
    
                                if (res.Success) {
                                    if (res.Response) {
                                        const responseData = JSON.parse(res.Response);
                                        resolve(responseData);
                                    }
                                } else {
                                    resolve(res.ErrorMessage);
                                    console.error('Error during getCampaignInfo ErrorMessage:', res.ErrorMessage);
                                }
                            }
                        });
                    })
    
                    .catch((err) => {
                        resolve(null);
                        console.log('getCampaignInfo failed!!!', err);
                    });
            });
        },
        updateMediaMixTemplateName: (template_id: any,template_name:string) => {
            return new Promise((resolve) => {
                fetchRequest(
                    `${constConfig.url.API_URL + media_mix_path}/UpdateMediaMixTemplateName`, 
                    'post',
                    new URLSearchParams({ 
                        templateId: template_id, 
                        templateName: template_name
                    }).toString()
                )
                    .then((response: any) => {
                        parseString(response, (err: any, result: any) => {
                            if (result) {
                                const res = JSON.parse(result.string._);
    
                                if (res.Success) {
                                    resolve(true);
                                } else {
                                    resolve(res.ErrorMessage);
                                    console.error('Error during getCampaignInfo ErrorMessage:', res.ErrorMessage);
                                }
                            }
                        });
                    })
    
                    .catch((err) => {
                        resolve(null);
                        console.log('getCampaignInfo failed!!!', err);
                    });
            });
        },
        deleteMediaMixTemplate: (template_id: number) => {
            return new Promise((resolve) => {
                fetchRequest(
                    `${constConfig.url.API_URL + media_mix_path}/DeleteMediaMixTemplate`, 
                    'post',
                    new URLSearchParams({ 
                        templateId: template_id.toString()
                    }).toString()
                )
                    .then((response: any) => {
                        parseString(response, (err: any, result: any) => {
                            if (result) {
                                const res = JSON.parse(result.string._);
    
                                if (res.Success) {
                                    resolve(true);
                                } else {
                                    resolve(res.ErrorMessage);
                                    console.error('Error during getCampaignInfo ErrorMessage:', res.ErrorMessage);
                                }
                            }
                        });
                    })
    
                    .catch((err) => {
                        resolve(null);
                        console.log('getCampaignInfo failed!!!', err);
                    });
            });
        },
    },
   MediaMixApproval:{
    getPendingApprovals: () => {
        return new Promise((resolve,reject) => {
            fetchRequest(
                `${constConfig.url.API_URL + media_mix_path}/GetPendingApprovals`,
                'post',
                new URLSearchParams({}).toString()
            )
                .then((response: any) => {
                    parseString(response, (err: any, result: any) => {
                        if (result) {
                            const res = JSON.parse(result.string._);

                            if (res.Success) {
                                if (res.Response) {
                                    const responseData = JSON.parse(res.Response);
                                    resolve(responseData);
                                }
                            } else {
                                reject(new Error(res.ErrorMessage))
                                console.error('Error during getPendingApprovals ErrorMessage:', res.ErrorMessage);
                            }
                        }
                    });
                })

                .catch((err) => {
                    reject(err);
                    console.log('getPendingApprovals failed!!!');
                });
        });
    },
    getMediaMixApprovalRemarks: (activityId:number, mediaMixId:number)=> {
        return new Promise((resolve,reject) => {
            fetchRequest(
                `${constConfig.url.API_URL + media_mix_path}/GetMediaMixApprovalRemarks`,
                'post',
                JSON.stringify({ 
                    activityId,
                    mediaMixId 
                    }),
                    true // send json i.o. urlencoded
                ).then((res: any) => { 
                    if (res.Success) {
                        if (res.Response) {
                            const responseData = JSON.parse(res.Response);
                            resolve(responseData);
                        }
                    } else {
                        reject(new Error(res.ErrorMessage))
                        console.error('Error during getMediaMixApprovalRemarks ErrorMessage:', res.ErrorMessage);
                    }
                }).catch((err) => {
                    reject(err);
                    console.log('getMediaMixApprovalRemarks failed!!!');
                });
        });
    },
    saveMediaMixApprovalStatus: (mediaMixId:number,approveStatus:MediaMixApprovalStatusEnum,remark:string) => {
        return new Promise((resolve,reject) => {
            fetchRequest(
                `${constConfig.url.API_URL + media_mix_path}/SaveMediaMixApprovalStatus`,
                'post',
                new URLSearchParams({mediaMixId:mediaMixId.toString(),
                                     approveStatus: approveStatus.toString(),
                                     remark}).toString()
            )
                .then((response: any) => {
                    parseString(response, (err: any, result: any) => {
                        if (result) {
                            const res = JSON.parse(result.string._);

                            if (res.Success) {
                                resolve(true);
                                // if (res.Response) {
                                //     const responseData = JSON.parse(res.Response);
                                //     resolve(responseData);
                                // }
                            } else {
                                reject(new Error(res.ErrorMessage))
                                console.error('Error during saveMediaMixApprovalStatus ErrorMessage:', res.ErrorMessage);
                            }
                        }
                    });
                })

                .catch((err) => {
                    reject(err);
                    console.log('saveMediaMixApprovalStatus failed!!!');
                });
        });
    },
    updateMediaMixApprovalRemark: (mediaMixId:number,remarkId:number,remark:string) => {
        return new Promise((resolve,reject) => {
            fetchRequest(
                `${constConfig.url.API_URL + media_mix_path}/UpdateMediaMixApprovalRemark`,
                'post',
                new URLSearchParams({mediaMixId:mediaMixId.toString(),
                                     remarkId: remarkId.toString(),
                                     remark}).toString()
            )
                .then((response: any) => {
                    parseString(response, (err: any, result: any) => {
                        if (result) {
                            const res = JSON.parse(result.string._);

                            if (res.Success) {
                                resolve(true);
                                // if (res.Response) {
                                //     const responseData = JSON.parse(res.Response);
                                //     resolve(responseData);
                                // }
                            } else {
                                reject(new Error(res.ErrorMessage))
                                console.error('Error during updateMediaMixApprovalRemark ErrorMessage:', res.ErrorMessage);
                            }
                        }
                    });
                })

                .catch((err) => {
                    reject(err);
                    console.log('updateMediaMixApprovalRemark failed!!!');
                });
        });
    },
    getMediaPlanFeedbacks: (mediaMixId:number) => {
        return new Promise((resolve,reject) => {
            fetchRequest(
                `${constConfig.url.API_URL + media_mix_path}/GetMediaPlanFeedbacks`,
                'post',
                new URLSearchParams({mediaMixId:mediaMixId.toString()}).toString()
            )
                .then((response: any) => {
                    parseString(response, (err: any, result: any) => {
                        if (result) {
                            const res = JSON.parse(result.string._);

                            if (res.Success) {
                                if (res.Response) {
                                    const responseData = JSON.parse(res.Response);
                                    resolve(responseData);
                                }
                            } else {
                                reject(new Error(res.ErrorMessage))
                                console.error('Error during getMediaPlanFeedbacks ErrorMessage:', res.ErrorMessage);
                            }
                        }
                    });
                })

                .catch((err) => {
                    reject(err);
                    console.log('getMediaPlanFeedbacks failed!!!');
                });
        });
    },
    
   }
};

const reports_path = '/WebServices/ReportsService.asmx';

export type AdCreativeInfo = {
    Platform: string;
    AdId: string;
    // Meta: "vid:<video ids>", "img:<image hashes>" or "cr:<creative id>"; TikTok: "vid:<video id>", "img:<image ids>" or "post:<post id>"
    Key?: string;
    // TikTok: the ad text
    AdText?: string;
    // TikTok spark ads (Key "post:<TikTok post id>"): the post in TikTok's player
    PostUrl?: string;
    Thumbnail?: string;
    // Meta image ads: the original image
    FullImage?: string;
    // Google search ads
    Headlines?: string[];
    Descriptions?: string[];
    FinalUrl?: string;
};
// the account-level creative report (ReportsService: GetAccountCampaignOptions, ...)
export type AccountCampaignOption = { Id: string; Name: string; AdAccountId: string };
export type AccountAdSetOption = { Id: string; Name: string; CampaignId: string };
const accountCreativesCall = <T,>(method: string, params: Record<string, any>): Promise<T> =>
    new Promise((resolve, reject) => {
        fetchRequest(`${constConfig.url.API_URL + reports_path}/${method}`, 'post', JSON.stringify(params), true)
            .then((res: any) => {
                if (res?.Success) {
                    resolve(res.Response ? JSON.parse(res.Response) : null);
                } else {
                    reject(new Error(res?.ErrorMessage || method + ' failed'));
                }
            })
            .catch(reject);
    });


export const ReportsApi = {
    MediaPlan: {
        getMediaMixLastRequest: (mediaMixId:number) => {
            return new Promise((resolve,reject) => {
                fetchRequest(
                    `${constConfig.url.API_URL + reports_path}/GetMediaMixLastRequest`,
                    'post',
                    new URLSearchParams({mediaMixId: mediaMixId.toString()}).toString()
                )
                    .then((response: any) => {
                        parseString(response, (err: any, result: any) => {
                            if (result) {
                                const res = JSON.parse(result.string._);

                                if (res.Success) {
                                    if (res.Response) {
                                        const responseData = JSON.parse(res.Response);
                                        resolve(responseData);
                                    }
                                } else {
                                    reject(res.ErrorMessage)
                                    console.error('Error during getMediaMixLastRequest ErrorMessage:', res.ErrorMessage);
                                }
                            }
                        });
                    })

                    .catch((err) => {
                        resolve(null);
                        console.log('getMediaMixLastRequest failed!!!');
                    });
            });
        },
        createRequestByDates: (mediaMixId:number,fromDate:string,toDate:string) => {
            return new Promise((resolve,reject) => {
                fetchRequest(
                    `${constConfig.url.API_URL + reports_path}/CreateRequestByDates`,
                    'post',
                    new URLSearchParams({ mediaMixId: mediaMixId.toString(),fromDate,toDate }).toString()
                )
                    .then((response: any) => {
                        parseString(response, (err: any, result: any) => {
                            if (result) {
                                const res = JSON.parse(result.string._);

                                if (res.Success) {
                                    if (res.Response) {
                                        const responseData = JSON.parse(res.Response);
                                        resolve(responseData);
                                    }
                                } else {
                                    console.error('Error during CreateRequestByDates ErrorMessage:', res.ErrorMessage);
                                    reject(res.ErrorMessage)
                                }
                            }
                        });
                    })

                    .catch((err) => {
                        resolve(null);
                        console.log('CreateRequestByDates failed!!!', err);
                    });
            });
        },
        getMediaMixRequestById: (requestId:number) => {
            return new Promise((resolve) => {
                fetchRequest(
                    `${constConfig.url.API_URL + reports_path}/GetMediaMixRequestById`,
                    'post',
                    new URLSearchParams({ requestId:requestId.toString() }).toString()
                )
                    .then((response: any) => {
                        parseString(response, (err: any, result: any) => {
                            if (result) {
                                const res = JSON.parse(result.string._);

                                if (res.Success) {
                                    if (res.Response) {
                                        const responseData = JSON.parse(res.Response);
                                        resolve(responseData);
                                    }
                                } else {
                                    console.error('Error during getMediaMixRequestById ErrorMessage:', res.ErrorMessage);
                                }
                            }
                        });
                    })

                    .catch((err) => {
                        resolve(null);
                        console.log('getMediaMixRequestById failed!!!', err);
                    });
            });
        },
        updateReportRequest: (requestId:number,isBookmarked:boolean,isBilling:boolean,reportName:string) => {
            return new Promise((resolve,reject) => {
                fetchRequest(
                    `${constConfig.url.API_URL + reports_path}/UpdateReportRequest`,
                    'post',
                    new URLSearchParams({ requestId: requestId.toString(),
                                        isBookmarked:isBookmarked.toString(),
                                        isBilling:isBilling.toString(),
                                        reportName }).toString()
                )
                    .then((response: any) => {
                        parseString(response, (err: any, result: any) => {
                            if (result) {
                                const res = JSON.parse(result.string._);

                                if (res.Success) {
                                    resolve(true);
                                } else {
                                    console.error('Error during updateReportRequest ErrorMessage:', res.ErrorMessage);
                                    reject(res.ErrorMessage);
                                }
                            }
                        });
                    })

                    .catch((err) => {
                        reject(err);
                        console.log('updateReportRequest failed!!!', err);
                    });
            });
        },
        updateManualReportField: (requestId:number,rowId:number,field_name:string,field_value:string) => {
            return new Promise((resolve,reject) => {
                fetchRequest(
                    `${constConfig.url.API_URL + reports_path}/UpdateManualReportField`,
                    'post',
                    new URLSearchParams({ requestId: requestId.toString(),
                                            rowId:rowId.toString(),
                                            field_name,field_value }).toString()
                )
                    .then((response: any) => {
                        parseString(response, (err: any, result: any) => {
                            if (result) {
                                const res = JSON.parse(result.string._);

                                if (res.Success) {
                                    resolve(true);
                                } else {
                                    console.error('Error during updateManualReportField ErrorMessage:', res.ErrorMessage);
                                    reject(res.ErrorMessage);
                                }
                            }
                        });
                    }).catch((err) => {
                        reject(err);
                        console.log('updateManualReportField failed!!!', err);
                    });
            });
        },
        reloadReportRequest: (requestId:number, keep_manual:boolean) => {
            return new Promise((resolve) => {
                fetchRequest(
                    `${constConfig.url.API_URL + reports_path}/ReloadReportRequest`,
                    'post',
                    new URLSearchParams({ requestId: requestId.toString(), keepManual: keep_manual.toString()}).toString()
                )
                    .then((response: any) => {
                        parseString(response, (err: any, result: any) => {
                            if (result) {
                                const res = JSON.parse(result.string._);

                                if (res.Success) {
                                    resolve(true);
                                } else {
                                    console.error('Error during ReloadReportRequest ErrorMessage:', res.ErrorMessage);
                                    resolve(res.ErrorMessage);
                                }
                            }
                        });
                    })

                    .catch((err) => {
                        resolve(null);
                        console.log('ReloadReportRequest failed!!!', err);
                    });
            });
        },
        getBookmarkedReportsOptions: (activityId:number) => {
            return new Promise((resolve,reject) => {
                fetchRequest(
                    `${constConfig.url.API_URL + reports_path}/GetBookmarkedReportsOptions`,
                    'post',
                    new URLSearchParams({activityId: activityId.toString()}).toString()
                )
                    .then((response: any) => {
                        parseString(response, (err: any, result: any) => {
                            if (result) {
                                const res = JSON.parse(result.string._);

                                if (res.Success) {
                                    if (res.Response) {
                                        const responseData = JSON.parse(res.Response);
                                        resolve(responseData);
                                    }else{
                                        reject(new Error('No saved reports'));
                                    }
                                } else {
                                    reject(new Error(res.ErrorMessage))
                                    console.error('Error during getBookmarkedReportsOptions ErrorMessage:', res.ErrorMessage);
                                }
                            }
                        });
                    })

                    .catch((err) => {
                        resolve(null);
                        console.log('getBookmarkedReportsOptions failed!!!');
                    });
            });
        },
        getAdGroupRequestById: (requestId:number,adGroupRequestId?:number,mediaChannelId?:number) => {
            return new Promise((resolve,reject) => {
                fetchRequest(
                    `${constConfig.url.API_URL + reports_path}/GetAdGroupRequestById`,
                    'post',
                    new URLSearchParams({ 
                        requestId:requestId.toString(),
                        adGroupRequestId: adGroupRequestId?.toString() || '-1',
                        mediaChannelId: mediaChannelId?.toString() || '-1',
                    }).toString()
                )
                    .then((response: any) => {
                        parseString(response, (err: any, result: any) => {
                            if (result) {
                                const res = JSON.parse(result.string._);

                                if (res.Success) {
                                    if (res.Response) {
                                        const responseData = JSON.parse(res.Response);
                                        resolve(responseData);
                                    }
                                } else {
                                    reject(new Error(res.ErrorMessage));
                                    console.error('Error during getAdGroupRequestById ErrorMessage:', res.ErrorMessage);
                                }
                            }
                        });
                    })

                    .catch((err) => {
                        reject(new Error(err.message));
                        console.log('getAdGroupRequestById failed!!!', err);
                    });
            });
        },
        sendMediaMixReportToClient: (report_id:number) => {
                return new Promise((resolve,reject) => {
                    fetchRequest(
                        `${constConfig.url.API_URL + reports_path}/SendMediaMixReportToClient`,
                        'post',
                        JSON.stringify({ reportId: report_id }),
                        true 
                ).then((res: any) => {
                    if (res.Success) {
                        if (res.Response) {
                                const responseData = JSON.parse(res.Response);
                                resolve(responseData);
                            }
                        } else {
                            console.error('Error during sendMediaMixReportToClient ErrorMessage:', res.ErrorMessage);
                            reject(new Error(res.ErrorMessage));
                        }
                            
                    }).catch((err) => {
                        reject(err);
                        console.log('sendMediaMixReportToClient failed!!!', err);
                    });
                });
            },
        // the creative of each ad of the report: Meta Key (images/videos it shows), Google search ad text
        getAdCreativeInfo: (requestId:number) : Promise<AdCreativeInfo[]> => {
                return new Promise((resolve,reject) => {
                    fetchRequest(
                        `${constConfig.url.API_URL + reports_path}/GetAdCreativeInfo`,
                        'post',
                        JSON.stringify({ requestId }),
                        true
                ).then((res: any) => {
                    if (res?.Success) {
                        resolve(res.Response ? JSON.parse(res.Response) : []);
                    } else {
                        console.error('Error during getAdCreativeInfo ErrorMessage:', res?.ErrorMessage);
                        reject(new Error(res?.ErrorMessage));
                    }
                }).catch((err) => {
                    reject(err);
                    console.log('getAdCreativeInfo failed!!!', err);
                });
            });
        },
    },
    // the account-level creative report: the account's ad accounts on one platform (not through activities);
    // dates dd/MM/yyyy
    AccountCreatives: {
        getCampaignOptions: (accountId: number, platform: number, fromDate: string, toDate: string, activityId?: number) =>
            accountCreativesCall<{ HasAdAccount: boolean; Campaigns: AccountCampaignOption[] }>('GetAccountCampaignOptions', { accountId, platform, fromDate, toDate, activityId: activityId ?? -1 }),
        getAdSetOptions: (accountId: number, platform: number, fromDate: string, toDate: string, campaignIds: string[]) =>
            accountCreativesCall<AccountAdSetOption[]>('GetAccountAdSetOptions', { accountId, platform, fromDate, toDate, campaignIds: campaignIds.join(',') }),
        createRequest: (accountId: number, platform: number, fromDate: string, toDate: string, campaignIds: string[]) =>
            accountCreativesCall<{ RequestId: number }>('CreateAccountCreativesRequest', { accountId, platform, fromDate, toDate, campaignIds: campaignIds.join(',') }),
        getRequest: (requestId: number) =>
            accountCreativesCall<{ Status: number; ReportError?: string; RequestData?: any[]; AdStatus?: Record<string, string> }>('GetAccountCreativesRequest', { requestId }),
        getCreativeInfo: (requestId: number) => accountCreativesCall<AdCreativeInfo[]>('GetAccountCreativeInfo', { requestId })
    },
    Ai:{
        getResponses:(refId:number) => {
            return new Promise((resolve,reject) => {
                fetchRequest(
                    `${constConfig.url.API_URL + reports_path}/GetResponses`,
                    'post',
                    new URLSearchParams({ referenceId: refId.toString()}).toString()
                )
                    .then((response: any) => {
                        parseString(response, (err: any, result: any) => {
                            if (result) {
                                const res = JSON.parse(result.string._);
    
                                if (res.Success) {
                                    if (res.Response) {
                                        const responseData = JSON.parse(res.Response);
                                        resolve(responseData);
                                    }else{
                                        resolve([]);
                                    }
                                } else {
                                    console.error('Error during getTargetsExceptions ErrorMessage:', res.ErrorMessage);
                                    reject(new Error(res.ErrorMessage));
                                }
                            }
                        });
                    })
    
                    .catch((err) => {
                        reject(new Error(err.message));
                        console.log('getTargetsExceptions failed!!!', err);
                    });
            });
        },
        getContextResponses:(filters:aiAnalyticsFilters) => {
            return new Promise((resolve,reject) => {
                fetchRequest(
                    `${constConfig.url.API_URL + reports_path}/GetContextResponses`,
                    'post',
                    new URLSearchParams({ analizeRequest: JSON.stringify(filters)}).toString()
                )
                    .then((response: any) => {
                        parseString(response, (err: any, result: any) => {
                            if (result) {
                                const res = JSON.parse(result.string._);
    
                                if (res.Success) {
                                    if (res.Response) {
                                        const responseData = JSON.parse(res.Response);
                                        resolve(responseData);
                                    }else{
                                        resolve([]);
                                    }
                                } else {
                                    console.error('Error during getContextResponses ErrorMessage:', res.ErrorMessage);
                                    reject(new Error(res.ErrorMessage));
                                }
                            }
                        });
                    })
    
                    .catch((err) => {
                        reject(new Error(err.message));
                        console.log('getContextResponses failed!!!', err);
                    });
            });
        },
        getResponseContent:(id:number) => {
            return new Promise((resolve,reject) => {
                fetchRequest(
                    `${constConfig.url.API_URL + reports_path}/GetResponseContent`,
                    'post',
                    new URLSearchParams({ id: id.toString()}).toString()
                )
                    .then((response: any) => {
                        parseString(response, (err: any, result: any) => {
                            if (result) {
                                const res = JSON.parse(result.string._);
    
                                if (res.Success) {
                                    if (res.Response) {
                                        const responseData = JSON.parse(res.Response);
                                        resolve(responseData);
                                    }else{
                                        resolve([]);
                                    }
                                } else {
                                    console.error('Error during getResponseContent ErrorMessage:', res.ErrorMessage);
                                    reject(new Error(res.ErrorMessage));
                                }
                            }
                        });
                    })
    
                    .catch((err) => {
                        reject(new Error(err.message));
                        console.log('getResponseContent failed!!!', err);
                    });
            });
        },
        updateAiResponsesTitle:(id:number,title:string) => {
            return new Promise((resolve,reject) => {
                fetchRequest(
                    `${constConfig.url.API_URL + reports_path}/UpdateAiResponsesTitle`,
                    'post',
                    new URLSearchParams({ id: id.toString(),title}).toString()
                )
                    .then((response: any) => {
                        parseString(response, (err: any, result: any) => {
                            if (result) {
                                const res = JSON.parse(result.string._);
    
                                if (res.Success) {
                                    resolve(true);
                                    
                                } else {
                                    console.error('Error during getTargetsExceptions ErrorMessage:', res.ErrorMessage);
                                    reject(new Error(res.ErrorMessage));
                                }
                            }
                        });
                    })
    
                    .catch((err) => {
                        reject(new Error(err.message));
                        console.log('getTargetsExceptions failed!!!', err);
                    });
            });
        },
        deleteAiResponse:(id:number) => {
            return new Promise((resolve,reject) => {
                fetchRequest(
                    `${constConfig.url.API_URL + reports_path}/DeleteAiResponse`,
                    'post',
                    new URLSearchParams({ id: id.toString()}).toString()
                )
                    .then((response: any) => {
                        parseString(response, (err: any, result: any) => {
                            if (result) {
                                const res = JSON.parse(result.string._);
    
                                if (res.Success) {
                                    resolve(true);
                                    
                                } else {
                                    console.error('Error during deleteAiResponse ErrorMessage:', res.ErrorMessage);
                                    reject(new Error(res.ErrorMessage));
                                }
                            }
                        });
                    })
    
                    .catch((err) => {
                        reject(new Error(err.message));
                        console.log('deleteAiResponse failed!!!', err);
                    });
            });
        },
        getCustomPrompts:(prompTypes: number[])=> {
            return new Promise((resolve,reject) => {
                fetchRequest(
                    `${constConfig.url.API_URL + reports_path}/GetCustomPrompts`,
                    'post',
                    new URLSearchParams({ prompTypes: prompTypes.join()}).toString()
                )
                    .then((response: any) => {
                        parseString(response, (err: any, result: any) => {
                            if (result) {
                                const res = JSON.parse(result.string._);
    
                                if (res.Success) {
                                    if (res.Response) {
                                        const responseData = JSON.parse(res.Response);
                                        resolve(responseData);
                                    }else{
                                        resolve([]);
                                    }
                                } else {
                                    console.error('Error during getTargetsExceptions ErrorMessage:', res.ErrorMessage);
                                    reject(new Error(res.ErrorMessage));
                                }
                            }
                        });
                    })
    
                    .catch((err) => {
                        reject(new Error(err.message));
                        console.log('getTargetsExceptions failed!!!', err);
                    });
            });
        },
        analizeDetailedMediaMix: (lang:string,filters:aiAnalyticsFilters,reload?:boolean,customPromptContent?:string,outputType?:OutputTypeEnum) => {
            return new Promise((resolve,reject) => {
                fetchRequest(
                    `${constConfig.url.API_URL + reports_path}/AnalizeDetailedMediaMix`,
                    'post',
                    new URLSearchParams({
                        lang,
                        analizeRequest: JSON.stringify(filters),
                        reload: reload ? 'true' : 'false',
                        customPromptContent: customPromptContent || '',
                        outputType: (outputType || OutputTypeEnum.RenderedContent).toString()}).toString()
                )
                    .then((response: any) => {
                        parseString(response, (err: any, result: any) => {
                            if (result) {
                                const res = JSON.parse(result.string._);
    
                                if (res.Success) {
                                    if (res.Response) {
                                        const responseData = JSON.parse(res.Response);
                                        resolve(responseData);
                                    }
                                } else {
                                    reject(new Error(res.ErrorMessage || 'failed analizing media mix'));
                                    console.error('Error during ai analizing ErrorMessage:', res.ErrorMessage);
                                }
                            } else {
                                reject(new Error('failed analizing media mix'));
                            }
                        });
                    })
    
                    .catch((err) => {
                        reject(err);
                        console.log('analizeDetailedMediaMix failed!!!');
                    });
            });
        },
        getMediaPlanPayload: (filters:aiAnalyticsFilters) => {
            return new Promise((resolve,reject) => {
                fetchRequest(
                    `${constConfig.url.API_URL + reports_path}/GetMediaPlanPayload`,
                    'post',
                     JSON.stringify({ analizeRequest: JSON.stringify(filters) }),
                    true 
                ).then((res: any) => {
                    if (res.Success) {
                        if (res.Response) {
                            resolve(res.Response);
                        }
                    } else {
                        console.error('Error during getMediaPlanPayload ErrorMessage:', res.ErrorMessage);
                        reject(new Error(res.ErrorMessage || 'failed fetching media mix payload'));
                    }
                })
                .catch((err) => {
                    reject(err);
                    console.log('payload failed!!!');
                });
            });
        },
        generatePresentation: (lang:string,filters:aiAnalyticsFilters) => {
            return new Promise((resolve,reject) => {
                fetchRequest(
                    `${constConfig.url.API_URL + reports_path}/GeneratePresentation`,
                    'post',
                     JSON.stringify({ lang,analizeRequest: JSON.stringify(filters) }),
                    true 
                ).then((res: any) => {
                    if (res.Success) {
                        if (res.Response) {
                            const responseData = JSON.parse(res.Response);
                            resolve(responseData);
                        }
                    } else {
                        console.error('Error during generatePresentation ErrorMessage:', res.ErrorMessage);
                        reject(new Error(res.ErrorMessage || 'failed fetching media mix payload'));
                    }
                })
                .catch((err) => {
                    reject(err);
                    console.log('payload failed!!!');
                });
            });
        },
        getLastAnalysis:(filters:aiAnalyticsFilters) => {
            return new Promise((resolve,reject) => {
                fetchRequest(
                    `${constConfig.url.API_URL + reports_path}/GetLastAnalysis`,
                    'post',
                    new URLSearchParams({
                        analizeRequest: JSON.stringify(filters)}).toString()
                )
                    .then((response: any) => {
                        parseString(response, (err: any, result: any) => {
                            if (result) {
                                const res = JSON.parse(result.string._);
    
                                if (res.Success) {
                                    if (res.Response) {
                                        const responseData = JSON.parse(res.Response);
                                        resolve(responseData);
                                    }else{
                                        resolve(null);
                                    }
                                } else {
                                    reject(new Error(res.ErrorMessage || 'failed getting analysis'));
                                    console.error('Error during getting analysis ErrorMessage:', res.ErrorMessage);
                                }
                            } else {
                                reject(new Error('failed getting analysis'));
                            }
                        });
                    })
    
                    .catch((err) => {
                        reject(err);
                        console.log('getLastAnalysis failed!!!');
                    });
            });
        },
        completeRequest:(responseId:number) => {
            return new Promise((resolve,reject) => {
                fetchRequest(
                    `${constConfig.url.API_URL + reports_path}/CompleteRequest`,
                    'post',
                    JSON.stringify({ responseId }),
                    true
                ).then((res: any) => {
                    if (res.Success) {
                        if (res.Response) {
                            const responseData = JSON.parse(res.Response);
                            resolve(responseData);
                        }else{
                            resolve(null);
                        }
                    } else {
                        reject(new Error(res.ErrorMessage || 'failed to complete request'));
                        console.error('Error during completeRequest ErrorMessage:', res.ErrorMessage);
                    }
                }).catch((err) => {
                    reject(err);
                    console.log('completeRequest failed!!!');
                });
            });
        },
        getAiUsageList: (from_date:string,to_date:string) => {
            return new Promise((resolve,reject) => {
                fetchRequest(
                    `${constConfig.url.API_URL + reports_path}/GetAiUsageList`,
                    'post', 
                    JSON.stringify({ fromDate:from_date,toDate:to_date }),
                    true 
                ).then((res: any) => {
                        if (res.Success) {
                        if (res.Response) {
                            const responseData = JSON.parse(res.Response);
                            resolve(responseData);
                        }
                    } else {
                        console.error('Error during getMediaServeList ErrorMessage:', res.ErrorMessage);
                        reject(new Error(res.ErrorMessage));
                    }
                })
                .catch((err) => {
                    reject(err);
                    console.log('getMediaServeList failed!!!', err);
                });
            });
        },
    },
    Billing:{
        getMonthlyBillingReport:(year:number,  month:number, reload:boolean) => {
            return new Promise((resolve,reject) => {
                fetchRequest(
                    `${constConfig.url.API_URL + reports_path}/GetMonthlyBillingReport`,
                    'post',
                    new URLSearchParams({
                         year: year.toString(),
                        month: month.toString(),
                        reload: reload ? 'true' : 'false',
                    }).toString()
                )
                    .then((response: any) => {
                        parseString(response, (err: any, result: any) => {
                            if (result) {
                                const res = JSON.parse(result.string._);
    
                                if (res.Success) {
                                    if (res.Response) {
                                        const responseData = JSON.parse(res.Response);
                                        resolve(responseData);
                                    }else{
                                        resolve([]);
                                    }
                                } else {
                                    console.error('Error during getTargetsExceptions ErrorMessage:', res.ErrorMessage);
                                    reject(new Error(res.ErrorMessage));
                                }
                            }
                        });
                    })
    
                    .catch((err) => {
                        reject(new Error(err.message));
                        console.log('getTargetsExceptions failed!!!', err);
                    });
            });
        },
        processBillingRow: (requestId:number, accountId:number,activityId:number,
            isSubmissionSum:boolean,materialNumber:string,totalBilling:number, channelTypeId?:number, campaignCategoryEnum?:CampaignCategoryEnum) => {
                return new Promise((resolve,reject) => {
                    fetchRequest(
                        `${constConfig.url.API_URL + reports_path}/ProcessBillingRow`,
                        'post',
                        new URLSearchParams({
                            requestId: requestId.toString(),
                            accountId: accountId.toString(),
                            activityId: activityId.toString(),
                            isSubmissionSum: isSubmissionSum ? 'true' : 'false',
                            materialNumber,
                            totalBilling:totalBilling.toString(),
                            channelTypeId: channelTypeId?.toString() || '-1',
                            campaignCategory: campaignCategoryEnum?.toString() || '-1',
                        }).toString()
                    )
                        .then((response: any) => {
                            parseString(response, (err: any, result: any) => {
                                if (result) {
                                    const res = JSON.parse(result.string._);
        
                                    if (res.Success) {
                                        resolve(res.Response);
                                    } else {
                                        console.error('Error during processBillingRow ErrorMessage:', res.ErrorMessage);
                                        reject(new Error(res.ErrorMessage));
                                    }
                                }
                            });
                        })
        
                        .catch((err) => {
                            reject(new Error(err.message));
                            console.log('processBillingRow failed!!!', err);
                        });
                });
        },
        unprocessBillingRow: (processId:number) => {
                return new Promise((resolve,reject) => {
                    fetchRequest(
                        `${constConfig.url.API_URL + reports_path}/UnprocessBillingRow`,
                        'post',
                        new URLSearchParams({
                            processId: processId.toString(),
                        }).toString()
                    )
                        .then((response: any) => {
                            parseString(response, (err: any, result: any) => {
                                if (result) {
                                    const res = JSON.parse(result.string._);
        
                                    if (res.Success) {
                                        resolve(true);
                                    } else {
                                        console.error('Error during unprocessBillingRow ErrorMessage:', res.ErrorMessage);
                                        reject(new Error(res.ErrorMessage));
                                    }
                                }
                            });
                        })
        
                        .catch((err) => {
                            reject(new Error(err.message));
                            console.log('unprocessBillingRow failed!!!', err);
                        });
                });
        },
        saveBillingRowRemark: (processId:number,remark:string) => {
            return new Promise((resolve,reject) => {
                fetchRequest(
                    `${constConfig.url.API_URL + reports_path}/SaveBillingRowRemark`,
                    'post',
                    new URLSearchParams({
                        processId: processId.toString(),
                        remark
                    }).toString()
                )
                    .then((response: any) => {
                        parseString(response, (err: any, result: any) => {
                            if (result) {
                                const res = JSON.parse(result.string._);
    
                                if (res.Success) {
                                    resolve(true);
                                } else {
                                    console.error('Error during saveBillingRowRemark ErrorMessage:', res.ErrorMessage);
                                    reject(new Error(res.ErrorMessage));
                                }
                            }
                        });
                    })
    
                    .catch((err) => {
                        reject(new Error(err.message));
                        console.log('saveBillingRowRemark failed!!!', err);
                    });
            });
        },
       
    },
    Monitoring:{
        getReportingExceptions:()=> {
            return new Promise((resolve,reject) => {
                fetchRequest(
                    `${constConfig.url.API_URL + reports_path}/GetReportingExceptions`,
                    'post',
                    null
                )
                    .then((response: any) => {
                        parseString(response, (err: any, result: any) => {
                            if (result) {
                                const res = JSON.parse(result.string._);
    
                                if (res.Success) {
                                    if (res.Response) {
                                        const responseData = JSON.parse(res.Response);
                                        resolve(responseData);
                                    }else{
                                        resolve([]);
                                    }
                                } else {
                                    console.error('Error during getReportingExceptions ErrorMessage:', res.ErrorMessage);
                                    reject(new Error(res.ErrorMessage));
                                }
                            }
                        });
                    })
    
                    .catch((err) => {
                        reject(new Error(err.message));
                        console.log('getReportingExceptions failed!!!', err);
                    });
            });
        },
        getBudgetExceptions:(version?:number)=> {
            return new Promise((resolve,reject) => {
                fetchRequest(
                    `${constConfig.url.API_URL + reports_path}/GetBudgetExceptions${version == 2 ? '_V2' : ''}`,
                    'post',
                    null,
                    true 
                )
                    .then((res: any) => {
                        if (res.Success) {
                            if (res.Response) {
                                const responseData = JSON.parse(res.Response);
                                resolve(responseData);
                            }else {
                                resolve([]);
                            }
                        } else {
                            console.error('Error during getBudgetExceptions ErrorMessage:', res.ErrorMessage);
                            reject(new Error(res.ErrorMessage));
                        }
                    })
                    .catch((err) => {
                        reject(new Error(err.message));
                        console.log('getBudgetExceptions failed!!!', err);
                    });
            });
        },
        getTargetsExceptions:()=> {
            return new Promise((resolve,reject) => {
                fetchRequest(
                    `${constConfig.url.API_URL + reports_path}/GetTargetsExceptions`,
                    'post',
                    null
                )
                    .then((response: any) => {
                        parseString(response, (err: any, result: any) => {
                            if (result) {
                                const res = JSON.parse(result.string._);
    
                                if (res.Success) {
                                    if (res.Response) {
                                        const responseData = JSON.parse(res.Response);
                                        resolve(responseData);
                                    }else{
                                        resolve([]);
                                    }
                                } else {
                                    console.error('Error during getTargetsExceptions ErrorMessage:', res.ErrorMessage);
                                    reject(new Error(res.ErrorMessage));
                                }
                            }
                        });
                    })
    
                    .catch((err) => {
                        reject(new Error(err.message));
                        console.log('getTargetsExceptions failed!!!', err);
                    });
            });
        },
        getBillingRptExceptions:()=> {
            return new Promise((resolve,reject) => {
                fetchRequest(
                    `${constConfig.url.API_URL + reports_path}/GetBillingRptExceptions`,
                    'post',
                    null
                )
                    .then((response: any) => {
                        parseString(response, (err: any, result: any) => {
                            if (result) {
                                const res = JSON.parse(result.string._);
    
                                if (res.Success) {
                                    if (res.Response) {
                                        const responseData = JSON.parse(res.Response);
                                        resolve(responseData);
                                    }else{
                                        resolve([]);
                                    }
                                } else {
                                    console.error('Error during getBillingRptExceptions ErrorMessage:', res.ErrorMessage);
                                    reject(new Error(res.ErrorMessage));
                                }
                            }
                        });
                    })
    
                    .catch((err) => {
                        reject(new Error(err.message));
                        console.log('getBillingRptExceptions failed!!!', err);
                    });
            });
        },
        getLostCampaigns:()=> {
            return new Promise((resolve,reject) => {
                fetchRequest(
                    `${constConfig.url.API_URL + reports_path}/GetLostCampaigns`,
                    'post',
                    null,true
                )
                    .then((res: any) => {
                        if (res.Success) {
                            if (res.Response) {
                                const responseData = JSON.parse(res.Response);
                                resolve(responseData);
                            }else {
                                resolve([]);
                            }
                        } else {
                            console.error('Error during getLostCampaigns ErrorMessage:', res.ErrorMessage);
                            reject(new Error(res.ErrorMessage));
                        }
                    })
                    .catch((err) => {
                        reject(new Error(err.message));
                        console.log('getLostCampaigns failed!!!', err);
                    });
            });
        },
        getStopLossBudgetExceptions:()=> {
            return new Promise((resolve,reject) => {
                fetchRequest(
                    `${constConfig.url.API_URL + reports_path}/GetStopLossBudgetExceptions`,
                    'post',
                    null,true
                )
                    .then((res: any) => {
                        if (res.Success) {
                            if (res.Response) {
                                const responseData = JSON.parse(res.Response);
                                resolve(responseData);
                            }else {
                                resolve([]);
                            }
                        } else {
                            console.error('Error during getStopLossBudgetExceptions ErrorMessage:', res.ErrorMessage);
                            reject(new Error(res.ErrorMessage));
                        }
                    })
                    .catch((err) => {
                        reject(new Error(err.message));
                        console.log('getStopLossBudgetExceptions failed!!!', err);
                    });
            });
        },
        getStopLossMediaChannelExceptions:()=> {
            return new Promise((resolve,reject) => {
                fetchRequest(
                    `${constConfig.url.API_URL + reports_path}/GetStopLossMediaChannelExceptions`,
                    'post',
                    null,true
                )
                    .then((res: any) => {
                        if (res.Success) {
                            if (res.Response) {
                                const responseData = JSON.parse(res.Response);
                                resolve(responseData);
                            }else {
                                resolve([]);
                            }
                        } else {
                            console.error('Error during getStopLossMediaChannelExceptions ErrorMessage:', res.ErrorMessage);
                            reject(new Error(res.ErrorMessage));
                        }
                    })
                    .catch((err) => {
                        reject(new Error(err.message));
                        console.log('getStopLossMediaChannelExceptions failed!!!', err);
                    });
            });
        },
        getActivitiesWithMissingCampaigns:()=> {
            return new Promise((resolve,reject) => {
                fetchRequest(
                    `${constConfig.url.API_URL + reports_path}/GetActivitiesWithMissingCampaigns`,
                    'post',
                    null,true
                )
                    .then((res: any) => {
                        if (res.Success) {
                            if (res.Response) {
                                const responseData = JSON.parse(res.Response);
                                resolve(responseData);
                            }else {
                                resolve([]);
                            }
                        } else {
                            console.error('Error during getActivitiesWithMissingCampaigns ErrorMessage:', res.ErrorMessage);
                            reject(new Error(res.ErrorMessage));
                        }
                    })
                    .catch((err) => {
                        reject(new Error(err.message));
                        console.log('getLostCampaigns failed!!!', err);
                    });
            });
        },
    },
    Stats:{
        getInsights:(mediaMixChannelId: number, field:string)=>{
            return new Promise<BanchMarks>((resolve,reject) => {
                fetchRequest(
                    `${constConfig.url.API_URL + reports_path}/GetInsights`,
                    'post',
                    new URLSearchParams({
                        mediaMixChannelId:mediaMixChannelId.toString(),
                        field: field.toString()}).toString()
                )
                    .then((response: any) => {
                        parseString(response, (err: any, result: any) => {
                            if (result) {
                                const res = JSON.parse(result.string._);
    
                                if (res.Success) {
                                    if (res.Response) {
                                        const responseData = JSON.parse(res.Response);
                                        resolve(responseData);
                                    }else{
                                        reject(new Error('No data'));
                                    }
                                } else {
                                    reject(new Error(res.ErrorMessage))
                                    console.error('Error during getInsights ErrorMessage:', res.ErrorMessage);
                                }
                            }
                        });
                    })
                    .catch((err) => {
                        reject(err)
                        console.log('getInsights failed!!!');
                    });
            });
        },
        getMediaPlanInsights: (accountId:number)=>{
            return new Promise((resolve,reject) => {
                fetchRequest(
                    `${constConfig.url.API_URL + reports_path}/GetMediaPlanInsights`,
                    'post',
                    new URLSearchParams({
                        accountId:accountId.toString()
                    }).toString())
                    .then((response: any) => {
                        parseString(response, (err: any, result: any) => {
                            if (result) {
                                const res = JSON.parse(result.string._);
    
                                if (res.Success) {
                                    if (res.Response) {
                                        const responseData = JSON.parse(res.Response);
                                        resolve(responseData);
                                    }else{
                                        reject(new Error('No data'));
                                    }
                                } else {
                                    reject(new Error(res.ErrorMessage))
                                    console.error('Error during getMediaPlanInsights ErrorMessage:', res.ErrorMessage);
                                }
                            }
                        });
                    })
                    .catch((err) => {
                        reject(err)
                        console.log('getMediaPlanInsights failed!!!');
                    });
            });
        },
    },
    Tasks: {
        getClientReplies:()=> {
            return new Promise((resolve,reject) => {
                fetchRequest(
                    `${constConfig.url.API_URL + reports_path}/GetClientReplies`,
                    'post',
                    null
                )
                    .then((response: any) => {
                        parseString(response, (err: any, result: any) => {
                            if (result) {
                                const res = JSON.parse(result.string._);
    
                                if (res.Success) {
                                    if (res.Response) {
                                        const responseData = JSON.parse(res.Response);
                                        resolve(responseData);
                                    }else{
                                        resolve([]);
                                    }
                                } else {
                                    console.error('Error during getClientReplies ErrorMessage:', res.ErrorMessage);
                                    reject(new Error(res.ErrorMessage));
                                }
                            }
                        });
                    })
    
                    .catch((err) => {
                        reject(new Error(err.message));
                        console.log('getClientReplies failed!!!', err);
                    });
            });
        },
        getPendingApprovals:()=> {
            return new Promise((resolve,reject) => {
                fetchRequest(
                    `${constConfig.url.API_URL + reports_path}/GetPendingApprovals`,
                    'post',
                    null
                )
                    .then((response: any) => {
                        parseString(response, (err: any, result: any) => {
                            if (result) {
                                const res = JSON.parse(result.string._);
    
                                if (res.Success) {
                                    if (res.Response) {
                                        const responseData = JSON.parse(res.Response);
                                        resolve(responseData);
                                    }else{
                                        resolve([]);
                                    }
                                } else {
                                    console.error('Error during getPendingApprovals ErrorMessage:', res.ErrorMessage);
                                    reject(new Error(res.ErrorMessage));
                                }
                            }
                        });
                    })
    
                    .catch((err) => {
                        reject(new Error(err.message));
                        console.log('getPendingApprovals failed!!!', err);
                    });
            });
        },
        getClientConfirmations:(year:number,  month:number) => {
            return new Promise((resolve,reject) => {
                fetchRequest(
                    `${constConfig.url.API_URL + reports_path}/GetClientConfirmations`,
                    'post',
                    JSON.stringify({
                         year: year.toString(),
                        month: month.toString(),
                    }),
                        true 
                ).then((res: any) => {
                    if (res.Success) {
                        if (res.Response) {
                            const responseData = JSON.parse(res.Response);
                            resolve(responseData);
                        }else{
                            resolve([]);
                        }
                    } else {
                        console.error('Error during getClientConfirmations ErrorMessage:', res.ErrorMessage);
                        reject(new Error(res.ErrorMessage));
                    }
                }).catch((err) => {
                    reject(new Error(err.message));
                    console.log('getClientConfirmations failed!!!', err);
                });
            });
        },
        getClientConfirmationsByActivity:(activityId:number) => {
            return new Promise((resolve,reject) => {
                fetchRequest(
                    `${constConfig.url.API_URL + reports_path}/GetClientConfirmationsByActivity`,
                    'post',
                    JSON.stringify({
                         activityId,
                    }),
                        true 
                ).then((res: any) => {
                    if (res.Success) {
                        if (res.Response) {
                            const responseData = JSON.parse(res.Response);
                            resolve(responseData);
                        }else{
                            resolve([]);
                        }
                    } else {
                        console.error('Error during getClientConfirmationsByActivity ErrorMessage:', res.ErrorMessage);
                        reject(new Error(res.ErrorMessage));
                    }
                }).catch((err) => {
                    reject(new Error(err.message));
                    console.log('getClientConfirmationsByActivity failed!!!', err);
                });
            });
        },
        getClientConfirmation: (confirmationId: number) => {
              return new Promise((resolve,reject) => {
                fetchRequest(
                    `${constConfig.url.API_URL + reports_path}/GetClientConfirmation`,
                    'post',
                    JSON.stringify({confirmationId}),
                        true 
                ).then((res: any) => {
                    if (res.Success) {
                        if (res.Response) {
                            const responseData = JSON.parse(res.Response);
                            resolve(responseData);
                        }else{
                            resolve([]);
                        }
                    } else {
                        console.error('Error during getClientConfirmation ErrorMessage:', res.ErrorMessage);
                        reject(new Error(res.ErrorMessage));
                    }
                }).catch((err) => {
                    reject(new Error(err.message));
                    console.log('getClientConfirmation failed!!!', err);
                });
            });
        }
    }
    
    
};

const users_path = '/WebServices/UsersService.asmx';

// back_app (src/back/app/bs.js /private/user|account/*): its fields <-> the
// asmx path's (C# UserDetails, UserPermissions, AccountAccessPermissionsObj)
const perm_keys: {[k: string]: string} = {is_admin: 'IsAdmin',
    general_settings: 'GeneralSettings', accounts_cd: 'AccountsCD',
    operational_reports: 'OperationalReports',
    management_reports: 'ManagementReports',
    media_plan_approver: 'MediaPlanApprover', client_zone: 'ClientZone'};
const access_keys: {[k: string]: string} = {account_settings: 'AccountSettings',
    activity_settings: 'ActivitySettings',
    media_plan_settings: 'MediaPlanSettings', read_only: 'ReadOnly'};
const access_obj_keys = {...access_keys, user_id: 'UserID',
    user_lbl: 'UserName', account_id: 'AccountID', account_lbl: 'AccountName',
    main_account_lbl: 'MainAccountName'};
const user_keys = {id: 'ID', user_code: 'UserCode', lbl: 'Name',
    mobile: 'Mobile', country_prefix: 'CountryPrefix', company_lbl: 'Company',
    is_system_admin: 'IsSystemAdmin', aws_status: 'AWS_Status'};
const keys2cs = (o: any, keys: {[k: string]: string}) => {
    const ret: any = {};
    for (const k in keys)
        ret[keys[k]] = o[k] === undefined ? null : o[k];
    return ret;
};
const keys2app = (o: any, keys: {[k: string]: string}) => {
    const ret: any = {};
    for (const k in keys)
        ret[k] = o?.[keys[k]];
    return ret;
};
// JavaScriptSerializer's DateTime, as helper.formatDate parses it
const date2cs = (s: string | null) => s ? `/Date(${Date.parse(s)})/` : null;
const user2cs = (u: any) => ({...keys2cs(u, user_keys),
    LastLoginDate: date2cs(u.last_login),
    Permissions: u.perm ? keys2cs(u.perm, perm_keys) : null});
const access2cs = (a: any) => keys2cs(a, access_obj_keys);
const access_type2app = (type: string) =>
    Object.keys(access_keys).find((k) => access_keys[k] == type) || type;
// rejects with the err string, as the asmx path
const app_call = (path: string, params: any) => fetch_app(path, params)
    .then((res: any) => res.err ? Promise.reject(res.err) : res);

export const UsersApi = {
    getUsersList: () => {
        if (is_bs_app) {
            return app_call('/private/user/list.json', {})
                .then((res: any) => res.users.map(user2cs))
                .catch((err) => {
                    console.log('getUsersList failed!!!', err);
                    return null;
                });
        }
        // XXX colin: remove the asmx path once back_app is on prod
        return new Promise((resolve) => {
            fetchRequest(`${constConfig.url.API_URL + users_path}/GetUsersList`, 'post', new URLSearchParams().toString())
                .then((response: any) => {
                    parseString(response, (err: any, result: any) => {
                        if (result) {
                            const res = JSON.parse(result.string._);

                            if (res.Success) {
                                if (res.Response) {
                                    const responseData = JSON.parse(res.Response);
                                    resolve(responseData);
                                }
                            } else {
                                console.error('Error during getUsersList ErrorMessage:', res.ErrorMessage);
                            }
                        }
                    });
                })

                .catch((err) => {
                    resolve(null);
                    console.log('getUsersList failed!!!');
                });
        });
    },

    getUserDetails: (id: any) => {
        if (is_bs_app) {
            return app_call('/private/user/get.json', {user_id: Number(id)})
                .then((res: any) => user2cs(res.user));
        }
        // XXX colin: remove the asmx path once back_app is on prod
        return new Promise((resolve,reject) => {
            fetchRequest(
                `${constConfig.url.API_URL + users_path}/GetUserDetails`,
                'post',
                new URLSearchParams({ userId: id }).toString()
            )
                .then((response: any) => {
                    parseString(response, (err: any, result: any) => {
                        if (result) {
                            const res = JSON.parse(result.string._);

                            if (res.Success) {
                                if (res.Response) {
                                    const responseData = JSON.parse(res.Response);
                                    resolve(responseData);
                                }
                            } else {
                                console.error('Error during GetUserDetails ErrorMessage:', res.ErrorMessage);
                                reject(new Error(res.ErrorMessage))
                            }
                        }
                    });
                })

                .catch((err) => {
                    reject(err);
                    console.log('GetUserDetails failed!!!', err);
                });
        });
    },

    saveUserItem: (user_item: any) => {
        if (is_bs_app) {
            return app_call('/private/user/set.json', {user: {
                id: user_item.ID, user_code: user_item.UserCode,
                lbl: user_item.Name, mobile: user_item.Mobile,
                country_prefix: user_item.CountryPrefix}})
                .then((res: any) => ({ID: res.id}));
        }
        // XXX colin: remove the asmx path once back_app is on prod
        return new Promise((resolve,reject) => {
            fetchRequest(
                `${constConfig.url.API_URL + users_path}/SaveUserItem`,
                'post',
                new URLSearchParams({ userItem: JSON.stringify(user_item) }).toString()
            )
                .then((response: any) => {
                    parseString(response, (err: any, result: any) => {
                        if (result) {
                            const res = JSON.parse(result.string._);
                           
                            if (res.Success) {
                                if (res.Response) {
                                    const responseData = JSON.parse(res.Response);
                                    resolve(responseData);
                                }
                            } else {
                                reject(res.ErrorMessage);
                                console.error('Error during SaveUserItem ErrorMessage:', res.ErrorMessage);
                            }
                        }
                    });
                })

                .catch((err) => {
                    resolve(null);
                    console.log('SaveUserItem failed!!!', err);
                });
        });
    },
    setUserRegistered: (id: any) => {
        if (is_bs_app) {
            return app_call('/private/user/registered_set.json',
                {user_id: Number(id)}).then(() => true);
        }
        // XXX colin: remove the asmx path once back_app is on prod
        return new Promise((resolve,reject) => {
            fetchRequest(
                `${constConfig.url.API_URL + users_path}/SetUserRegistered`,
                'post',
                new URLSearchParams({ userId: id }).toString()
            )
                .then((response: any) => {
                    parseString(response, (err: any, result: any) => {
                        if (result) {
                            const res = JSON.parse(result.string._);

                            if (res.Success) {
                                resolve(true);
                                // if (res.Response) {
                                //     const responseData = JSON.parse(res.Response);

                                // }
                            } else {
                                reject(res.ErrorMessage)
                                console.error('Error during SetUserRegistered ErrorMessage:', res.ErrorMessage);
                            }
                        }
                    });
                })

                .catch((err) => {
                    reject(err)
                   // resolve(null);
                    console.log('SetUserRegistered failed!!!', err);
                });
        });
    },
    deleteUserItem: (id: any) => {
        if (is_bs_app) {
            return app_call('/private/user/del.json', {user_id: Number(id)})
                .then(() => true);
        }
        // XXX colin: remove the asmx path once back_app is on prod
        return new Promise((resolve,reject) => {
            fetchRequest(
                `${constConfig.url.API_URL + users_path}/DeleteUserItem`,
                'post',
                new URLSearchParams({ userId: id }).toString()
            )
                .then((response: any) => {
                    parseString(response, (err: any, result: any) => {
                        if (result) {
                            const res = JSON.parse(result.string._);

                            if (res.Success) {
                                resolve(true);
                            } else {
                                reject(res.ErrorMessage);
                                console.error('Error during DeleteUserItem ErrorMessage:', res.ErrorMessage);
                            }
                        }
                    });
                })

                .catch((err) => {
                    reject(err);
                    console.log('DeleteUserItem failed!!!', err);
                });
        });
    },
    // activateUserItem: (id: any) => {
    //     return new Promise((resolve,reject) => {
    //         fetchRequest(
    //             `${constConfig.url.API_URL + users_path}/ActivateUserItem`,
    //             'post',
    //             new URLSearchParams({ userId: id }).toString()
    //         )
    //             .then((response: any) => {
    //                 parseString(response, (err: any, result: any) => {
    //                     if (result) {
    //                         const res = JSON.parse(result.string._);

    //                         if (res.Success) {
    //                             if (res.Response) {
    //                                 const responseData = JSON.parse(res.Response);
    //                                 resolve(responseData);
    //                             }
    //                         } else {
    //                             reject(res.ErrorMessage);
    //                             console.error('Error during DeleteUserItem ErrorMessage:', res.ErrorMessage);
    //                         }
    //                     }
    //                 });
    //             })

    //             .catch((err) => {
    //                 reject(err);
    //                 console.log('DeleteUserItem failed!!!', err);
    //             });
    //     });
    // },
    getUserPermissions: (id: any) => {
        if (is_bs_app) {
            return app_call('/private/user/perm_get.json', {user_id: Number(id)})
                .then((res: any) => res.perm ? keys2cs(res.perm, perm_keys)
                    : null);
        }
        // XXX colin: remove the asmx path once back_app is on prod
        return new Promise((resolve,reject) => {
            fetchRequest(
                `${constConfig.url.API_URL + users_path}/GetUserPermissions`,
                'post',
                new URLSearchParams({ userId: id }).toString()
            )
                .then((response: any) => {
                    parseString(response, (err: any, result: any) => {
                        if (result) {
                            const res = JSON.parse(result.string._);

                            if (res.Success) {
                                if (res.Response) {
                                    const responseData = JSON.parse(res.Response);
                                    resolve(responseData);
                                }
                            } else {
                                reject(res.ErrorMessage);
                                console.error('Error during getUserPermissions ErrorMessage:', res.ErrorMessage);
                            }
                        }
                    });
                })

                .catch((err) => {
                    reject(err);
                    console.log('getUserPermissions failed!!!', err);
                });
        });
    },
    saveUserPermissions: (userId: number,permissions:any) => {
        if (is_bs_app) {
            return app_call('/private/user/perm_set.json', {user_id: userId,
                perm: keys2app(permissions, perm_keys)}).then(() => true);
        }
        // XXX colin: remove the asmx path once back_app is on prod
        return new Promise((resolve,reject) => {
            fetchRequest(
                `${constConfig.url.API_URL + users_path}/SaveUserPermissions`,
                'post',
                new URLSearchParams({ userId: userId.toString(),
                    permissions: JSON.stringify(permissions) }).toString()
            )
                .then((response: any) => {
                    parseString(response, (err: any, result: any) => {
                        if (result) {
                            const res = JSON.parse(result.string._);

                            if (res.Success) {
                                resolve(true);
                            } else {
                                reject(res.ErrorMessage);
                                console.error('Error during saveUserAccessPermissions ErrorMessage:', res.ErrorMessage);
                            }
                        }
                    });
                })

                .catch((err) => {
                    reject(err);
                    console.log('saveUserAccessPermissions failed!!!', err);
                });
        });
    },
    getUserFeatures: (id: any) => {
        if (is_bs_app) {
            return app_call('/private/user/feature_get.json',
                {user_id: Number(id)}).then((res: any) => res.features);
        }
        // XXX colin: remove the asmx path once back_app is on prod
        return new Promise((resolve,reject) => {
            fetchRequest(
                `${constConfig.url.API_URL + users_path}/GetUserFeatures`,
                'post',
                new URLSearchParams({ userId: id }).toString()
            )
                .then((response: any) => {
                    parseString(response, (err: any, result: any) => {
                        if (result) {
                            const res = JSON.parse(result.string._);
                            if (res.Success) {
                                resolve(res.Response);
                            } else {
                                reject(res.ErrorMessage);
                                console.error('Error during getUserFeatures ErrorMessage:', res.ErrorMessage);
                            }
                        }
                    });
                })

                .catch((err) => {
                    reject(err);
                    console.log('getUserFeatures failed!!!', err);
                });
        });
    },
    saveUserFeatures: (userId: number,features:FeatureFlags[]) => {
        if (is_bs_app) {
            return app_call('/private/user/feature_set.json', {user_id: userId,
                features: features.join(',')}).then(() => true);
        }
        // XXX colin: remove the asmx path once back_app is on prod
        return new Promise((resolve,reject) => {
            fetchRequest(
                `${constConfig.url.API_URL + users_path}/SaveUserFeatures`,
                'post',
                new URLSearchParams({ userId: userId.toString(),
                    features: features.join(',') }).toString()
            )
                .then((response: any) => {
                    parseString(response, (err: any, result: any) => {
                        if (result) {
                            const res = JSON.parse(result.string._);

                            if (res.Success) {
                                resolve(true);
                            } else {
                                reject(res.ErrorMessage);
                                console.error('Error during saveUserFeatures ErrorMessage:', res.ErrorMessage);
                            }
                        }
                    });
                })

                .catch((err) => {
                    reject(err);
                    console.log('saveUserFeatures failed!!!', err);
                });
        });
    },

    
    getUserNotificationsSubscriptions: (id: any) => {
        if (is_bs_app) {
            return app_call('/private/user/notification_get.json',
                {user_id: Number(id)}).then((res: any) => res.keys);
        }
        // XXX colin: remove the asmx path once back_app is on prod
        return new Promise((resolve,reject) => {
            fetchRequest(
                `${constConfig.url.API_URL + users_path}/GetUserNotificationsSubscriptions`,
                'post',
                new URLSearchParams({ userId: id }).toString()
            )
                .then((response: any) => {
                    parseString(response, (err: any, result: any) => {
                        if (result) {
                            const res = JSON.parse(result.string._);
                            if (res.Success) {
                                resolve(res.Response ? JSON.parse(res.Response) : []);
                            } else {
                                reject(res.ErrorMessage);
                                console.error('Error during getUserNotificationsSubscriptions ErrorMessage:', res.ErrorMessage);
                            }
                        }
                    });
                })

                .catch((err) => {
                    reject(err);
                    console.log('getUserNotificationsSubscriptions failed!!!', err);
                });
        });
    },
    saveUserNotificationsSubscriptions: (userId: number,notifications:string[]) => {
        if (is_bs_app) {
            return app_call('/private/user/notification_set.json',
                {user_id: userId, keys: notifications}).then(() => true);
        }
        // XXX colin: remove the asmx path once back_app is on prod
        return new Promise((resolve,reject) => {
            fetchRequest(
                `${constConfig.url.API_URL + users_path}/SaveUserNotificationsSubscriptions`,
                'post',
                JSON.stringify({ 
                    userId,
                    notifications // :JSON.stringify(notifications)
                }),
                true
                // new URLSearchParams({ userId: userId.toString(),
                //     notifications: JSON.stringify(notifications)}).toString()
            )
                .then((res: any) => {
                    if (res.Success) {
                        resolve(true);
                    } else {
                        reject(res.ErrorMessage);
                        console.error('Error during saveUserNotificationsSubscriptions ErrorMessage:', res.ErrorMessage);
                    }
                }).catch((err) => {
                    reject(err);
                    console.log('saveUserNotificationsSubscriptions failed!!!', err);
                });
        });
    },
    
    getUserAccessPermissions: (id: any) => {
        if (is_bs_app) {
            return app_call('/private/user/access_get.json',
                {user_id: Number(id)})
                .then((res: any) => res.access.map(access2cs));
        }
        // XXX colin: remove the asmx path once back_app is on prod
        return new Promise((resolve,reject) => {
            fetchRequest(
                `${constConfig.url.API_URL + users_path}/GetUserAccessPermissions`,
                'post',
                new URLSearchParams({ userId: id }).toString()
            )
                .then((response: any) => {
                    parseString(response, (err: any, result: any) => {
                        if (result) {
                            const res = JSON.parse(result.string._);

                            if (res.Success) {
                                if (res.Response) {
                                    const responseData = JSON.parse(res.Response);
                                    resolve(responseData);
                                }
                            } else {
                                reject(res.ErrorMessage);
                                console.error('Error during getUserAccessPermissions ErrorMessage:', res.ErrorMessage);
                            }
                        }
                    });
                })

                .catch((err) => {
                    reject(err);
                    console.log('getUserAccessPermissions failed!!!', err);
                });
        });
    },
    saveUserAccessPermissions: (userId: number,accountId:number,permissionType:string, grant:string) => {
        if (is_bs_app) {
            return app_call('/private/user/access_set.json', {user_id: userId,
                account_id: accountId, type: access_type2app(permissionType),
                grant: grant == 'True'})
                .then((res: any) => access2cs(res.access));
        }
        // XXX colin: remove the asmx path once back_app is on prod
        return new Promise((resolve,reject) => {
            fetchRequest(
                `${constConfig.url.API_URL + users_path}/SaveUserAccessPermissions`,
                'post',
                new URLSearchParams({ userId: userId.toString(),
                    accountId: accountId.toString(),
                    permissionType: permissionType.toString(),
                    grant: (grant == 'True' ? 'true' : 'false') }).toString()
            )
                .then((response: any) => {
                    parseString(response, (err: any, result: any) => {
                        if (result) {
                            const res = JSON.parse(result.string._);

                            if (res.Success) {
                                if (res.Response) {
                                    const responseData = JSON.parse(res.Response);
                                    resolve(responseData);
                                }
                            } else {
                                reject(res.ErrorMessage);
                                console.error('Error during saveUserAccessPermissions ErrorMessage:', res.ErrorMessage);
                            }
                        }
                    });
                })

                .catch((err) => {
                    reject(err);
                    console.log('saveUserAccessPermissions failed!!!', err);
                });
        });
    },
    saveBulkUserAccessPermissions: (userId: number,accountIds:number[],permission:any) => {
        if (is_bs_app) {
            return app_call('/private/user/access_bulk_set.json', {
                user_id: userId, account_ids: accountIds,
                access: keys2app(permission, access_keys)}).then(() => true);
        }
        // XXX colin: remove the asmx path once back_app is on prod
        return new Promise((resolve,reject) => {
            fetchRequest(
                `${constConfig.url.API_URL + users_path}/SaveBulkUserAccessPermissions`,
                'post',
                new URLSearchParams({ userId: userId.toString(),
                    accountIds: JSON.stringify(accountIds),
                    permission: JSON.stringify(permission)}).toString()
            )
                .then((response: any) => {
                    parseString(response, (err: any, result: any) => {
                        if (result) {
                            const res = JSON.parse(result.string._);

                            if (res.Success) {
                                resolve(true);
                            } else {
                                reject(res.ErrorMessage);
                                console.error('Error during saveUserAccessPermissions ErrorMessage:', res.ErrorMessage);
                            }
                        }
                    });
                })

                .catch((err) => {
                    reject(err);
                    console.log('saveUserAccessPermissions failed!!!', err);
                });
        });
    },
    getAccountAccessPermissions: (accountId: any) => {
        if (is_bs_app) {
            return app_call('/private/account/access_get.json',
                {account_id: Number(accountId)})
                .then((res: any) => res.access.map(access2cs));
        }
        // XXX colin: remove the asmx path once back_app is on prod
        return new Promise((resolve,reject) => {
            fetchRequest(
                `${constConfig.url.API_URL + users_path}/GetAccountAccessPermissions`,
                'post',
                new URLSearchParams({ accountId: accountId.toString() }).toString()
            )
                .then((response: any) => {
                    parseString(response, (err: any, result: any) => {
                        if (result) {
                            const res = JSON.parse(result.string._);

                            if (res.Success) {
                                if (res.Response) {
                                    const responseData = JSON.parse(res.Response);
                                    resolve(responseData);
                                }
                            } else {
                                reject(res.ErrorMessage);
                                console.error('Error during getAccountAccessPermissions ErrorMessage:', res.ErrorMessage);
                            }
                        }
                    });
                })

                .catch((err) => {
                    reject(err);
                    console.log('getAccountAccessPermissions failed!!!', err);
                });
        });
    },
    saveAccountAccessPermissions: (accountId:number,userId: number,permissionType:string, grant:string) => {
        if (is_bs_app) {
            return app_call('/private/account/access_set.json', {
                account_id: accountId, user_id: userId,
                type: access_type2app(permissionType), grant: grant == 'True'})
                .then((res: any) => access2cs(res.access));
        }
        // XXX colin: remove the asmx path once back_app is on prod
        return new Promise((resolve,reject) => {
            fetchRequest(
                `${constConfig.url.API_URL + users_path}/SaveAccountAccessPermissions`,
                'post',
                new URLSearchParams({ 
                    accountId: accountId.toString(),
                    userId: userId.toString(),
                    permissionType: permissionType.toString(),
                    grant: (grant == 'True' ? 'true' : 'false') }).toString()
            )
                .then((response: any) => {
                    parseString(response, (err: any, result: any) => {
                        if (result) {
                            const res = JSON.parse(result.string._);

                            if (res.Success) {
                                if (res.Response) {
                                    const responseData = JSON.parse(res.Response);
                                    resolve(responseData);
                                }
                            } else {
                                reject(res.ErrorMessage);
                                console.error('Error during saveAccountAccessPermissions ErrorMessage:', res.ErrorMessage);
                            }
                        }
                    });
                })

                .catch((err) => {
                    reject(err);
                    console.log('saveAccountAccessPermissions failed!!!', err);
                });
        });
    },
    saveBulkAccountAccessPermissions: (accountId: number,userIds:number[],permission:any) => {
        if (is_bs_app) {
            return app_call('/private/account/access_bulk_set.json', {
                account_id: accountId, user_ids: userIds,
                access: keys2app(permission, access_keys)}).then(() => true);
        }
        // XXX colin: remove the asmx path once back_app is on prod
        return new Promise((resolve,reject) => {
            fetchRequest(
                `${constConfig.url.API_URL + users_path}/SaveBulkAccountAccessPermissions`,
                'post',
                new URLSearchParams({ accountId: accountId.toString(),
                    userIds: JSON.stringify(userIds),
                    permission: JSON.stringify(permission)}).toString()
            )
                .then((response: any) => {
                    parseString(response, (err: any, result: any) => {
                        if (result) {
                            const res = JSON.parse(result.string._);

                            if (res.Success) {
                                resolve(true);
                            } else {
                                reject(res.ErrorMessage);
                                console.error('Error during saveBulkAccountAccessPermissions ErrorMessage:', res.ErrorMessage);
                            }
                        }
                    });
                })

                .catch((err) => {
                    reject(err);
                    console.log('saveBulkAccountAccessPermissions failed!!!', err);
                });
        });
    },
};

// was Services/todelete
export const ExplorerSchemaApi = {
    getExplorerSchemasList: () => {
        return new Promise((resolve) => {
            fetchRequest(
                `${constConfig.url.API_URL}/WebServices/ExplorerStructure.asmx/GetExplorerSchemasList`,
                'post',
                new URLSearchParams().toString()
            )
                .then((response: any) => {
                    parseString(response, (err: any, result: any) => {
                        if (result) {
                            const res = JSON.parse(result.string._);

                            if (res.Success) {
                                if (res.Response) {
                                    const responseData = JSON.parse(res.Response);
                                    resolve(responseData);
                                }
                            } else {
                                console.error('Error during getData ErrorMessage:', res.ErrorMessage);
                            }
                        }
                    });
                })

                .catch((err) => {
                    resolve(null);
                    console.log('GetExplorerSubjectsList failed!!!');
                });
        });
    },
    getExplorerSchemaItem: (schema_id: any) => {
        return new Promise((resolve) => {
            fetchRequest(
                `${constConfig.url.API_URL}/WebServices/ExplorerStructure.asmx/GetExplorerSchemaItem`,
                'post',
                new URLSearchParams({ schemaId: schema_id }).toString()
            )
                .then((response: any) => {
                    parseString(response, (err: any, result: any) => {
                        if (result) {
                            const res = JSON.parse(result.string._);

                            if (res.Success) {
                                if (res.Response) {
                                    const responseData = JSON.parse(res.Response);
                                    resolve(responseData);
                                }
                            } else {
                                console.error('Error during getData ErrorMessage:', res.ErrorMessage);
                            }
                        }
                    });
                })

                .catch((err) => {
                    resolve(null);
                    console.log('GetExplorerSubjectItem failed!!!', err);
                });
        });
    },
    saveExplorerSchema: (explorer_schema: any) => {
        console.log(explorer_schema);
        return new Promise((resolve) => {
            fetchRequest(
                `${constConfig.url.API_URL}/WebServices/ExplorerStructure.asmx/SaveExplorerSchema`,
                'post',
                new URLSearchParams({ explorerSchema: JSON.stringify(explorer_schema) }).toString()
            )
                .then((response: any) => {
                    parseString(response, (err: any, result: any) => {
                        if (result) {
                            const res = JSON.parse(result.string._);

                            if (res.Success) {
                                if (res.Response) {
                                    const responseData = JSON.parse(res.Response);
                                    resolve(responseData);
                                }
                            } else {
                                resolve(null);
                                console.error('Error during getData ErrorMessage:', res.ErrorMessage);
                            }
                        }
                    });
                })

                .catch((err) => {
                    resolve(null);
                    console.log('SaveExplorerSubject failed!!!', err);
                });
        });
    },
    deleteExplorerSchema: (schema_id: any) => {
        return new Promise((resolve) => {
            fetchRequest(
                `${constConfig.url.API_URL}/WebServices/ExplorerStructure.asmx/DeleteExplorerSchema`,
                'post',
                new URLSearchParams({ schemaId: schema_id }).toString()
            )
                .then((response: any) => {
                    parseString(response, (err: any, result: any) => {
                        if (result) {
                            const res = JSON.parse(result.string._);

                            if (res.Success) {
                                if (res.Response) {
                                    const responseData = JSON.parse(res.Response);
                                    resolve(responseData);
                                }
                            } else {
                                console.error('Error during getData ErrorMessage:', res.ErrorMessage);
                            }
                        }
                    });
                })

                .catch((err) => {
                    resolve(null);
                    console.log('DeleteExplorerSubject failed!!!', err);
                });
        });
    }
};
export const ExplorerTabApi = {
    getExplorerTabsList: (schema_id: any) => {
        return new Promise((resolve) => {
            fetchRequest(
                `${constConfig.url.API_URL}/WebServices/ExplorerStructure.asmx/GetExplorerTabsList`,
                'post',
                new URLSearchParams({ schemaId: schema_id }).toString()
            )
                .then((response: any) => {
                    parseString(response, (err: any, result: any) => {
                        if (result) {
                            const res = JSON.parse(result.string._);

                            if (res.Success) {
                                if (res.Response) {
                                    const responseData = JSON.parse(res.Response);
                                    resolve(responseData);
                                }
                            } else {
                                console.error('Error during getData ErrorMessage:', res.ErrorMessage);
                            }
                        }
                    });
                })

                .catch((err) => {
                    resolve(null);
                    console.log('GetExplorerTabsList failed!!!');
                });
        });
    },
    getExplorerTabItem: (id: any) => {
        return new Promise((resolve) => {
            fetchRequest(
                `${constConfig.url.API_URL}/WebServices/ExplorerStructure.asmx/GetExplorerTabItem`,
                'post',
                new URLSearchParams({ tab_id: id }).toString()
            )
                .then((response: any) => {
                    parseString(response, (err: any, result: any) => {
                        if (result) {
                            const res = JSON.parse(result.string._);

                            if (res.Success) {
                                if (res.Response) {
                                    const responseData = JSON.parse(res.Response);
                                    resolve(responseData);
                                }
                            } else {
                                console.error('Error during getData ErrorMessage:', res.ErrorMessage);
                            }
                        }
                    });
                })

                .catch((err) => {
                    resolve(null);
                    console.log('GetExplorerTabItem failed!!!', err);
                });
        });
    },
    saveExplorerTab: (explorerTab: any) => {
        return new Promise((resolve) => {
            fetchRequest(
                `${constConfig.url.API_URL}/WebServices/ExplorerStructure.asmx/SaveExplorerTab`,
                'post',
                new URLSearchParams({ explorer_tab: JSON.stringify(explorerTab) }).toString()
            )
                .then((response: any) => {
                    parseString(response, (err: any, result: any) => {
                        if (result) {
                            const res = JSON.parse(result.string._);

                            if (res.Success) {
                                if (res.Response) {
                                    const responseData = JSON.parse(res.Response);
                                    resolve(responseData);
                                }
                            } else {
                                console.error('Error during getData ErrorMessage:', res.ErrorMessage);
                            }
                        }
                    });
                })

                .catch((err) => {
                    resolve(null);
                    console.log('SaveExplorerTab failed!!!', err);
                });
        });
    },
    deleteExplorerTab: (id: any) => {
        return new Promise((resolve) => {
            fetchRequest(
                `${constConfig.url.API_URL}/WebServices/ExplorerStructure.asmx/DeleteExplorerTab`,
                'post',
                new URLSearchParams({ tab_id: id }).toString()
            )
                .then((response: any) => {
                    parseString(response, (err: any, result: any) => {
                        if (result) {
                            const res = JSON.parse(result.string._);

                            if (res.Success) {
                                if (res.Response) {
                                    const responseData = JSON.parse(res.Response);
                                    resolve(responseData);
                                }
                            } else {
                                console.error('Error during getData ErrorMessage:', res.ErrorMessage);
                            }
                        }
                    });
                })

                .catch((err) => {
                    resolve(null);
                    console.log('DeleteExplorerTab failed!!!', err);
                });
        });
    },
    setExplorerTabsListSortOrder: (schema_id: any, ids_new_order: number[]) => {
        console.log('setExplorerTabsListSortOrder');
        return new Promise((resolve) => {
            fetchRequest(
                `${constConfig.url.API_URL}/WebServices/ExplorerStructure.asmx/SetExplorerTabsListSortOrder`,
                'post',
                new URLSearchParams({ schemaId: schema_id, idsNewOrder: JSON.stringify(ids_new_order) }).toString()
            )
                .then((response: any) => {
                    parseString(response, (err: any, result: any) => {
                        if (result) {
                            const res = JSON.parse(result.string._);
                            resolve(res.Success);
                            if (res.Success) {
                                // if (res.Response) {
                                //     const responseData = JSON.parse(res.Response);
                                //     resolve(responseData);
                                // }
                            } else {
                                console.error('Error during setSort ErrorMessage:', res.ErrorMessage);
                            }
                        }
                    });
                })

                .catch((err) => {
                    resolve(null);
                    console.log('setExplorerTabsListSortOrder failed!!!', err);
                });
        });
    }
};
export const ExplorerSubjectApi = {
    getExplorerSubjectsList: (tabId: any) => {
        return new Promise((resolve) => {
            fetchRequest(
                `${constConfig.url.API_URL}/WebServices/ExplorerStructure.asmx/GetExplorerSubjectsList`,
                'post',
                new URLSearchParams({ tab_id: tabId }).toString()
            )
                .then((response: any) => {
                    parseString(response, (err: any, result: any) => {
                        if (result) {
                            const res = JSON.parse(result.string._);

                            if (res.Success) {
                                if (res.Response) {
                                    const responseData = JSON.parse(res.Response);
                                    resolve(responseData);
                                }
                            } else {
                                console.error('Error during getData ErrorMessage:', res.ErrorMessage);
                            }
                        }
                    });
                })

                .catch((err) => {
                    resolve(null);
                    console.log('GetExplorerSubjectsList failed!!!');
                });
        });
    },
    getExplorerSubjectItem: (id: any) => {
        return new Promise((resolve) => {
            fetchRequest(
                `${constConfig.url.API_URL}/WebServices/ExplorerStructure.asmx/GetExplorerSubjectItem`,
                'post',
                new URLSearchParams({ subject_id: id }).toString()
            )
                .then((response: any) => {
                    parseString(response, (err: any, result: any) => {
                        if (result) {
                            const res = JSON.parse(result.string._);

                            if (res.Success) {
                                if (res.Response) {
                                    const responseData = JSON.parse(res.Response);
                                    resolve(responseData);
                                }
                            } else {
                                console.error('Error during getData ErrorMessage:', res.ErrorMessage);
                            }
                        }
                    });
                })

                .catch((err) => {
                    resolve(null);
                    console.log('GetExplorerSubjectItem failed!!!', err);
                });
        });
    },
    saveExplorerSubject: (explorerSubject: any) => {
        return new Promise((resolve) => {
            fetchRequest(
                `${constConfig.url.API_URL}/WebServices/ExplorerStructure.asmx/SaveExplorerSubject`,
                'post',
                new URLSearchParams({ explorer_subject: JSON.stringify(explorerSubject) }).toString()
            )
                .then((response: any) => {
                    parseString(response, (err: any, result: any) => {
                        if (result) {
                            const res = JSON.parse(result.string._);

                            if (res.Success) {
                                if (res.Response) {
                                    const responseData = JSON.parse(res.Response);
                                    resolve(responseData);
                                }
                            } else {
                                console.error('Error during getData ErrorMessage:', res.ErrorMessage);
                            }
                        }
                    });
                })

                .catch((err) => {
                    resolve(null);
                    console.log('SaveExplorerSubject failed!!!', err);
                });
        });
    },
    deleteExplorerSubject: (id: any) => {
        return new Promise((resolve) => {
            fetchRequest(
                `${constConfig.url.API_URL}/WebServices/ExplorerStructure.asmx/DeleteExplorerSubject`,
                'post',
                new URLSearchParams({ subject_id: id }).toString()
            )
                .then((response: any) => {
                    parseString(response, (err: any, result: any) => {
                        if (result) {
                            const res = JSON.parse(result.string._);

                            if (res.Success) {
                                if (res.Response) {
                                    const responseData = JSON.parse(res.Response);
                                    resolve(responseData);
                                }
                            } else {
                                console.error('Error during getData ErrorMessage:', res.ErrorMessage);
                            }
                        }
                    });
                })

                .catch((err) => {
                    resolve(null);
                    console.log('DeleteExplorerSubject failed!!!', err);
                });
        });
    },
    setExplorerSubjectsListSortOrder: (tab_id: any, ids_new_order: number[]) => {
        
        return new Promise((resolve) => {
            fetchRequest(
                `${constConfig.url.API_URL}/WebServices/ExplorerStructure.asmx/SetExplorerSubjectsListSortOrder`,
                'post',
                new URLSearchParams({ tabId: tab_id, idsNewOrder: JSON.stringify(ids_new_order) }).toString()
            )
                .then((response: any) => {
                    parseString(response, (err: any, result: any) => {
                        if (result) {
                            const res = JSON.parse(result.string._);
                            resolve(res.Success);
                            if (res.Success) {
                                // if (res.Response) {
                                //     const responseData = JSON.parse(res.Response);
                                //     resolve(responseData);
                                // }
                            } else {
                                console.error('Error during setSort ErrorMessage:', res.ErrorMessage);
                            }
                        }
                    });
                })

                .catch((err) => {
                    resolve(null);
                    console.log('setExplorerTabsListSortOrder failed!!!', err);
                });
        });
    }
};

export const ExSubjectVariableApi = {
    getExSubjectVariablesList: (subjectId: any) => {
        return new Promise((resolve) => {
            fetchRequest(
                `${constConfig.url.API_URL}/WebServices/ExplorerStructure.asmx/GetExSubjectVariablesList`,
                'post',
                new URLSearchParams({ subject_id: subjectId }).toString()
            )
                .then((response: any) => {
                    parseString(response, (err: any, result: any) => {
                        if (result) {
                            const res = JSON.parse(result.string._);

                            if (res.Success) {
                                if (res.Response) {
                                    const responseData = JSON.parse(res.Response);
                                    resolve(responseData);
                                }
                            } else {
                                console.error('Error during getData ErrorMessage:', res.ErrorMessage);
                            }
                        }
                    });
                })

                .catch((err) => {
                    resolve(null);
                    console.log('GetExSubjectVariablesList failed!!!');
                });
        });
    },

    getExpSubjectVariableItem: (id: any) => {
        return new Promise((resolve) => {
            fetchRequest(
                `${constConfig.url.API_URL}/WebServices/ExplorerStructure.asmx/GetExSubjectVariableItem`,
                'post',
                new URLSearchParams({ subject_variable_id: id }).toString()
            )
                .then((response: any) => {
                    parseString(response, (err: any, result: any) => {
                        if (result) {
                            const res = JSON.parse(result.string._);

                            if (res.Success) {
                                if (res.Response) {
                                    const responseData = JSON.parse(res.Response);
                                    resolve(responseData);
                                }
                            } else {
                                console.error('Error during getData ErrorMessage:', res.ErrorMessage);
                            }
                        }
                    });
                })

                .catch((err) => {
                    resolve(null);
                    console.log('GetExSubjectVariableItem failed!!!', err);
                });
        });
    },
    saveExSubjectVariable: (subjectVariable: any) => {
        return new Promise((resolve) => {
            fetchRequest(
                `${constConfig.url.API_URL}/WebServices/ExplorerStructure.asmx/SaveExSubjectVariable`,
                'post',
                new URLSearchParams({ subject_variable: JSON.stringify(subjectVariable) }).toString()
            )
                .then((response: any) => {
                    parseString(response, (err: any, result: any) => {
                        if (result) {
                            const res = JSON.parse(result.string._);

                            if (res.Success) {
                                if (res.Response) {
                                    const responseData = JSON.parse(res.Response);
                                    resolve(responseData);
                                }
                            } else {
                                console.error('Error during getData ErrorMessage:', res.ErrorMessage);
                            }
                        }
                    });
                })

                .catch((err) => {
                    resolve(null);
                    console.log('SaveExSubjectVariable failed!!!', err);
                });
        });
    },

    deleteExSubjectVariable: (id: any) => {
        return new Promise((resolve) => {
            fetchRequest(
                `${constConfig.url.API_URL}/WebServices/ExplorerStructure.asmx/DeleteExSubjectVariable`,
                'post',
                new URLSearchParams({ subject_variable_id: id }).toString()
            )
                .then((response: any) => {
                    parseString(response, (err: any, result: any) => {
                        if (result) {
                            const res = JSON.parse(result.string._);

                            if (res.Success) {
                                if (res.Response) {
                                    const responseData = JSON.parse(res.Response);
                                    resolve(responseData);
                                }
                            } else {
                                console.error('Error during getData ErrorMessage:', res.ErrorMessage);
                            }
                        }
                    });
                })

                .catch((err) => {
                    resolve(null);
                    console.log('DeleteExSubjectVariable failed!!!', err);
                });
        });
    },
    setExSubjectVariablesListSortOrder: (subject_id: any, ids_new_order: number[]) => {
        
        return new Promise((resolve) => {
            fetchRequest(
                `${constConfig.url.API_URL}/WebServices/ExplorerStructure.asmx/SetExSubjectVariablesListSortOrder`,
                'post',
                new URLSearchParams({ subjectId: subject_id, idsNewOrder: JSON.stringify(ids_new_order) }).toString()
            )
                .then((response: any) => {
                    parseString(response, (err: any, result: any) => {
                        if (result) {
                            const res = JSON.parse(result.string._);
                            resolve(res.Success);
                            if (res.Success) {
                                // if (res.Response) {
                                //     const responseData = JSON.parse(res.Response);
                                //     resolve(responseData);
                                // }
                            } else {
                                console.error('Error during setSort ErrorMessage:', res.ErrorMessage);
                            }
                        }
                    });
                })

                .catch((err) => {
                    resolve(null);
                    console.log('setExplorerTabsListSortOrder failed!!!', err);
                });
        });
    }
};

export const JobApi = {
    getJobsList: () => {
        return new Promise((resolve) => {
            fetchRequest(`${constConfig.url.API_URL}/WebServices/Jobs.asmx/GetJobsList`, 'post', new URLSearchParams({}).toString())
                .then((response: any) => {
                    parseString(response, (err: any, result: any) => {
                        if (result) {
                            const res = JSON.parse(result.string._);

                            if (res.Success) {
                                if (res.Response) {
                                    const responseData = JSON.parse(res.Response);
                                    resolve(responseData);
                                }
                            } else {
                                
                                console.error('Error during getData ErrorMessage:', res.ErrorMessage);
                            }
                        }
                    });
                })

                .catch((err) => {
                    resolve(null);
                    console.log('GetJobsList failed!!!');
                });
        });
    },
    getJobsLocationList: () => {
        return new Promise((resolve) => {
            fetchRequest(`${constConfig.url.API_URL}/WebServices/Jobs.asmx/GetJobsLocationList`, 'post', new URLSearchParams({}).toString())
                .then((response: any) => {
                    parseString(response, (err: any, result: any) => {
                        if (result) {
                            const res = JSON.parse(result.string._);

                            if (res.Success) {
                                if (res.Response) {
                                    const responseData = JSON.parse(res.Response);
                                    resolve(responseData);
                                }
                            } else {
                                console.error('Error during getData ErrorMessage:', res.ErrorMessage);
                            }
                        }
                    });
                })

                .catch((err) => {
                    resolve(null);
                    console.log('GetJobsList failed!!!');
                });
        });
    },
    getJobsListByManufacturer: (manufacturer_id: number) => {
        return new Promise((resolve) => {
            fetchRequest(
                `${constConfig.url.API_URL}/WebServices/Jobs.asmx/GetJobsListByManufacturer`,
                'post',
                new URLSearchParams({ manufacturerId: manufacturer_id.toString() }).toString()
            )
                .then((response: any) => {
                    parseString(response, (err: any, result: any) => {
                        if (result) {
                            const res = JSON.parse(result.string._);

                            if (res.Success) {
                                if (res.Response) {
                                    const responseData = JSON.parse(res.Response);
                                    resolve(responseData);
                                }
                            } else {
                                console.error('Error during getData ErrorMessage:', res.ErrorMessage);
                            }
                        }
                    });
                })

                .catch((err) => {
                    resolve(null);
                    console.log('GetJobsListByManufacturer failed!!!');
                });
        });
    },
    getJobDetails: (job_id: any) => {
        // GetJobDetails(int jobId
        return new Promise((resolve) => {
            fetchRequest(
                `${constConfig.url.API_URL}/WebServices/Jobs.asmx/GetJobDetails`,
                'post',
                new URLSearchParams({ jobId: job_id }).toString()
            )
                .then((response: any) => {
                    parseString(response, (err: any, result: any) => {
                        if (result) {
                            const res = JSON.parse(result.string._);

                            if (res.Success) {
                                if (res.Response) {
                                    const responseData = JSON.parse(res.Response);
                                    resolve(responseData);
                                }
                            } else {
                                console.error('Error during getData ErrorMessage:', res.ErrorMessage);
                            }
                        }
                    });
                })

                .catch((err) => {
                    resolve(null);
                    console.log('GetJobsList failed!!!');
                });
        });
    },
    getJobExplorerData: (
        job_id: any,
        tab_id: any,
        transaction_id: any,
        transaction_id_compare_type: CompareType,
        transaction_date: any
    ) => {
        // GetJobExplorerData(int jobId, int transactionId, string fromDate, string toDate)
        return new Promise((resolve) => {
            fetchRequest(
                `${constConfig.url.API_URL}/WebServices/Jobs.asmx/GetJobExplorerData`,
                'post',
                new URLSearchParams({
                    jobId: job_id,
                    tabId: tab_id,
                    transactionId: transaction_id || 0,
                    transactionIdCompareType: transaction_id_compare_type.toString(),
                    transactionDate: transaction_date
                }).toString()
            )
                .then((response: any) => {
                    parseString(response, (err: any, result: any) => {
                        if (result) {
                            const res = JSON.parse(result.string._);

                            if (res.Success) {
                                if (res.Response) {
                                    const responseData = JSON.parse(res.Response);
                                    resolve(responseData);
                                }
                            } else {
                                console.error('Error during getData ErrorMessage:', res.ErrorMessage);
                            }
                        }
                    });
                })

                .catch((err) => {
                    resolve(null);
                    console.log('GetJobsList failed!!!');
                });
        });
    },
    getJobExplorerLatestData: (
        job_id: any,
        tab_id: any,
        transaction_date_compare_type: CompareType,
        transaction_date: any
    ) => {
        // GetJobExplorerLatestDataByDate(int jobId, int tabId, Helper.CompareType transactionDateCompareType, string transactionDate)
        return new Promise((resolve) => {
            fetchRequest(
                `${constConfig.url.API_URL}/WebServices/Jobs.asmx/GetJobExplorerLatestDataByDate`,
                'post',
                new URLSearchParams({
                    jobId: job_id,
                    tabId: tab_id,
                    transactionDateCompareType: transaction_date_compare_type.toString(),
                    transactionDate: transaction_date
                }).toString()
            )
                .then((response: any) => {
                    parseString(response, (err: any, result: any) => {
                        if (result) {
                            const res = JSON.parse(result.string._);

                            if (res.Success) {
                                if (res.Response) {
                                    const responseData = JSON.parse(res.Response);
                                    resolve(responseData);
                                } else{
                                    resolve(null);
                                }
                            } else {
                                console.error('Error during getData ErrorMessage:', res.ErrorMessage);
                            }
                        }
                    });
                })

                .catch((err) => {
                    resolve(null);
                    console.log('getJobExplorerLatestData failed!!!');
                });
        });
    },
    getJobStaticExplorerData: (job_id: any, transaction_id: any, transaction_id_compare_type: CompareType, transaction_date: any) => {
        // GetJobExplorerData(int jobId, int transactionId, string fromDate, string toDate)
        return new Promise((resolve) => {
            fetchRequest(
                `${constConfig.url.API_URL}/WebServices/Jobs.asmx/GetJobStaticExplorerData`,
                'post',
                new URLSearchParams({
                    jobId: job_id,
                    transactionId: transaction_id || 0,
                    transactionIdCompareType: transaction_id_compare_type.toString(),
                    transactionDate: transaction_date
                }).toString()
            )
                .then((response: any) => {
                    parseString(response, (err: any, result: any) => {
                        if (result) {
                            const res = JSON.parse(result.string._);

                            if (res.Success) {
                                if (res.Response) {
                                    const responseData = JSON.parse(res.Response);
                                    resolve(responseData);
                                }
                            } else {
                                console.error('Error during getData ErrorMessage:', res.ErrorMessage);
                            }
                        }
                    });
                })

                .catch((err) => {
                    resolve(null);
                    console.log('GetJobsList failed!!!');
                });
        });
    },
    getJobStaticData: (job_id: any) => {
        // GetJobExplorerData(int jobId, int transactionId, string fromDate, string toDate)
        return new Promise((resolve) => {
            fetchRequest(
                `${constConfig.url.API_URL}/WebServices/Jobs.asmx/GetJobStaticData`,
                'post',
                new URLSearchParams({
                    jobId: job_id
                }).toString()
            )
                .then((response: any) => {
                    parseString(response, (err: any, result: any) => {
                        if (result) {
                            const res = JSON.parse(result.string._);

                            if (res.Success) {
                                if (res.Response) {
                                    const responseData = JSON.parse(res.Response);
                                    resolve(responseData);
                                }
                            } else {
                                console.error('Error during getData ErrorMessage:', res.ErrorMessage);
                            }
                        }
                    });
                })

                .catch((err) => {
                    resolve(null);
                    console.log('GetJobsList failed!!!');
                });
        });
    },
    getJobExplorerSubjects: (job_id: any, tab_id: any) => {
        // GetJobDetails(int jobId
        return new Promise((resolve) => {
            fetchRequest(
                `${constConfig.url.API_URL}/WebServices/Jobs.asmx/GetJobExplorerSubjects`,
                'post',
                new URLSearchParams({ jobId: job_id, tabId: tab_id }).toString()
            )
                .then((response: any) => {
                    parseString(response, (err: any, result: any) => {
                        if (result) {
                            const res = JSON.parse(result.string._);

                            if (res.Success) {
                                if (res.Response) {
                                    const responseData = JSON.parse(res.Response);
                                    resolve(responseData);
                                }
                            } else {
                                console.error('Error during getData ErrorMessage:', res.ErrorMessage);
                            }
                        }
                    });
                })

                .catch((err) => {
                    resolve(null);
                    console.log('GetJobsList failed!!!');
                });
        });
    },
    getJobStaticExplorerSubjects: (job_id: any) => {
        // GetJobDetails(int jobId
        return new Promise((resolve) => {
            fetchRequest(
                `${constConfig.url.API_URL}/WebServices/Jobs.asmx/GetJobStaticExplorerSubjects`,
                'post',
                new URLSearchParams({ jobId: job_id }).toString()
            )
                .then((response: any) => {
                    parseString(response, (err: any, result: any) => {
                        if (result) {
                            const res = JSON.parse(result.string._);

                            if (res.Success) {
                                if (res.Response) {
                                    const responseData = JSON.parse(res.Response);
                                    resolve(responseData);
                                }
                            } else {
                                console.error('Error during getData ErrorMessage:', res.ErrorMessage);
                            }
                        }
                    });
                })

                .catch((err) => {
                    resolve(null);
                    console.log('GetJobsList failed!!!');
                });
        });
    },
    getJobFaultLog: (job_id: any, from_date: any, to_date: any) => {
        return new Promise((resolve) => {
            fetchRequest(
                `${constConfig.url.API_URL}/WebServices/Jobs.asmx/GetJobFaultLog`,
                'post',
                new URLSearchParams({ jobId: job_id, fromDate: from_date, toDate: to_date }).toString()
            )
                .then((response: any) => {
                    parseString(response, (err: any, result: any) => {
                        if (result) {
                            const res = JSON.parse(result.string._);

                            if (res.Success) {
                                if (res.Response) {
                                    const responseData = JSON.parse(res.Response);
                                    resolve(responseData);
                                }
                            } else {
                                console.error('Error during getData ErrorMessage:', res.ErrorMessage);
                            }
                        }
                    });
                })

                .catch((err) => {
                    resolve(null);
                    console.log('GetJobsList failed!!!');
                });
        });
    }
};
export const JobMaintApi = {
    getJobGeneralInformation: (job_id: any) => {
        return new Promise((resolve) => {
            fetchRequest(
                `${constConfig.url.API_URL}/WebServices/Jobs.asmx/GetJobGeneralInformation`,
                'post',
                new URLSearchParams({ jobId: job_id }).toString()
            )
                .then((response: any) => {
                    parseString(response, (err: any, result: any) => {
                        if (result) {
                            const res = JSON.parse(result.string._);

                            if (res.Success) {
                                if (res.Response) {
                                    const responseData = JSON.parse(res.Response);
                                    resolve(responseData);
                                }
                            } else {
                                console.error('Error during getData ErrorMessage:', res.ErrorMessage);
                            }
                        }
                    });
                })

                .catch((err) => {
                    resolve(null);
                    console.log('GetJobsList failed!!!');
                });
        });
    },
    saveJobGeneralInformation: (job_general_info: any) => {
        return new Promise((resolve) => {
            fetchRequest(
                `${constConfig.url.API_URL}/WebServices/Jobs.asmx/SaveJobGeneralInformation`,
                'post',
                new URLSearchParams({ jobGeneralInfo: JSON.stringify(job_general_info) }).toString()
            )
                .then((response: any) => {
                    parseString(response, (err: any, result: any) => {
                        if (result) {
                            const res = JSON.parse(result.string._);
                            resolve(res);
                            if (!res.Success) {
                                console.error('Error during getData ErrorMessage:', res.ErrorMessage);
                            }
                        }
                    });
                })

                .catch((err) => {
                    resolve(null);
                    console.log('GetJobsList failed!!!');
                });
        });
    },
    getJobClientInformation: (job_id: any) => {
        return new Promise((resolve) => {
            fetchRequest(
                `${constConfig.url.API_URL}/WebServices/Jobs.asmx/GetJobClientInformation`,
                'post',
                new URLSearchParams({ jobId: job_id }).toString()
            )
                .then((response: any) => {
                    parseString(response, (err: any, result: any) => {
                        if (result) {
                            const res = JSON.parse(result.string._);

                            if (res.Success) {
                                if (res.Response) {
                                    const responseData = JSON.parse(res.Response);
                                    resolve(responseData);
                                }
                            } else {
                                console.error('Error during getData ErrorMessage:', res.ErrorMessage);
                            }
                        }
                    });
                })

                .catch((err) => {
                    resolve(null);
                    console.log('GetJobsList failed!!!');
                });
        });
    },
    saveJobClientInformation: (job_id: any, job_client_info: any) => {
        return new Promise((resolve) => {
            fetchRequest(
                `${constConfig.url.API_URL}/WebServices/Jobs.asmx/SaveJobClientInformation`,
                'post',
                new URLSearchParams({ jobId: job_id, jobClientInfo: JSON.stringify(job_client_info) }).toString()
            )
                .then((response: any) => {
                    parseString(response, (err: any, result: any) => {
                        if (result) {
                            const res = JSON.parse(result.string._);

                            if (res.Success) {
                                if (res.Response) {
                                    const responseData = JSON.parse(res.Response);
                                    resolve(responseData);
                                }
                            } else {
                                console.error('Error during getData ErrorMessage:', res.ErrorMessage);
                            }
                        }
                    });
                })

                .catch((err) => {
                    resolve(null);
                    console.log('GetJobsList failed!!!');
                });
        });
    },
    deleteJob: (job_id: any) => {
        return new Promise((resolve) => {
            fetchRequest(`${constConfig.url.API_URL}/WebServices/Jobs.asmx/DeleteJob`, 'post', new URLSearchParams({ jobId: job_id }).toString())
                .then((response: any) => {
                    parseString(response, (err: any, result: any) => {
                        if (result) {
                            const res = JSON.parse(result.string._);

                            if (res.Success) {
                                if (res.Response) {
                                    const responseData = JSON.parse(res.Response);
                                    resolve(responseData);
                                }
                            } else {
                                console.error('Error during getData ErrorMessage:', res.ErrorMessage);
                            }
                        }
                    });
                })

                .catch((err) => {
                    resolve(null);
                    console.log('GetJobsList failed!!!');
                });
        });
    },
    getJobDocs: (job_id: any, file_type: any) => {
        return new Promise((resolve) => {
            fetchRequest(
                `${constConfig.url.API_URL}/WebServices/Jobs.asmx/GetJobDocs`,
                'post',
                new URLSearchParams({ jobId: job_id, fileType: file_type }).toString()
            )
                .then((response: any) => {
                    parseString(response, (err: any, result: any) => {
                        if (result) {
                            const res = JSON.parse(result.string._);

                            if (res.Success) {
                                if (res.Response) {
                                    const responseData = JSON.parse(res.Response);
                                    resolve(responseData);
                                }
                            } else {
                                console.error('Error during getData ErrorMessage:', res.ErrorMessage);
                            }
                        }
                    });
                })

                .catch((err) => {
                    resolve(null);
                    console.log('GetJobsList failed!!!');
                });
        });
    },
    saveJobDocs: (job_id: any, file_type: any, file_path: any, file_name: any, file_size: any, file_desc?: any) => {
        return new Promise((resolve) => {
            fetchRequest(
                `${constConfig.url.API_URL}/WebServices/Jobs.asmx/SaveJobDocs`,
                'post',
                new URLSearchParams({
                    jobId: job_id,
                    fileType: file_type,
                    filePath: file_path,
                    fileName: file_name,
                    size: file_size,
                    fileDesc: file_desc || ''
                }).toString()
            )
                .then((response: any) => {
                    parseString(response, (err: any, result: any) => {
                        if (result) {
                            const res = JSON.parse(result.string._);

                            if (res.Success) {
                                if (res.Response) {
                                    const responseData = JSON.parse(res.Response);
                                    resolve(responseData);
                                }
                            } else {
                                console.error('Error during getData ErrorMessage:', res.ErrorMessage);
                            }
                        }
                    });
                })

                .catch((err) => {
                    resolve(null);
                    console.log('GetJobsList failed!!!');
                });
        });
    },
    saveJobDocs_base64: (job_id: any, file_type: any, file_base: any, file_name: any, file_size: any, file_desc?: any) => {
        return new Promise((resolve) => {
            fetchRequest(
                `${constConfig.url.API_URL}/WebServices/Jobs.asmx/SaveJobDocs_base64`,
                'post',
                new URLSearchParams({
                    jobId: job_id,
                    fileType: file_type,
                    fileBase64: file_base,
                    fileName: file_name,
                    size: file_size,
                    fileDesc: file_desc || ''
                }).toString()
            )
                .then((response: any) => {
                    parseString(response, (err: any, result: any) => {
                        if (result) {
                            const res = JSON.parse(result.string._);
                            resolve(res);
                            if (!res.Success) {
                                console.error('Error during getData ErrorMessage:', res.ErrorMessage);
                            }
                        }
                    });
                })

                .catch((err) => {
                    resolve(null);
                    console.log('GetJobsList failed!!!');
                });
        });
    },

    updateJobDocDesc: (job_doc_id: any, file_desc: any) => {

        return new Promise((resolve) => {
            fetchRequest(
                `${constConfig.url.API_URL}/WebServices/Jobs.asmx/UpdateJobDocDesc`,
                'post',
                new URLSearchParams({
                    jobDocId: job_doc_id,
                    fileDesc: file_desc || ''
                }).toString()
            )
                .then((response: any) => {
                    console.log(response);
                    parseString(response, (err: any, result: any) => {
                       
                        if (result) {
                            const res = JSON.parse(result.string._);
                            resolve(res.Success);
                            if (!res.Success) {
                                console.error('Error during getData ErrorMessage:', res.ErrorMessage);
                            }
                        }
                    });
                })

                .catch((err) => {
                    resolve(null);
                    console.log('GetJobsList failed!!!');
                });
        });
    },
 
    deleteJobDocs: (job_id: any, file_type: any, file_id: any) => {
        return new Promise((resolve) => {
            fetchRequest(
                `${constConfig.url.API_URL}/WebServices/Jobs.asmx/DeleteJobDocs`,
                'post',
                new URLSearchParams({ jobId: job_id, fileType: file_type, fileId: file_id }).toString()
            )
                .then((response: any) => {
                    parseString(response, (err: any, result: any) => {
                        if (result) {
                            const res = JSON.parse(result.string._);

                            if (res.Success) {
                                if (res.Response) {
                                    const responseData = JSON.parse(res.Response);
                                    resolve(responseData);
                                }
                            } else {
                                console.error('Error during getData ErrorMessage:', res.ErrorMessage);
                            }
                        }
                    });
                })

                .catch((err) => {
                    resolve(null);
                    console.log('GetJobsList failed!!!');
                });
        });
    }
};
export const JobStatApi = {
    getJobsStatusByModels: (manufacturer_id: any, model_id: any, dealer_id: any) => {
        return new Promise((resolve) => {
            fetchRequest(
                `${constConfig.url.API_URL}/WebServices/JobStats.asmx/GetJobsStatusByModels`,
                'post',
                new URLSearchParams({
                    manufacturerId: manufacturer_id,
                    modelId: model_id,
                    dealerId: dealer_id
                }).toString()
            )
                .then((response: any) => {
                    parseString(response, (err: any, result: any) => {
                        if (result) {
                            const res = JSON.parse(result.string._);

                            if (res.Success) {
                                if (res.Response) {
                                    const responseData = JSON.parse(res.Response);
                                    resolve(responseData);
                                }
                            } else {
                                console.error('Error during getData ErrorMessage:', res.ErrorMessage);
                            }
                        }
                    });
                })

                .catch((err) => {
                    resolve(null);
                    console.log('getJobsStatusByModels failed!!!');
                });
        });
    },
    getJobsStatusByDealers: (manufacturer_id: any, model_id: any, dealer_id: any) => {
        return new Promise((resolve) => {
            fetchRequest(
                `${constConfig.url.API_URL}/WebServices/JobStats.asmx/GetJobsStatusByDealers`,
                'post',
                new URLSearchParams({
                    manufacturerId: manufacturer_id,
                    modelId: model_id,
                    dealerId: dealer_id
                }).toString()
            )
                .then((response: any) => {
                    parseString(response, (err: any, result: any) => {
                        if (result) {
                            const res = JSON.parse(result.string._);

                            if (res.Success) {
                                if (res.Response) {
                                    const responseData = JSON.parse(res.Response);
                                    resolve(responseData);
                                }
                            } else {
                                console.error('Error during getData ErrorMessage:', res.ErrorMessage);
                            }
                        }
                    });
                })

                .catch((err) => {
                    resolve(null);
                    console.log('getJobsStatusByDealers failed!!!');
                });
        });
    },
    getJobFaultsSummary: (fault_type: any, manufacturer_id: any, model_id: any, dealer_id: any, from_date: any, to_date: any) => {
        // GetJobDetails(int jobId
        return new Promise((resolve) => {
            fetchRequest(
                `${constConfig.url.API_URL}/WebServices/JobStats.asmx/GetJobFaultsSummary`,
                'post',
                new URLSearchParams({
                    faultType: fault_type,
                    manufacturerId: manufacturer_id,
                    modelId: model_id,
                    dealerId: dealer_id,
                    fromDate: from_date,
                    toDate: to_date
                }).toString()
            )
                .then((response: any) => {
                    parseString(response, (err: any, result: any) => {
                        if (result) {
                            const res = JSON.parse(result.string._);

                            if (res.Success) {
                                if (res.Response) {
                                    const responseData = JSON.parse(res.Response);
                                    resolve(responseData);
                                }
                            } else {
                                console.error('Error during getData ErrorMessage:', res.ErrorMessage);
                            }
                        }
                    });
                })

                .catch((err) => {
                    resolve(null);
                    console.log('getJobFaultsSummary failed!!!');
                });
        });
    },
    getJobsStatusSummary: (manufacturer_id: any, model_id: any, dealer_id: any) => {
        // GetJobExplorerData(int jobId, int transactionId, string fromDate, string toDate)
        return new Promise((resolve) => {
            fetchRequest(
                `${constConfig.url.API_URL}/WebServices/JobStats.asmx/GetJobsStatusSummary`,
                'post',
                new URLSearchParams({
                    manufacturerId: manufacturer_id,
                    modelId: model_id,
                    dealerId: dealer_id
                }).toString()
            )
                .then((response: any) => {
                    parseString(response, (err: any, result: any) => {
                        if (result) {
                            const res = JSON.parse(result.string._);

                            if (res.Success) {
                                if (res.Response) {
                                    const responseData = JSON.parse(res.Response);
                                    resolve(responseData);
                                }
                            } else {
                                console.error('Error during getData ErrorMessage:', res.ErrorMessage);
                            }
                        }
                    });
                })

                .catch((err) => {
                    resolve(null);
                    console.log('getJobsStatusSummary failed!!!');
                });
        });
    },
    getJobsLocations: (manufacturer_id: any, model_id: any, dealer_id: any) => {
        // GetJobExplorerData(int jobId, int transactionId, string fromDate, string toDate)
        return new Promise((resolve) => {
            fetchRequest(
                `${constConfig.url.API_URL}/WebServices/JobStats.asmx/getJobsLocations`,
                'post',
                new URLSearchParams({
                    manufacturerId: manufacturer_id,
                    modelId: model_id,
                    dealerId: dealer_id
                }).toString()
            )
                .then((response: any) => {
                    parseString(response, (err: any, result: any) => {
                        if (result) {
                            const res = JSON.parse(result.string._);

                            if (res.Success) {
                                if (res.Response) {
                                    const responseData = JSON.parse(res.Response);
                                    resolve(responseData);
                                }
                            } else {
                                console.error('Error during getData ErrorMessage:', res.ErrorMessage);
                            }
                        }
                    });
                })

                .catch((err) => {
                    resolve(null);
                    console.log('getJobsLocations failed!!!');
                });
        });
    }
};

export const ShadowsApi = {
    getShadowsList: () => {
        return new Promise((resolve) => {
            fetchRequest(`${constConfig.url.API_URL}/WebServices/ShadowsService.asmx/GetShadowsList`, 'post', new URLSearchParams({}).toString())
                .then((response: any) => {
                    parseString(response, (err: any, result: any) => {
                        if (result) {
                            const res = JSON.parse(result.string._);

                            if (res.Success) {
                                if (res.Response) {
                                    const responseData = JSON.parse(res.Response);
                                    resolve(responseData);
                                }
                            } else {
                                console.error('Error during getData ErrorMessage:', res.ErrorMessage);
                            }
                        }
                    });
                })

                .catch((err) => {
                    resolve(null);
                    console.log('GetShadowsList failed!!!');
                });
        });
    },
    getShadowsListByThing: (thing_id:number) => {
        return new Promise((resolve) => {
            fetchRequest(`${constConfig.url.API_URL}/WebServices/ShadowsService.asmx/GetShadowsListByThing`, 'post', 
            new URLSearchParams({thingId: thing_id.toString()}).toString())
                .then((response: any) => {
                    parseString(response, (err: any, result: any) => {
                        if (result) {
                            const res = JSON.parse(result.string._);

                            if (res.Success) {
                                if (res.Response) {
                                    const responseData = JSON.parse(res.Response);
                                    resolve(responseData);
                                }
                            } else {
                                console.error('Error during getData ErrorMessage:', res.ErrorMessage);
                            }
                        }
                    });
                })

                .catch((err) => {
                    resolve(null);
                    console.log('GetShadowsListByThing failed!!!');
                });
        });
    },
    getShadowInfo: (id: any) => {
        return new Promise((resolve) => {
            fetchRequest(
                `${constConfig.url.API_URL}/WebServices/ShadowsService.asmx/GetShadowInfo`,
                'post',
                new URLSearchParams({ shadow_id: id }).toString()
            )
                .then((response: any) => {
                    parseString(response, (err: any, result: any) => {
                        if (result) {
                            const res = JSON.parse(result.string._);

                            if (res.Success) {
                                if (res.Response) {
                                    const responseData = JSON.parse(res.Response);
                                    resolve(responseData);
                                }
                            } else {
                                console.error('Error during getData ErrorMessage:', res.ErrorMessage);
                            }
                        }
                    });
                })

                .catch((err) => {
                    resolve(null);
                    console.log('getShadowInfo failed!!!', err);
                });
        });
    },

    saveShadow: (shadow: any) => {
        return new Promise((resolve) => {
            fetchRequest(
                `${constConfig.url.API_URL}/WebServices/ShadowsService.asmx/SaveShadow`,
                'post',
                new URLSearchParams({ shadow: JSON.stringify(shadow) }).toString()
            )
                .then((response: any) => {
                    parseString(response, (err: any, result: any) => {
                        if (result) {
                            const res = JSON.parse(result.string._);

                            if (res.Success) {
                                if (res.Response) {
                                    const responseData = JSON.parse(res.Response);
                                    resolve(responseData);
                                }
                            } else {
                                console.error('Error during getData ErrorMessage:', res.ErrorMessage);
                                resolve(res.ErrorMessage);
                            }
                        }
                    });
                })
                .catch((err) => {
                    resolve(null);
                    console.log('saveShadow failed!!!', err);
                });
        });
    },

    deleteShadow: (id: any) => {
        return new Promise((resolve) => {
            fetchRequest(
                `${constConfig.url.API_URL}/WebServices/ShadowsService.asmx/DeleteShadow`,
                'post',
                new URLSearchParams({ shadow_id: id }).toString()
            )
                .then((response: any) => {
                    parseString(response, (err: any, result: any) => {
                        if (result) {
                            const res = JSON.parse(result.string._);

                            if (res.Success) {
                                if (res.Response) {
                                    const responseData = JSON.parse(res.Response);
                                    resolve(responseData);
                                }
                            } else {
                                console.error('Error during getData ErrorMessage:', res.ErrorMessage);
                            }
                        }
                    });
                })

                .catch((err) => {
                    resolve(null);
                    console.log('deleteShadow failed!!!', err);
                });
        });
    }
};

export const ThingsApi = {
    getThingsList: () => {
        return new Promise((resolve) => {
            fetchRequest(`${constConfig.url.API_URL}/WebServices/ThingsService.asmx/GetThingsList`, 'post', new URLSearchParams({}).toString())
                .then((response: any) => {
                    parseString(response, (err: any, result: any) => {
                        if (result) {
                            const res = JSON.parse(result.string._);

                            if (res.Success) {
                                if (res.Response) {
                                    const responseData = JSON.parse(res.Response);
                                    resolve(responseData);
                                }
                            } else {
                                console.error('Error during getData ErrorMessage:', res.ErrorMessage);
                            }
                        }
                    });
                })

                .catch((err) => {
                    resolve(null);
                    console.log('GetThingsList failed!!!');
                });
        });
    },
    
    getAvailableThingsListByJobId: (jobId: any) => {
        return new Promise((resolve) => {
            fetchRequest(`${constConfig.url.API_URL}/WebServices/ThingsService.asmx/GetAvailableThingsListByJobId`, 'post', new URLSearchParams({job_id: jobId}).toString())
                .then((response: any) => {
                    parseString(response, (err: any, result: any) => {
                        if (result) {
                            const res = JSON.parse(result.string._);

                            if (res.Success) {
                                if (res.Response) {
                                    const responseData = JSON.parse(res.Response);
                                    resolve(responseData);
                                }
                            } else {
                                console.error('Error during getAvailableThingsListByJobId ErrorMessage:', res.ErrorMessage);
                            }
                        }
                    });
                })

                .catch((err) => {
                    resolve(null);
                    console.log('getAvailableThingsListByJobId failed!!!');
                });
        });
    },
    getThingInfo: (id: any) => {
        return new Promise((resolve) => {
            fetchRequest(
                `${constConfig.url.API_URL}/WebServices/ThingsService.asmx/GetThingInfo`,
                'post',
                new URLSearchParams({ thing_id: id }).toString()
            )
                .then((response: any) => {
                    parseString(response, (err: any, result: any) => {
                        if (result) {
                            const res = JSON.parse(result.string._);

                            if (res.Success) {
                                if (res.Response) {
                                    const responseData = JSON.parse(res.Response);
                                    resolve(responseData);
                                }
                            } else {
                                console.error('Error during getData ErrorMessage:', res.ErrorMessage);
                            }
                        }
                    });
                })

                .catch((err) => {
                    resolve(null);
                    console.log('GetThingInfo failed!!!', err);
                });
        });
    },

    saveThing: (thing: any) => {
        return new Promise((resolve) => {
            fetchRequest(
                `${constConfig.url.API_URL}/WebServices/ThingsService.asmx/SaveThing`,
                'post',
                new URLSearchParams({ thing: JSON.stringify(thing) }).toString()
            )
                .then((response: any) => {
                    parseString(response, (err: any, result: any) => {
                        if (result) {
                            const res = JSON.parse(result.string._);

                            if (res.Success) {
                                if (res.Response) {
                                    const responseData = JSON.parse(res.Response);
                                    resolve(responseData);
                                }
                            } else {
                                console.error('Error during getData ErrorMessage:', res.ErrorMessage);
                                resolve(res.ErrorMessage);
                            }
                        }
                    });
                })
                .catch((err) => {
                    resolve(null);
                    console.log('SaveThing failed!!!', err);
                });
        });
    },

    deleteThing: (id: any) => {
        return new Promise((resolve) => {
            fetchRequest(
                `${constConfig.url.API_URL}/WebServices/ThingsService.asmx/DeleteThing`,
                'post',
                new URLSearchParams({ thing_id: id }).toString()
            )
                .then((response: any) => {
                    parseString(response, (err: any, result: any) => {
                        if (result) {
                            const res = JSON.parse(result.string._);

                            if (res.Success) {
                                if (res.Response) {
                                    const responseData = JSON.parse(res.Response);
                                    resolve(responseData);
                                }
                            } else {
                                console.error('Error during getData ErrorMessage:', res.ErrorMessage);
                            }
                        }
                    });
                })

                .catch((err) => {
                    resolve(null);
                    console.log('DeleteThing failed!!!', err);
                });
        });
    }
};
